const customizationMain = document.querySelector('.flask-customization-main');
const defaultCapType = customizationMain.getAttribute('data-cap-type');

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function (e) {
    if(e.target.classList.contains('ocf--back')){
      onBoardingPreviousSlide(e.target.dataset.step);
    }
    if(e.target.classList.contains('ocf--next')){
      onBoardingNextSlide(e.target.dataset.step);
    }
    if(e.target.classList.contains('onboarding_close')){

      document.querySelector('.onboarding-section').classList.add('closed');
      document.querySelectorAll('.onboarding_content').forEach(function (oc) { oc.classList.remove('active') })
      localStorage.setItem('flaskOnboarding', 'hide');
      stopOnboardingVideo();
      
      setTimeout(function(){
        closeOnboarding();

      }, 100);
    }
  });
});

let clickFromMainRadios = false;
let swiperInitialized = false;

let bottleIndividualVariantID = '';
let bottleBundleVariantID = '';

let bottleIndividualVariantID32oz = ''
let bottleBundleVariantID32oz = '';

let bottleIndividualVariantID30oz = ''
let bottleBundleVariantID30oz = '';

let loopBundleVariantID = '';
let loopIndividualVariantID = '';

let capBundleVariantID = '';
let capIndividualVariantID = '';

let bootVariantID = '';
let bootVariantID32oz = '';

let engravingValue = '';
let engravingPlacement = 'bottom';
let engravingColor = '';

let engravingOrientation = 'horizontal';
let engravingFont = 'Replica';

let chosenMainColor = document.querySelector('variant-radios fieldset.swatch input[checked]').dataset.handleName;

let bottleSizeOption = document.querySelector('.flask-customization-main').getAttribute('data-size');
const defaultSize = document.querySelectorAll('fieldset#size input[type="radio"]').length > 1 ? document.querySelector('.flask-customization-main').getAttribute('data-size') : document.querySelectorAll('fieldset#size input[type="radio"]')[0].value;

let totalPrice = 0;
let bundlePrice = bottleSizeOption == '25oz' || bottleSizeOption == '16oz' ? 30 : 35;
let loopPrice = 10;
let bottlePrice = bottleSizeOption == '25oz' || bottleSizeOption == '16oz' ? 25 : 30;
let capPrice = 15;
let bootPrice = bottleSizeOption == '25oz' || bottleSizeOption == '16oz' ? 10 : 12;

let gliderPrice = 5;
let gliderVariantID = '';
let gliderActive = false;

let customizerLoaded = false;
let pageLoaded = false;

const totalPriceText = document.querySelector('.flask-price');
const originalPriceText = document.querySelector('.original-price');

const unavailable32OZColors = ['pomodoro', 'ikura','creamsicle','pina','slush', 'piña'];
const available16OZColors = ["macchiato", "gulaman", "boysenberry", "taffy", "pistachio", "gumball", "peach", "buttermilk", "key lime", "jelly", "blackberry", "bubblegum"];

let randomizeCondition = false;
let isCheckingBottle = false;
let isDispatchingEvents = false;
let bottleMainImage25oz;
let bottleMain25oz;
let bottleMainImage32oz;
let bottleMain32oz;
let bottleMainImage16oz;
let bottleMain16oz;
let bottleMainImage30oz;
let bottleMain30oz;

let capMain25oz;
let capMain16oz;
let capMain32oz;
let capMain30oz;
let robocapMain25oz;  
let robocapMain16oz;
let robocapMain32oz;
let robocapMain30oz;

let bubblecapMain25oz;  
let bubblecapMain16oz;
let bubblecapMain32oz;
let bubblecapMain30oz;

let loopMain25oz;
let loopMain16oz;
let loopMain32oz;
let loopMain30oz;

let bandMain25oz;
let bandMain16oz;
let bandMain32oz;
let bandMain30oz;
let connectorMain25oz;
let connectorMain16oz;
let connectorMain32oz;
let connectorMain30oz;

let bootMain25oz;
let bootMain16oz;
let bootMain32oz;


let bottleIsAvailable = true;
let capIsAvailable = true;
let loopIsAvailable = true;
let bootIsAvailable = true;
let engravingIsValid = true;

let item_cart_count;
let bottleInventory = {};
let loopInventory = {};
let capInventory = {};
let bootInventory = {};

// Function to check if a URL parameter exists
function checkUrlParameter(parameterName, url) {
  // Get the query string from the URL
  var queryString = url.split('?')[1];

  if (!queryString) {
    return false;
  }

  var parameters = queryString.split('&');

  for (var i = 0; i < parameters.length; i++) {
    var parameter = parameters[i].split('=');
    if (parameter[0] === parameterName) {
      return true;
    }
  }

  return false;
}

let url = location.href;

let sizeExists = checkUrlParameter("size", url);
let capExists = checkUrlParameter("cap", url);
let loopExists = checkUrlParameter("loop", url);
let bottleExists = checkUrlParameter("bottle", url);
let bootExists = checkUrlParameter("boot", url);
let sourceExists = checkUrlParameter("source", url);

// Function to get the value of a URL parameter
function getUrlParameterValue(parameterName, url) {
  var queryString = url.split('?')[1];

  if (!queryString) {
    return null;
  }

  var parameters = queryString.split('&');

  for (var i = 0; i < parameters.length; i++) {
    var parameter = parameters[i].split('=');
    if (parameter[0] === parameterName) {
      // Decode the parameter value and return it
      return decodeURIComponent(parameter[1]).toLowerCase();
    }
  }

  return null;
}

// Get the values of the parameters
var sizeValue = getUrlParameterValue("size", url) || defaultSize;
var capTypeValue = getUrlParameterValue("captype", url) || defaultCapType;
var capValue = getUrlParameterValue("cap", url) || '';
var loopValue = getUrlParameterValue("loop", url) || '';
var bottleValue = getUrlParameterValue("bottle", url) || '';
var bootValue = getUrlParameterValue("boot", url) || '';
var sourceValue = getUrlParameterValue("source", url) || '';

let withLoop = true;
let withBoot = false;
let animationSpeed = 300;

const closeFlaskBtn = document.querySelector('.preview-close svg');
closeFlaskBtn.addEventListener('click', function (params) {
  customizationMain.classList.remove('show');
});

const customizeMainBtn = document.querySelector('.customize-flask-button');
const customizeMainBtnMobile = document.querySelector('.customize-flask-button.mobile');
customizeMainBtn.addEventListener('click', function (e) {
  oosModal.classList.remove('show');
  if (customizeMainBtn.getAttribute('disabled') == null) {
    showCustomizer();;
    setDefaultCapType();
    try {
      localStorage.getItem('flaskOnboarding') ? document.querySelector('.onboarding-section').classList.add('hidden') : document.querySelector('.onboarding--step-1.active .ocm--video').play();
    } catch (error) { }
    updatePricing();
  }
});
customizeMainBtnMobile.addEventListener('click', function (e) {
  oosModal.classList.remove('show');
  if (customizeMainBtnMobile.getAttribute('disabled') == null) {
    showCustomizer();;
    setDefaultCapType();
    try {
      localStorage.getItem('flaskOnboarding') ? document.querySelector('.onboarding-section').classList.add('hidden') : document.querySelector('.onboarding--step-1.active .ocm--video').play();
    } catch (error) { }
    updatePricing();
  }
});

function setDefaultCapType(){

  const capSection = document.querySelector('.summary-content.cap-section');
  capSection.querySelectorAll('.cap-type-options').forEach(section => {
    if (defaultCapType == 'robo') {
      section.querySelectorAll('input[type="radio"]')[1].checked = true;
      section.querySelectorAll('input[type="radio"]')[1].dispatchEvent(changeEvent);
    }
    else{
      section.querySelectorAll('input[type="radio"]')[0].checked = true;
      section.querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
    }
  });
}

const addToBag = document.querySelector('.add-flask');
addToBag.addEventListener('click', async function () {
    
    const checker = await getItemCartCount();
    if(!checker){
      checkoutOOS(true);
    }
    else{
      if(bottleIsAvailable && bootIsAvailable && loopIsAvailable && capIsAvailable && engravingIsValid){
        popupCheckout.classList.add('show');
        customizationMain.scrollTop = -999999;
        bottleBundleVariantID.length > 1 ? popupBottleImage.classList.remove('hidden') : popupBottleImage.classList.add('hidden');
        capBundleVariantID.length > 1 ? popupCapImage.classList.remove('hidden') : popupCapImage.classList.add('hidden');
        loopBundleVariantID.length > 1 ? popupLoopImage.classList.remove('hidden') : popupLoopImage.classList.add('hidden');
        bootVariantID.length > 1 ? popupBootImage.classList.remove('hidden') : popupBootImage.classList.add('hidden');
        engravingValue.length > 1 ? '' : (engravingPlacement = '', engravingColor = '');
      }
      else{
        checkoutOOS(false);
      }
    }
  // }
});


async function getItemCartCount(){
  try {
      const response = await fetch('/cart.js');
      if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
      }
      const data = await response.json();
      item_cart_count = groupByItemId(data.items);
      if(item_cart_count[bottleInventory.variantID] >= bottleInventory.variantQuantity && bottleInventory.variantQuantity > 0){
        bottleIsAvailable = false
        return bottleIsAvailable;
      }
      if(item_cart_count[capInventory.variantID] >= capInventory.variantQuantity && capInventory.variantQuantity > 0){
        capIsAvailable = false
        return capIsAvailable;
      }
      if(item_cart_count[loopInventory.variantID] >= loopInventory.variantQuantity && loopInventory.variantQuantity > 0){
        loopIsAvailable = false
        return loopIsAvailable;
      }
      if(item_cart_count[bootInventory.variantID] >= bootInventory.variantQuantity && bootInventory.variantQuantity > 0){
        bootIsAvailable = false
        return bootIsAvailable;
      }
      return true;
  } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
  }
}

function groupByItemId(items) {
  if (!Array.isArray(items)) {
      return {};
  }

  const counts = {};

  items.forEach(item => {
      counts[item.id] = (counts[item.id] || 0) + 1;
  });
  return counts;
}


const changeEvent = new Event('change');

let firstAvailableBottle25oz = document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-25oz"]:not(.disabled)') || document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-25oz"]');
let firstAvailableBottle32oz = document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-32oz"]:not(.disabled)') || document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-32oz"]');
let firstAvailableBottle16oz = document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-16oz"]:not(.disabled)') || document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-16oz"]');
let firstAvailableBottle30oz = document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-30oz"]:not(.disabled)') || document.querySelector('.bottle-section .color-section input[type="radio"][name="summary-body-component-30oz"]');


// elements for bottle section
const bottleRadios = document.querySelectorAll('.bottle-section .color-section input[type="radio"][name="summary-body-component-25oz"]');
const bottleRadiosMobile = document.querySelectorAll('.bottle-section-mobile input[type="radio"][name="summary-bottle-component-mobile-25oz"]');
const bottleRadios32oz = document.querySelectorAll('.bottle-section .color-section input[type="radio"][name="summary-body-component-32oz"]');
const bottleRadiosMobile32oz = document.querySelectorAll('.bottle-section-mobile input[type="radio"][name="summary-bottle-component-mobile-32oz"]');
const bottleRadios16oz = document.querySelectorAll('.bottle-section .color-section input[type="radio"][name="summary-body-component-16oz"]');
const bottleRadiosMobile16oz = document.querySelectorAll('.bottle-section-mobile input[type="radio"][name="summary-bottle-component-mobile-16oz"]');
const bottleRadios30oz = document.querySelectorAll('.bottle-section .color-section input[type="radio"][name="summary-body-component-30oz"]');
const bottleRadiosMobile30oz = document.querySelectorAll('.bottle-section-mobile input[type="radio"][name="summary-bottle-component-mobile-30oz"]');
const bottleColorTextClassic = document.querySelector('.summary-desktop [data-size-category="25oz"] #bottle-color-text-classic');
const bottleColorTextLimited = document.querySelector('.summary-desktop [data-size-category="25oz"] #bottle-color-text-limited');
const bottleColorTextClassicMobile = document.querySelector('.summary-mobile [data-size-category="25oz"] #bottle-color-text-classic');
const bottleColorTextLimitedMobile = document.querySelector('.summary-mobile [data-size-category="25oz"] #bottle-color-text-limited');
const bottleColorTextClassic32oz = document.querySelector('.summary-desktop [data-size-category="32oz"] #bottle-color-text-classic');
const bottleColorTextLimited32oz = document.querySelector('.summary-desktop [data-size-category="32oz"] #bottle-color-text-limited');
const bottleColorTextClassicMobile32oz = document.querySelector('.summary-mobile [data-size-category="32oz"] #bottle-color-text-classic');
const bottleColorTextLimitedMobile32oz = document.querySelector('.summary-mobile [data-size-category="32oz"] #bottle-color-text-limited');
const bottleColorTextClassic16oz = document.querySelector('.summary-desktop [data-size-category="16oz"] #bottle-color-text-classic');
const bottleColorTextLimited16oz = document.querySelector('.summary-desktop [data-size-category="16oz"] #bottle-color-text-limited');
const bottleColorTextClassicMobile16oz = document.querySelector('.summary-mobile [data-size-category="16oz"] #bottle-color-text-classic');
const bottleColorTextLimitedMobile16oz = document.querySelector('.summary-mobile [data-size-category="16oz"] #bottle-color-text-limited');
const bottleColorTextClassic30oz = document.querySelector('.summary-desktop [data-size-category="30oz"] #bottle-color-text-classic');
const bottleColorTextLimited30oz = document.querySelector('.summary-desktop [data-size-category="30oz"] #bottle-color-text-limited');
const bottleColorTextClassicMobile30oz = document.querySelector('.summary-mobile [data-size-category="30oz"] #bottle-color-text-classic');
const bottleColorTextLimitedMobile30oz = document.querySelector('.summary-mobile [data-size-category="30oz"] #bottle-color-text-limited');
const bottleColorTextAnimal16oz = document.querySelector('.summary-desktop .color-section[data-size-category="16oz"] #bottle-color-text-animal');
const bottleColorTextAnimalMobile16oz = document.querySelector('.summary-mobile .color-section[data-size-category="16oz"] #bottle-color-text-animal');
// Set default checked state with safety checks
if (bottleRadios && bottleRadios.length > 0) {
  bottleRadios[0].checked = true;
}
if (bottleRadiosMobile && bottleRadiosMobile.length > 0) {
  bottleRadiosMobile[0].checked = true;
}
if (bottleRadios32oz && bottleRadios32oz.length > 0) {
  bottleRadios32oz[0].checked = true;
}
if (bottleRadiosMobile32oz && bottleRadiosMobile32oz.length > 0) {
  bottleRadiosMobile32oz[0].checked = true;
}
if (bottleRadios16oz && bottleRadios16oz.length > 0) {
  bottleRadios16oz[0].checked = true;
}
if (bottleRadiosMobile16oz && bottleRadiosMobile16oz.length > 0) {
  bottleRadiosMobile16oz[0].checked = true;
}
if (bottleRadios30oz && bottleRadios30oz.length > 0) {
  bottleRadios30oz[0].checked = true;
}
if (bottleRadiosMobile30oz && bottleRadiosMobile30oz.length > 0) {
  bottleRadiosMobile30oz[0].checked = true;
}

// Get first bottle colors with safety checks
const first25ozBottleColor = (bottleRadios && bottleRadios.length > 0) ? bottleRadios[0].dataset.name : '';
const first16ozBottleColor = (bottleRadios16oz && bottleRadios16oz.length > 0) ? bottleRadios16oz[0].dataset.name : '';
const first32ozBottleColor = (bottleRadios32oz && bottleRadios32oz.length > 0) ? bottleRadios32oz[0].dataset.name : '';
const first30ozBottleColor = (bottleRadios30oz && bottleRadios30oz.length > 0) ? bottleRadios30oz[0].dataset.name : '';

const bottleSizeRadios = document.querySelectorAll('.summary-desktop .bottle-size-option input[type="radio"]');
const bottleSizeRadiosMobile = document.querySelectorAll('.summary-mobile .bottle-size-option input[type="radio"]');

let bottleSizeHolder = null;

window.addEventListener('DOMContentLoaded', function () {
  // if (sizeExists) {
  //   // Convert size value to match radio button data-name format (e.g., "32oz" -> "32oz")
  //   const validSizes = ["25oz", "32oz", "16oz"];
  //   if (validSizes.includes(sizeValue)) {
  //     checkSizeRadioButtonWithValue(sizeValue);
  //   }
  // }
  
  if (!capExists || !loopExists || !bottleExists) {
    // if(defaultSize == '32oz'){
    // bottleRadios32oz[0].dispatchEvent(changeEvent);
    // }
    // else if(defaultSize == '16oz'){
    //   bottleRadios16oz[0].dispatchEvent(changeEvent);
    // }
    // else{
    //   bottleRadios[0].dispatchEvent(changeEvent);
    // }
    // // bottleRadiosMobile[0].dispatchEvent(changeEvent);
    // // bottleRadiosMobile32oz[0].dispatchEvent(changeEvent);

  } else {
    document.querySelector('body').classList.remove('hide');
  }
  customizeMainBtn.removeAttribute('disabled');
  customizeMainBtnMobile.removeAttribute('disabled');
})


// elements for cap section
const capRadios = document.querySelectorAll('.cap-section .color-section.pebble-cap--section input[type="radio"]');
const capRadiosMobile = document.querySelectorAll('.cap-section-mobile .color-section.pebble-cap--section input[type="radio"]');
const capColorTextClassic = document.querySelector('#cap-color-text-classic');
const capColorTextLimited = document.querySelector('#cap-color-text-limited');
const capColorTextAnimal = document.querySelector('#cap-color-text-animal');
const capColorTextClassicMobile = document.querySelector('.summary-mobile #cap-color-text-classic');
const capColorTextLimitedMobile = document.querySelector('.summary-mobile #cap-color-text-limited');
const capColorTextAnimalMobile = document.querySelector('.summary-mobile #cap-color-text-animal');

const robocapRadios = document.querySelectorAll('.cap-section .color-section.robocap--section input[type="radio"]');
const robocapRadiosMobile = document.querySelectorAll('.cap-section-mobile .color-section.robocap--section input[type="radio"]');
const robocapColorTextClassic = document.querySelector('#robocap-color-text-classic');
const robocapColorTextLimited = document.querySelector('#robocap-color-text-limited');
const robocapColorTextAnimal = document.querySelector('#robocap-color-text-animal');
const robocapColorTextClassicMobile = document.querySelector('.summary-mobile #robocap-color-text-classic');
const robocapColorTextLimitedMobile = document.querySelector('.summary-mobile #robocap-color-text-limited');
const robocapColorTextAnimalMobile = document.querySelector('.summary-mobile #robocap-color-text-animal');

const bubblecapRadios = document.querySelectorAll('.cap-section .color-section.bubblecap--section input[type="radio"]');
const bubblecapRadiosMobile = document.querySelectorAll('.cap-section-mobile .color-section.bubblecap--section input[type="radio"]');
const bubblecapColorTextClassic = document.querySelector('#bubblecap-color-text-classic');
const bubblecapColorTextLimited = document.querySelector('#bubblecap-color-text-limited');
const bubblecapColorTextAnimal = document.querySelector('#bubblecap-color-text-animal');
const bubblecapColorTextClassicMobile = document.querySelector('.summary-mobile #bubblecap-color-text-classic');
const bubblecapColorTextLimitedMobile = document.querySelector('.summary-mobile #bubblecap-color-text-limited');
const bubblecapColorTextAnimalMobile = document.querySelector('.summary-mobile #bubblecap-color-text-animal');

// elements for loop section
const loopSection = document.querySelector('.loop-section ');
const loopRadios = document.querySelectorAll('.loop-section .color-section.loop--section input[type="radio"]');
const loopRadiosMobile = document.querySelectorAll('.loop-section-mobile .color-section.loop--section input[type="radio"]');
const capRadios30oz = document.querySelectorAll('.cap-section .color-section.pebble-cap--section [name="summary-cap-component"]');
const robocapRadios30oz = document.querySelectorAll('.cap-section .color-section.robocap--section [name="summary-robocap-component"]');

const bubblecapRadios30oz = document.querySelectorAll('.cap-section .color-section.bubblecap--section [name="summary-bubblecap-component"]');
const loopRadios30oz = document.querySelectorAll('.loop-section .color-section.loop--section [name="summary-loop-component"]');
const connectorRadios30oz = document.querySelectorAll('.loop-section .color-section.connector--section [name="summary-connector-component"]');
const loopColorTextClassic = document.querySelector('#loop-color-text-classic');
const loopColorTextLimited = document.querySelector('#loop-color-text-limited');
const loopColorTextCharm = document.querySelector('#loop-color-text-charm');
const loopColorTextAnimal = document.querySelector('#loop-color-text-animal');
const loopColorTextClassicMobile = document.querySelector('.summary-mobile #loop-color-text-classic');
const loopColorTextLimitedMobile = document.querySelector('.summary-mobile #loop-color-text-limited');
const loopColorTextCharmMobile = document.querySelector('.summary-mobile #loop-color-text-charm');
const loopColorTextAnimalMobile = document.querySelector('.summary-mobile #loop-color-text-animal');


const connectorRadios = document.querySelectorAll('.loop-section .color-section.connector--section input[type="radio"]');
const connectorRadiosMobile = document.querySelectorAll('.loop-section-mobile .color-section.connector--section input[type="radio"]');
const connectorColorTextClassic = document.querySelector('#connector-color-text-classic');
const connectorColorTextLimited = document.querySelector('#connector-color-text-limited');
const connectorColorTextAnimal = document.querySelector('#connector-color-text-animal');
const connectorColorTextClassicMobile = document.querySelector('.summary-mobile #connector-color-text-classic');
const connectorColorTextLimitedMobile = document.querySelector('.summary-mobile #connector-color-text-limited');
const connectorColorTextAnimalMobile = document.querySelector('.summary-mobile #connector-color-text-animal');

const bandRadios = document.querySelectorAll('.loop-section .color-section.band--section input[type="radio"]');
const bandRadiosMobile = document.querySelectorAll('.loop-section-mobile .color-section.band--section input[type="radio"]');
const bandColorTextClassic = document.querySelector('#band-color-text-classic');
const bandColorTextLimited = document.querySelector('#band-color-text-limited');
const bandColorTextAnimal = document.querySelector('#band-color-text-animal');
const bandColorTextClassicMobile = document.querySelector('.summary-mobile #band-color-text-classic');
const bandColorTextLimitedMobile = document.querySelector('.summary-mobile #band-color-text-limited');
const bandColorTextAnimalMobile = document.querySelector('.summary-mobile #band-color-text-animal');


// elements for boot section
const bootSection = document.querySelector('.boot-section');
const bootRadios = document.querySelectorAll('.boot-section input[type="radio"][name="summary-boot-component-25oz"]');
const bootRadiosMobile = document.querySelectorAll('.boot-section-mobile input[type="radio"][name="summary-boot-component-mobile-25oz"]');
const bootRadios32oz = document.querySelectorAll('.boot-section input[type="radio"][name="summary-boot-component-32oz"]');
const bootRadiosMobile32oz = document.querySelectorAll('.boot-section-mobile input[type="radio"][name="summary-boot-component-mobile-32oz"]');
const bootColorTextClassic = document.querySelector('[data-size-category="25oz"] #boot-color-text-classic');
const bootColorTextClassic32oz = document.querySelector('[data-size-category="32oz"] #boot-color-text-classic');
const bootColorTextCandy = document.querySelector('[data-size-category="25oz"] #boot-color-text-candy');
const bootColorTextCandy32oz = document.querySelector('[data-size-category="32oz"] #boot-color-text-candy');
const bootColorTextLimited = document.querySelector('[data-size-category="25oz"] #boot-color-text-limited');
const bootColorTextLimited32oz = document.querySelector('[data-size-category="32oz"] #boot-color-text-limited');
const bootColorTextClassicMobile = document.querySelector('.summary-mobile [data-size-category="25oz"] #boot-color-text-classic');
const bootColorTextClassicMobile32oz = document.querySelector('.summary-mobile [data-size-category="32oz"] #boot-color-text-classic');
const bootColorTextCandyMobile = document.querySelector('.summary-mobile [data-size-category="25oz"] #boot-color-text-candy');
const bootColorTextCandyMobile32oz = document.querySelector('.summary-mobile [data-size-category="32oz"] #boot-color-text-candy');
const bootColorTextLimitedMobile = document.querySelector('.summary-mobile [data-size-category="25oz"] #boot-color-text-limited');
const bootColorTextLimitedMobile32oz = document.querySelector('.summary-mobile [data-size-category="32oz"] #boot-color-text-limited');
const bootColorTextAnimal = document.querySelector('#boot-color-text-animal');
const bootColorTextAnimalMobile = document.querySelector('.summary-mobile #boot-color-text-animal');
const bootChoices = document.querySelector('.boot-choices');
const bootChoices32oz = document.querySelector('.boot-choices');
const bootChoicesMobile = document.querySelector('.summary-mobile .boot-choices');
const bootChoicesMobile32oz = document.querySelector('.summary-mobile .boot-choices');
const bootColorSection = document.querySelector('.boot-section .color-section[data-size-category="25oz"]');
const bootColorSectionMobile = document.querySelector('.summary-mobile .boot-section-mobile .color-section[data-size-category="25oz"]');
const bootColorSection32oz = document.querySelector('.boot-section .color-section[data-size-category="32oz"]');
const bootColorSectionMobile32oz = document.querySelector('.summary-mobile .boot-section-mobile .color-section[data-size-category="32oz"]');

// elements for mobile tabs
const mobileTabs = document.querySelectorAll('.summary-mobile-tab');
const summaryContentMobile = document.querySelectorAll('.summary-content-mobile');

// summary sections
const summaryContent = document.querySelectorAll('.summary-content');
const summaryBottleSection = document.querySelector('.summary-content.bottle-section');
const summaryBootSection = document.querySelector('.summary-content.boot-section');
const summaryCapSection = document.querySelector('.summary-content.cap-section');
const summaryLoopSection = document.querySelector('.summary-content.loop-section');
const summaryEngravingSection = document.querySelector('.summary-content.engraving-section');
const engravingInput = document.querySelector('#engraving');
const engravingInputMobile = document.querySelector('.summary-mobile #engraving');
const engravingPlacementDesktop = document.querySelectorAll('.summary-desktop .desktop-summary-placement');
const engravingOrientationDesktop = document.querySelectorAll('.summary-desktop .desktop-summary-orientation');

const summaryBottleSectionMobile = document.querySelector('.bottle-section-mobile');
const summaryBootSectionMobile = document.querySelector('.boot-section-mobile');
const summaryCapSectionMobile = document.querySelector('.cap-section-mobile');
const summaryLoopSectionMobile = document.querySelector('.loop-section-mobile');
const summaryEngravingSectionMobile = document.querySelector('.engraving-section-mobile');
const engravingPlacementMobile = document.querySelectorAll('.summary-mobile .mobile-summary-placement');
const engravingOrientationMobile = document.querySelectorAll('.summary-mobile .mobile-summary-orientation');

const previewSections = document.querySelectorAll('.preview-components');
const bottlePreview = document.querySelector('.bottle-preview[data-size-category="25oz"]');
const bottlePreview16oz = document.querySelector('.bottle-preview[data-size-category="16oz"]');
const bottlePreview32oz = document.querySelector('.bottle-preview[data-size-category="32oz"]');
const bottlePreview30oz = document.querySelector('.bottle-preview[data-size-category="30oz"]');
const capPreview = document.querySelector('.cap-preview[data-size-category="25oz"]');
const capPreview32oz = document.querySelector('.cap-preview[data-size-category="32oz"]');
const capPreview16oz = document.querySelector('.cap-preview[data-size-category="16oz"]');
const capPreview30oz = document.querySelector('.cap-preview[data-size-category="30oz"]');
const robocapPreview = document.querySelector('.robocap-preview[data-size-category="25oz"]');
const robocapPreview32oz = document.querySelector('.robocap-preview[data-size-category="32oz"]');
const robocapPreview16oz = document.querySelector('.robocap-preview[data-size-category="16oz"]');
const robocapPreview30oz = document.querySelector('.robocap-preview[data-size-category="30oz"]');

const bubblecapPreview = document.querySelector('.bubblecap-preview[data-size-category="25oz"]');
const bubblecapPreview32oz = document.querySelector('.bubblecap-preview[data-size-category="32oz"]');
const bubblecapPreview16oz = document.querySelector('.bubblecap-preview[data-size-category="16oz"]');
const bubblecapPreview30oz = document.querySelector('.bubblecap-preview[data-size-category="30oz"]');
const loopPreview = document.querySelector('.loop-preview[data-size-category="25oz"]');
const loopPreview32oz = document.querySelector('.loop-preview[data-size-category="32oz"]');
const loopPreview16oz = document.querySelector('.loop-preview[data-size-category="16oz"]');
const loopPreview30oz = document.querySelector('.loop-preview[data-size-category="30oz"]');
const connectorPreview = document.querySelector('.connector-preview[data-size-category="25oz"]');
const connectorPreview32oz = document.querySelector('.connector-preview[data-size-category="32oz"]');
const connectorPreview16oz = document.querySelector('.connector-preview[data-size-category="16oz"]');
const connectorPreview30oz = document.querySelector('.connector-preview[data-size-category="30oz"]');

const bandPreview = document.querySelector('.band-preview[data-size-category="25oz"]');
const bandPreview32oz = document.querySelector('.band-preview[data-size-category="32oz"]');
const bandPreview16oz = document.querySelector('.band-preview[data-size-category="16oz"]');
const bandPreview30oz = document.querySelector('.band-preview[data-size-category="30oz"]');
const bootPreview = document.querySelector('.boot-preview[data-size-category="25oz"]');
const bootPreview32oz = document.querySelector('.boot-preview[data-size-category="32oz"]');
// 30oz uses 25oz boot
const bootPreview30oz = bootPreview;

// preview main images
const swipeElement = document.querySelector('.preview-main .content');
const previewMainImage = document.querySelectorAll('.preview-main-image');
const bottleImage = document.querySelector('.preview-image-containers .bottle-image');
const capImage = document.querySelector('.preview-image-containers .cap-image');
const loopImage = document.querySelector('.preview-image-containers .loop-image');
const bootImage = document.querySelector('.preview-image-containers .boot-image');

// popup images

const popupCheckout = document.querySelector('.preview-popup');
const popupCapImage = document.querySelector('.popup-image-cap');
const popupBottleImage = document.querySelector('.popup-image-bottle');
const popupLoopImage = document.querySelector('.popup-image-loop');
const popupBootImage = document.querySelector('.popup-image-boot');
const popupButtonEdit = document.querySelectorAll('.popup-button-edit');

const mainRadios = document.querySelectorAll('.flask-swatch').length > 0 ?  document.querySelectorAll('.flask-swatch') : document.querySelectorAll('.swatch input[type="radio"]') ;
const mainSizeRadios = document.querySelectorAll('variant-radios #size input');
const variantNameClassic = document.querySelector('.variant-name p.color-text-classic');
const variantNameLimited = document.querySelector('.variant-name p.color-text-limited');
const previewEngraving = document.querySelector('.bottle-hover');
const previewEngravingText = document.querySelector('.bottle-hover span');
const popupEngraving = document.querySelector('.popup-engraving');
const popupEngravingText = document.querySelector('.popup-engraving span');

let chosenBottle = '';
let chosenCap = '';
let chosenLoop = '';
let chosenBoot = '';

const randomize = document.querySelector('#randomize-button');

const sliderNavButtons = document.querySelectorAll('.slider-nav');

const capNext = document.querySelector('.cap-next');
const capPrevious = document.querySelector('.cap-previous');

const bottleNext = document.querySelector('.bottle-next');
const bottleNext32oz = document.querySelector('.bottle-next-32oz');
const bottlePrevious = document.querySelector('.bottle-previous');
const bottlePrevious32oz = document.querySelector('.bottle-previous-32oz');

const loopNext = document.querySelector('.loop-next');
const loopPrevious = document.querySelector('.loop-previous');

const bootNext = document.querySelector('.boot-next');
const bootNext32oz = document.querySelector('.boot-next-32oz');
const bootPrevious = document.querySelector('.boot-previous');
const bootPrevious32oz = document.querySelector('.boot-previous-32oz');

// form inputs
const mainBundle = document.querySelector('#main-bundle');
const bottleComponent = document.querySelector('#bottle-component');
const capComponent = document.querySelector('#cap-component');
const loopComponent = document.querySelector('#loop-component');
const bootComponent = document.querySelector('#boot-component');
const engravingComponent = document.querySelector('#engraving-component');
const productForm = document.querySelector('product-form-kit form button');

const buttonFont = document.querySelectorAll('.button-font');

window.addEventListener('DOMContentLoaded', function () {
  // mainRadios[0].checked = true;
  // mainRadios[0].dataset.color_type == 'classic' ? variantNameClassic.innerText = ': ' + mainRadios[0].id : variantNameLimited.innerText = ': ' + mainRadios[0].id;
  // variantNameClassic.innerText = mainRadios[0].id;
})

// mainRadios.forEach(function (r) {
//   r.addEventListener('click', function (e) {
//     animationSpeed = 0;
//     checkRadioButtonWithValue(r.dataset.color);
//     chosenMainColor = r.dataset.color;
//     if (r.dataset.color_type === 'limited') {
//       variantNameLimited.innerText = ': ' + r.id;
//       variantNameClassic.innerText = '';
//     } else {
//       variantNameLimited.innerText = '';
//       variantNameClassic.innerText = ': ' + r.id;
//     }
//     document.querySelectorAll('#vto-image-wrapper img.swiper-slide').forEach(el => { el.classList.remove('show') });
//     document.querySelectorAll('#vto-image-wrapper img.swiper-slide').forEach(el => { el.dataset.variant == r.dataset.color ? el.classList.add('show') : '' });
//     animationSpeed = 300;
//     fetchFlaskDetails(r.dataset.url);
//   });
// });

document.addEventListener('click', function(e){
  if(e.target.closest('variant-radios fieldset.swatch') && e.target.type == 'radio'){
    
    animationSpeed = 0;
    clickFromMainRadios = true;
    checkRadioButtonWithValue(e.target.dataset.color);
    chosenMainColor = e.target.dataset.color;
    if (e.target.dataset.color_type === 'limited') {
      // variantNameLimited.innerText = ': ' + e.target.id;
      // variantNameClassic.innerText = '';
    } else {
      // variantNameLimited.innerText = '';
      // variantNameClassic.innerText = ': ' + e.target.id;
    }
    document.querySelectorAll('#vto-image-wrapper img.swiper-slide').forEach(el => { el.classList.remove('show') });
    document.querySelectorAll('#vto-image-wrapper img.swiper-slide').forEach(el => { el.dataset.variant == e.target.dataset.color ? el.classList.add('show') : '' });
    animationSpeed = 300;
    fetchFlaskDetails(e.target.dataset.url);
  }
});

mainSizeRadios.forEach(msr => {

  msr.addEventListener('click', e => {

  if(summaryCapSection.getAttribute('data-filled') != 'filled'){
    const capSection = document.querySelector('.summary-content.cap-section');
    capSection.querySelectorAll('.cap-type-options').forEach(section => {
      if (defaultCapType == 'robo') {
        section.querySelectorAll('input[type="radio"]')[1].checked = true;
        section.querySelectorAll('input[type="radio"]')[1].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'pebble'){
        section.querySelectorAll('input[type="radio"]')[0].checked = true;
        section.querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'bubble'){
        section.querySelectorAll('input[type="radio"]')[2].checked = true;
        section.querySelectorAll('input[type="radio"]')[2].dispatchEvent(changeEvent);
      }
    });
  }
    if(msr.value === '25oz'){
      document.querySelector('#product-price').innerText = defaultCapType == 'pebble' ? '$35': '$50';
      bottlePreview.classList.add('active');
      bottlePreview32oz.classList.remove('active');
      bottlePreview16oz.classList.remove('active');
      if(bottlePreview30oz) bottlePreview30oz.classList.remove('active');
      bottlePreview.dataset.filled = 'filled';
    }
    else if(msr.value === '16oz'){
      document.querySelector('#product-price').innerText = defaultCapType == 'pebble' ? '$35': '$50';
      bottlePreview16oz.classList.add('active');
      bottlePreview32oz.classList.remove('active');
      bottlePreview.classList.remove('active');
      if(bottlePreview30oz) bottlePreview30oz.classList.remove('active');
      bottlePreview16oz.dataset.filled = 'filled';
    }
    else if(msr.value === '30oz'){
      document.querySelector('#product-price').innerText = defaultCapType == 'pebble' ? '$30': defaultCapType == 'bubble' ? '$35' : '$40';
      if(bottlePreview30oz) {
        bottlePreview30oz.classList.add('active');
        bottlePreview30oz.dataset.filled = 'filled';
      }
      bottlePreview.classList.remove('active');
      bottlePreview32oz.classList.remove('active');
      bottlePreview16oz.classList.remove('active');
    }
    else if(msr.value === '32oz'){
      document.querySelector('#product-price').innerText = defaultCapType == 'pebble' ? '$40': '$55';
      bottlePreview.classList.remove('active');
      bottlePreview32oz.classList.add('active');
      bottlePreview16oz.classList.remove('active');
      if(bottlePreview30oz) bottlePreview30oz.classList.remove('active');
    }
    
    if(msr.value == '32oz'){
      setTimeout(function(){
          bottleRadios32oz.forEach(br => {
            if(br.dataset.name == chosenMainColor){
              br.dispatchEvent(changeEvent);
            }
          });
          capRadios.forEach(cr => {
            if(cr.dataset.name == chosenMainColor){
              cr.dispatchEvent(changeEvent);
            }
          });
          loopRadios.forEach(lr => {
            if(lr.dataset.name == chosenMainColor){
              lr.dispatchEvent(changeEvent);
            }
          });
      }, 500);
    }

    if(msr.value == '16oz'){
      setTimeout(function(){
          bottleRadios16oz.forEach(br => {
            if(br.dataset.name == chosenMainColor){
              br.dispatchEvent(changeEvent);
            }
          });
          capRadios.forEach(cr => {
            if(cr.dataset.name == chosenMainColor){
              cr.dispatchEvent(changeEvent);
            }
          });
          loopRadios.forEach(lr => {
            if(lr.dataset.name == chosenMainColor){
              lr.dispatchEvent(changeEvent);
            }
          });
      }, 500);
    }

    if(msr.value == '30oz'){
      setTimeout(function(){
          bottleRadios30oz.forEach(br => {
            if(br.dataset.name == chosenMainColor){
              br.dispatchEvent(changeEvent);
            }
          });
          capRadios.forEach(cr => {
            if(cr.dataset.name == chosenMainColor){
              cr.dispatchEvent(changeEvent);
            }
          });
          loopRadios.forEach(lr => {
            if(lr.dataset.name == chosenMainColor){
              lr.dispatchEvent(changeEvent);
            }
          });
          connectorRadios.forEach(cr => {
            if(cr.dataset.name == chosenMainColor){
              cr.dispatchEvent(changeEvent);
            }
          });
          bandRadios.forEach(br => {
            if(br.dataset.name == chosenMainColor){
              br.dispatchEvent(changeEvent);
            }
          });
      }, 500);
    }
    updatePricing();
    checkSizeRadioButtonWithValue(msr.value);
    document.querySelector('.preview-main').classList.remove('animation')
  })
})

function mainRadioFunctions() {

}

engravingInput.addEventListener('input', function (e) {
  updateEngraving(e.target.value, 'desktop', e)
});

engravingInputMobile.addEventListener('input', function (e) {
  updateEngraving(e.target.value, 'mobile', e)
});

function updateEngraving(input, device, e){

  // Updated by Ruent: 
  //𖤓🜲��
  // Don't process SVG content - skip the replacement for paw SVG
  let modifiedInput = input;
  
  // Only replace actual emoji characters, not SVG content
  if (!input.includes('<svg')) {
    modifiedInput = input.replace(/ᯓ★/g, 'X').replace(/•ᴗ•/g, 'Y').replace(/🐾/g, 'Y').replace(/🜲/g, 'Y').replace(/𖤓/g, 'Y');
  }
  
  // Get current font selection
  const currentFont = engravingFont || 'Replica'; // Default to Replica if not set
  
  if(modifiedInput.length >= 10){
    // MORE THAN 10 CHARACTERS
    // For Savoye font, use 12px for 10+ characters
    if(currentFont.includes('Savoye')){
      previewEngravingText.style.fontSize = '12px';
      popupEngravingText.style.fontSize = '12px';

    }else if(currentFont.includes('Nautica')){
      previewEngravingText.style.fontSize = '12px';
      popupEngravingText.style.fontSize = '12px';
    }else if(currentFont.includes('Only Organic')){
      previewEngravingText.style.fontSize = '6px';
      popupEngravingText.style.fontSize = '6px';
    }
    else {
      // For other fonts, use 7px for 10+ characters
      previewEngravingText.style.fontSize = '7px';
      popupEngravingText.style.fontSize = '7px';
    }
   
  }else{
    // Standard text size 12px
    if(currentFont === 'Only Organic'){
      // for Only Organic is now 9px 
      previewEngravingText.style.fontSize = '8px';
      popupEngravingText.style.fontSize = '8px';
    }else if(currentFont.includes('Nautica')){
      // for Savoye is now 14px
      previewEngravingText.style.fontSize = '14px';
      popupEngravingText.style.fontSize = '14px';
    }else if(currentFont.includes('Savoye')){
      // for Savoye is now 14px
      previewEngravingText.style.fontSize = '14px';
      popupEngravingText.style.fontSize = '14px';
    }
    else{
      previewEngravingText.style.fontSize = '12px';
      popupEngravingText.style.fontSize = '12px';
    }
  }

  popupEngravingText.style.fontStyle = 'normal';
  popupEngravingText.style.color = 'white';

  if(modifiedInput.length < 15){
    // Don't replace SVG content - keep it as is
    const pawSVG = `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="white" stroke="white" style="width: 12px; height: 12px;"><path d="M18.137 21.824c-5.645 1.549-9.088 7.132-8.092 10.944c.998 3.813 4.766-.53 10.411-2.08c5.643-1.551 11.024.281 10.028-3.532c-.997-3.813-6.702-6.883-12.347-5.332" fill="white"></path><path d="M13.768 20.047c1.701-.632 1.918-4.417 1.012-6.969c-.906-2.55-3.02-4.103-4.721-3.469c-1.7.635-2.344 3.217-1.438 5.767c.906 2.551 3.445 5.306 5.147 4.671" fill="white"></path><path d="M20.708 18.078c1.803-.162 2.967-3.759 2.736-6.465c-.23-2.704-1.879-4.763-3.682-4.604c-1.803.163-3.079 2.486-2.848 5.19c.232 2.704 1.989 6.041 3.794 5.879" fill="white"></path><path d="M28.678 10.164c-1.809 0-3.275 2.2-3.275 4.914c0 2.716 1.467 6.195 3.275 6.195c1.81 0 3.276-3.479 3.276-6.195c.001-2.715-1.466-4.914-3.276-4.914" fill="white"></path><path d="M3.318 17.127c-1.568.926-1.766 3.584-.439 5.936c1.324 2.35 4.293 4.612 5.86 3.685c1.568-.927 1.141-4.693-.184-7.043c-1.325-2.352-3.671-3.505-5.237-2.578" fill="white"></path><path d="M45.865 44.529c-5.645-1.551-11.352 1.52-12.348 5.332c-.998 3.813 4.385 1.981 10.029 3.532c5.645 1.55 9.412 5.893 10.408 2.08c.998-3.812-2.446-9.394-8.089-10.944" fill="white"></path><path d="M50.234 42.755c1.699.632 4.24-2.123 5.146-4.674c.906-2.551.262-5.133-1.438-5.767c-1.701-.635-3.813.919-4.719 3.47s-.69 6.336 1.011 6.971" fill="white"></path><path d="M43.295 40.782c1.803.162 3.561-3.174 3.791-5.878s-1.043-5.028-2.846-5.19c-1.803-.16-3.451 1.9-3.684 4.605c-.23 2.705.936 6.301 2.739 6.463" fill="white"></path><path d="M35.322 43.978c1.811 0 3.277-3.479 3.277-6.195c0-2.714-1.467-4.914-3.277-4.914s-3.277 2.2-3.277 4.916c0 2.714 1.469 6.193 3.277 6.193" fill="white"></path><path d="M60.683 39.832c-1.568-.927-3.912.226-5.236 2.577c-1.323 2.351-1.751 6.117-.186 7.044c1.568.927 4.537-1.335 5.861-3.685c1.324-2.351 1.127-5.009-.439-5.936" fill="white"></path></svg>`;
    const processedInput = input.includes('<svg') ? input : input.replace(/🐾/g, pawSVG);
    const processedInputValue = input;
    // device == 'desktop' ? engravingInputMobile.value = processedInput : engravingInput.value = processedInput;
    previewEngravingText.innerHTML = processedInput
    popupEngravingText.innerHTML = processedInput
    engravingValue = processedInputValue;
  }else{
    e.preventDefault();
  }
}

// previewEngraving
// popupEngraving

engravingPlacementDesktop.forEach(p => {
  p.addEventListener('change', function () {
    if (p.id == 'top-placement') {
      updatePlacement('top', 'Top');
    } else if (p.id == 'middle-placement') {
      updatePlacement('middle', 'Middle');
    } else {
      updatePlacement('bottom', 'Bottom');
    }
  });
})

engravingPlacementMobile.forEach(p => {
  p.addEventListener('change', function () {
    if (p.id == 'top-placement-mobile') {
      updatePlacement('top', 'Top');
    } else if (p.id == 'middle-placement-mobile') {
      updatePlacement('middle', 'Middle');
    } else {
      updatePlacement('bottom', 'Bottom');
    }
  });
})

engravingOrientationDesktop.forEach(o => {
  o.addEventListener('change', function () {
    updateOrientation(o);
  })
})

engravingOrientationMobile.forEach(o => {
  o.addEventListener('change', function () {
    updateOrientation(o);
  })
})

function updateOrientation(o){
  if(o.id.includes('horizontal-orientation')){
    popupEngraving.setAttribute('orientation','');
    previewEngraving.setAttribute('orientation','');
    engravingOrientation = 'horizontal';
  }
  else{
    popupEngraving.setAttribute('orientation','vertical');
    previewEngraving.setAttribute('orientation','vertical');
    engravingOrientation = 'vertical';
  }
  document.querySelectorAll('#engraving-orientation-text').forEach(element => {
    element.innerText = engravingOrientation;
  });
}

function updatePlacement(placement, text) {
  popupEngraving.setAttribute('placement', placement);
  previewEngraving.setAttribute('placement', placement);
  document.querySelectorAll('#engraving-placement-text').forEach(ept => {
    ept.innerText = placement;
  });
  engravingPlacement = placement;
}


// Click event listener for opening summary sections
summaryContent.forEach(function (element) {
  element.addEventListener('click', function (event) {

    if (isOutsideOptions(event.target)) {
      sliderNavButtons.forEach(function (nav) {
        nav.classList.remove('active');
        nav.classList.remove('hidden');
      })

      summaryContent.forEach(function (e) {
        e.classList.remove('active');
      });

      if (element.getAttribute('data-filled') === 'empty') {
        if (element.querySelectorAll('input[type="radio"]')[0]) {
          if (!element.closest('.boot-section')) {
            element.setAttribute('data-filled', 'filled');
            element.querySelectorAll('input[type="radio"]')[0].checked = true;
            element.querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
          }
          if (event.target.closest('.engraving-section')) {
            engravingOrientationDesktop[1].checked = true;
            engravingOrientationDesktop[1].dispatchEvent(changeEvent)
          }
        } else {
          if (event.target.closest('.engraving-section')) {
            element.setAttribute('data-filled', 'filled');
          }
        }
      }


      previewSections.forEach(function (ps) {
        ps.classList.remove('active');
      })

      previewMainImage.forEach(function (pmi) {
        pmi.classList.remove('active')
      })

      if (element.closest('.bottle-section')) {
        bottleShowPreview();
      }
      else if (element.closest('.cap-section')) {
        capShowPreview();
      }
      else if (element.closest('.boot-section')) {
        bootShowPreview();
      }
      else if (element.closest('.loop-section')) {
        loopShowPreview();
      }

      // Toggle the 'active' class only if the above conditions are met
      element.classList.toggle('active');
    }
    updatePricing();
  });
});

// event listener for mobile tabs
mobileTabs.forEach(function (tab) {
  tab.addEventListener('change', function (t) {

    sliderNavButtons.forEach(function (nav) {
      nav.classList.remove('active');
      nav.classList.remove('hidden');
    })

    summaryContentMobile.forEach(function (mobileContent) {
      mobileContent.classList.remove('active');
    });

    previewSections.forEach(function (ps) {
      ps.classList.remove('active');
    });

    previewMainImage.forEach(function (pmi) {
      pmi.classList.remove('active')
    });

    if (t.target.id == "bottle-tab") {
      summaryBottleSectionMobile.classList.add('active');
      bottleShowPreview();
      summaryBottleSection.setAttribute('data-filled', 'filled');
    }
    else if (t.target.id == "cap-tab") {
      summaryCapSectionMobile.classList.add('active');
      capShowPreview();
      summaryCapSection.setAttribute('data-filled', 'filled');
    }
    else if (t.target.id == "loop-tab") {
      summaryLoopSectionMobile.classList.add('active');
      loopShowPreview();
      summaryLoopSection.setAttribute('data-filled', 'filled');
    }
    else if (t.target.id == "boot-tab") {
      summaryBootSectionMobile.classList.add('active');
      bootShowPreview();
      summaryBootSection.setAttribute('data-filled', 'filled');
    }
    else if (t.target.id == "engraving-tab") {
      summaryEngravingSectionMobile.classList.add('active');
      summaryEngravingSection.classList.add('active');
      summaryEngravingSection.setAttribute('data-filled', 'filled');
      engravingPlacement == '' ? (engravingPlacementMobile[0].checked = true, engravingPlacementMobile[0].dispatchEvent(changeEvent) ) : '';
    }
  })
});

function bottleShowPreview() {


  sliderNavButtons.forEach(function (nav) {
    nav.classList.remove('active');
    nav.classList.remove('hidden');
  })

  previewMainImage.forEach(function (pmi) {
    pmi.classList.remove('active')
  })
  previewSections.forEach(function (ps) {
    ps.classList.remove('active');
  });

  if (bottleSizeOption === '25oz') {
    bottlePreview.classList.add('active');
    bottlePreview32oz.classList.remove('active');
    bottlePreview30oz.classList.remove('active');
    bottlePreview16oz.classList.remove('active');
    checkAnimalObservatoryColor(bottleMain25oz ? bottleMain25oz : bottleRadios[0]);
  } 
  else if (bottleSizeOption === '32oz') {
    bottlePreview32oz.classList.add('active');
    bottlePreview.classList.remove('active');
    bottlePreview30oz.classList.remove('active');
    bottlePreview16oz.classList.remove('active');
    checkAnimalObservatoryColor(bottleMain32oz ? bottleMain32oz : bottleRadios32oz[0]);
  } 
  else if (bottleSizeOption === '30oz') {
    bottlePreview30oz.classList.add('active');
    bottlePreview.classList.remove('active');
    bottlePreview32oz.classList.remove('active');
    bottlePreview16oz.classList.remove('active');
    checkAnimalObservatoryColor(bottleMain30oz ? bottleMain30oz : bottleRadios30oz[0]);
  }
  else if (bottleSizeOption === '16oz') {
    bottlePreview32oz.classList.remove('active');
    bottlePreview.classList.remove('active');
    bottlePreview30oz.classList.remove('active');
    bottlePreview16oz.classList.add('active');
    checkAnimalObservatoryColor(bottleMain16oz ? bottleMain16oz : bottleRadios16oz[0]);
  }

  bottleImage.parentElement.parentElement.classList.add('active');
  bottlePreview.setAttribute('data-filled', 'filled');
  bottlePreview32oz.setAttribute('data-filled', 'filled');
  bottlePreview30oz.setAttribute('data-filled', 'filled');
  if(bottleSizeOption == '25oz' || bottleSizeOption == '30oz' || bottleSizeOption == '16oz'){
    bottleNext.classList.add('active');
    bottlePrevious.classList.add('active');
    bottleNext.classList.remove('hidden');
    bottlePrevious.classList.remove('hidden');

    bottleNext32oz.classList.remove('active');
    bottlePrevious32oz.classList.remove('active');
  }
  else{
    bottleNext.classList.remove('active');
    bottlePrevious.classList.remove('active');
    bottleNext.classList.remove('active');
    bottlePrevious.classList.remove('active');

    bottleNext32oz.classList.add('active');
    bottlePrevious32oz.classList.add('active');
    bottleNext32oz.classList.remove('hidden');
    bottlePrevious32oz.classList.remove('hidden');
  }
}
function capShowPreview(clickFromMain) {
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  if(customizationMain.dataset.capType == 'robo'){
    if (bottleSizeOption === "25oz") {
      robocapPreview.classList.add('active');
      checkAnimalObservatoryColor(robocapMain25oz ? robocapMain25oz : robocapRadios[0]);
    } else if (bottleSizeOption === "32oz") {
      robocapPreview32oz.classList.add('active');
      checkAnimalObservatoryColor(robocapMain32oz ? robocapMain32oz : robocapRadios[0]);
    } else if (bottleSizeOption === "30oz") {
      robocapPreview30oz.classList.add('active');
      checkAnimalObservatoryColor(robocapMain30oz ? robocapMain30oz : robocapRadios30oz[0]);
    } else if (bottleSizeOption === "16oz") {
      robocapPreview16oz.classList.add('active');
      checkAnimalObservatoryColor(robocapMain16oz ? robocapMain16oz : robocapRadios[0]);
    }
  } else if(customizationMain.dataset.capType == 'bubble'){
    if (bottleSizeOption === "25oz") {
      bubblecapPreview.classList.add('active');
      checkAnimalObservatoryColor(bubblecapMain25oz ? bubblecapMain25oz : bubblecapRadios[0]);
    } else if (bottleSizeOption === "32oz") {
      bubblecapPreview32oz.classList.add('active');
      checkAnimalObservatoryColor(bubblecapMain32oz ? bubblecapMain32oz : bubblecapRadios[0]);
    } else if (bottleSizeOption === "30oz") {
      bubblecapPreview30oz.classList.add('active');
      checkAnimalObservatoryColor(bubblecapMain30oz ? bubblecapMain30oz : bubblecapRadios30oz[0]);
    } else if (bottleSizeOption === "16oz") {
      bubblecapPreview16oz.classList.add('active');
      checkAnimalObservatoryColor(bubblecapMain16oz ? bubblecapMain16oz : bubblecapRadios[0]);
    }
  }
  else{
    if (bottleSizeOption === "25oz") {
      capPreview.classList.add('active');
      checkAnimalObservatoryColor(capMain25oz ? capMain25oz : capRadios[0]);
    } else if (bottleSizeOption === "32oz") {
      capPreview32oz.classList.add('active');
      checkAnimalObservatoryColor(capMain32oz ? capMain32oz : capRadios[0]);
    } else if (bottleSizeOption === "30oz") {
      capPreview30oz.classList.add('active');
      checkAnimalObservatoryColor(capMain30oz ? capMain30oz : capRadios30oz[0]);
    } else if (bottleSizeOption === "16oz") {
      capPreview16oz.classList.add('active');
      checkAnimalObservatoryColor(capMain16oz ? capMain16oz : capRadios[0]);
    } 
  }

  const capSection = document.querySelector('.summary-content.cap-section');

  capSection.querySelectorAll('.cap-type-options').forEach(section => {
    if (document.querySelector('.flask-customization-main').dataset.capType == 'robo') {
      section.querySelectorAll('input[type="radio"]')[1].checked = true;
      section.querySelectorAll('input[type="radio"]')[1].dispatchEvent(changeEvent);
    }
    else if(document.querySelector('.flask-customization-main').dataset.capType == 'bubble'){
      section.querySelectorAll('input[type="radio"]')[2].checked = true;
      section.querySelectorAll('input[type="radio"]')[2].dispatchEvent(changeEvent);
    }
    else{
      section.querySelectorAll('input[type="radio"]')[0].checked = true;
      section.querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
    }
  });


    if(capSection.dataset.filled != 'filled'){
      capSection.querySelectorAll('.color-section').forEach(section => {
        section.querySelector('input[type="radio"]').checked = true;
        section.querySelector('input[type="radio"]').dispatchEvent(changeEvent);
      });
    }

    capImage.parentElement.parentElement.classList.add('active');
    capPreview.setAttribute('data-filled', 'filled');
    capPreview32oz.setAttribute('data-filled', 'filled');
    capPreview30oz.setAttribute('data-filled', 'filled');
    capPreview16oz.setAttribute('data-filled', 'filled'); 
    robocapPreview.setAttribute('data-filled', 'filled');
    robocapPreview32oz.setAttribute('data-filled', 'filled');
    robocapPreview30oz.setAttribute('data-filled', 'filled');
    robocapPreview16oz.setAttribute('data-filled', 'filled');
    bubblecapPreview.setAttribute('data-filled', 'filled');
    bubblecapPreview32oz.setAttribute('data-filled', 'filled');
    bubblecapPreview30oz.setAttribute('data-filled', 'filled');
    bubblecapPreview16oz.setAttribute('data-filled', 'filled');
    capNext.classList.add('active');
    capPrevious.classList.add('active');
    // robocapNext.classList.add('active');
    // robocapPrevious.classList.add('active');
    if(!clickFromMain){
      if(window.innerWidth > 899){
        if(capBundleVariantID.length < 1){
          if(capType == 'pebble'){
          for (const [index, e] of capRadios.entries()) {
            if (!e.classList.contains('disabled')) {
              capRadios[index].dispatchEvent(changeEvent)
              break;
            }
          }
        }
        else if(capType == 'bubble'){
          for (const [index, e] of bubblecapRadios.entries()) {
            if (!e.classList.contains('disabled')) {
              bubblecapRadios[index].dispatchEvent(changeEvent)
              break;
            }
          }
        }
        else{
          for (const [index, e] of robocapRadios.entries()) {
            if (!e.classList.contains('disabled')) {
              robocapRadios[index].dispatchEvent(changeEvent)
              break;
            }
          }
        }
      }
    }
  }
}

function loopShowPreview(clickFromMain) {
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  if(document.querySelector('.flask-customization-main').dataset.capType == 'robo'){
    if (bottleSizeOption === "25oz") {
      connectorPreview.classList.add('active');
      checkAnimalObservatoryColor(connectorMain25oz ? connectorMain25oz : connectorRadios[0]);
    } 
    else if (bottleSizeOption === "32oz") {
      connectorPreview32oz.classList.add('active');
      checkAnimalObservatoryColor(connectorMain32oz ? connectorMain32oz : connectorRadios[0]);
    }
    else if (bottleSizeOption === "30oz") {
      connectorPreview30oz.classList.add('active');
      checkAnimalObservatoryColor(connectorMain30oz ? connectorMain30oz : connectorRadios[0]);
    }
    else if (bottleSizeOption === "16oz") {
      connectorPreview16oz.classList.add('active');
      checkAnimalObservatoryColor(connectorMain16oz ? connectorMain16oz : connectorRadios[0]);
    }
  }
  else if(document.querySelector('.flask-customization-main').dataset.capType == 'bubble'){
    if (bottleSizeOption === "25oz") {
      bandPreview.classList.add('active');
      checkAnimalObservatoryColor(bandMain25oz ? bandMain25oz : bandRadios[0]);
    }
    else if (bottleSizeOption === "32oz") {
      bandPreview32oz.classList.add('active');
      checkAnimalObservatoryColor(bandMain32oz ? bandMain32oz : bandRadios[0]);
    }
    else if (bottleSizeOption === "30oz") {
      bandPreview30oz.classList.add('active');
      checkAnimalObservatoryColor(bandMain30oz ? bandMain30oz : bandRadios[0]);
    }
    else if (bottleSizeOption === "16oz") {
      bandPreview16oz.classList.add('active');
      checkAnimalObservatoryColor(bandMain16oz ? bandMain16oz : bandRadios[0]);
    }
  }
  else{
    if (bottleSizeOption === "25oz") {
      loopPreview.classList.add('active');
      checkAnimalObservatoryColor(loopMain25oz ? loopMain25oz : loopRadios[0]);
    } 
    else if (bottleSizeOption === "32oz") {
      loopPreview32oz.classList.add('active');
      checkAnimalObservatoryColor(loopMain32oz ? loopMain32oz : loopRadios[0]);
    }
    else if (bottleSizeOption === "30oz") {
      loopPreview30oz.classList.add('active');
      checkAnimalObservatoryColor(loopMain30oz ? loopMain30oz : loopRadios30oz[0]);
    }
    else if (bottleSizeOption === "16oz") {
      loopPreview16oz.classList.add('active');
      checkAnimalObservatoryColor(loopMain16oz ? loopMain16oz : loopRadios[0]);
    }
  }

  const loopSection = document.querySelector('.summary-content.loop-section');
  if(loopSection.dataset.filled != 'filled'){
    loopSection.querySelectorAll('.color-section').forEach(section => {
      section.querySelector('input[type="radio"]').checked = true;
      section.querySelector('input[type="radio"]').dispatchEvent(changeEvent);
    });
  }

  loopImage.parentElement.parentElement.classList.add('active');
  loopPreview32oz.setAttribute('data-filled', 'filled');
  loopPreview30oz.setAttribute('data-filled', 'filled');
  loopPreview16oz.setAttribute('data-filled', 'filled');
  loopPreview.setAttribute('data-filled', 'filled');
  bandPreview.setAttribute('data-filled', 'filled');
  bandPreview32oz.setAttribute('data-filled', 'filled');
  bandPreview30oz.setAttribute('data-filled', 'filled');
  bandPreview16oz.setAttribute('data-filled', 'filled');
  connectorPreview32oz.setAttribute('data-filled', 'filled');
  connectorPreview30oz.setAttribute('data-filled', 'filled');
  connectorPreview16oz.setAttribute('data-filled', 'filled');
  connectorPreview.setAttribute('data-filled', 'filled');
  loopNext.classList.add('active');
  loopPrevious.classList.add('active');
  loopNext.classList.remove('hidden');
  loopPrevious.classList.remove('hidden');
  if(!clickFromMain){
    if(window.innerWidth > 899){
      if(loopBundleVariantID.length < 1){
        if(capType == 'pebble'){
        for (const [index, e] of loopRadios.entries()) {
          if (!e.classList.contains('disabled')) {
            loopRadios[index].dispatchEvent(changeEvent)
            break;
          }
        }
      }
      else if(capType == 'bubble'){
        for (const [index, e] of bandRadios.entries()) {
          if (!e.classList.contains('disabled')) {
            bandRadios[index].dispatchEvent(changeEvent)
            break;
          }
        }
      }
      else{
        for (const [index, e] of connectorRadios.entries()) {
          if (!e.classList.contains('disabled')) {
            connectorRadios[index].dispatchEvent(changeEvent)
            break;
            }
          }
        }
      }
    }
  }
}

function bootShowPreview() {
  sliderNavButtons.forEach(function (nav) {
    nav.classList.remove('active');
    nav.classList.remove('hidden');
  })
  // previewSections.forEach(function (ps) {
  //   ps.classList.remove('active');
  // })
  if (withBoot) {
    bottlePreview.classList.remove('active');
    bottlePreview32oz.classList.remove('active');
    bottlePreview30oz.classList.remove('active');
    if (bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz') {
      bootPreview32oz.classList.remove('active');
      bootPreview30oz.classList.remove('active');
      bootPreview.classList.add('active');
      checkAnimalObservatoryColor(bootMain25oz ? bootMain25oz : document.querySelector('.boot_component_radio[data-value="25oz"]:checked'));
    }
    else {
      bootPreview.classList.remove('active');
      bootPreview30oz.classList.remove('active');
      bootPreview32oz.classList.add('active');
      checkAnimalObservatoryColor(bootMain32oz ? bootMain32oz : document.querySelector('.boot_component_radio[data-value="32oz"]:checked') ? document.querySelector('.boot_component_radio[data-value="32oz"]:checked') : document.querySelector('.boot_component_radio[data-value="32oz"]'));
    }
    bootImage.parentElement.parentElement.classList.add('active');
    bootPreview.setAttribute('data-filled', 'filled');
    bootPreview32oz.setAttribute('data-filled', 'filled');
    bootPreview30oz.setAttribute('data-filled', 'filled');
    bootNext.classList.add('active');
    bootPrevious.classList.add('active');
    bootNext.classList.remove('hidden');
    bootPrevious.classList.remove('hidden');

    if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
      bootNext.classList.add('active');
      bootPrevious.classList.add('active');
      bootNext.classList.remove('hidden');
      bootPrevious.classList.remove('hidden');
  
      bootNext32oz.classList.remove('active');
      bootPrevious32oz.classList.remove('active');
    }
    else{
      bootNext.classList.remove('active');
      bootPrevious.classList.remove('active');
  
      bootNext32oz.classList.add('active');
      bootPrevious32oz.classList.add('active');
      bootNext32oz.classList.remove('hidden');
      bootPrevious32oz.classList.remove('hidden');
    }
  }
  else {
    bootNext.classList.add('active');
    bootPrevious.classList.add('active');
    bootNext.classList.add('hidden');
    bootPrevious.classList.add('hidden');
    bootNext32oz.classList.add('active');
    bootPrevious32oz.classList.add('active');
    bootNext32oz.classList.add('hidden');
    bootPrevious32oz.classList.add('hidden');
  }
}

function isOutsideOptions(element) {
  return !element.closest('.summary-content_options .form') && !element.closest('.loop-choices') && !element.closest('.boot-choices') && !element.closest('.cap-type-options');
}

bottleSizeRadios.forEach(function (bottleSize){
  bottleSize.addEventListener('change', function(e){
    sizeUpdate(bottleSize);
  });
});
bottleSizeRadiosMobile.forEach(function (bottleSize){
  bottleSize.addEventListener('change', function(e){
    sizeUpdate(bottleSize);
  });
});

let sizeChanging = false;
function sizeUpdate(bottleSize){
  bottleSizeHolder = bottleSize;
  bottleSizeOption = bottleSize.dataset.name;
  
  
  bottleShowPreview();
  changeSize(bottleSize);
  
    if(bottleSizeOption == '25oz'){
    bottlePreview30oz.classList.remove('active');
    bottlePreview32oz.classList.remove('active');
    bottlePreview16oz.classList.remove('active');
    bottlePreview.classList.add('active');
    bottleSwiper.slideToLoop(bottleSwiper.realIndex, 0);
  }
  else if(bottleSizeOption == '32oz'){
    bottlePreview30oz.classList.remove('active');
    bottlePreview.classList.remove('active');
    bottlePreview16oz.classList.remove('active');
    bottlePreview32oz.classList.add('active');
    bottleSwiper32oz.slideToLoop(bottleSwiper32oz.realIndex, 0);
  }
  else if(bottleSizeOption == '16oz'){
    bottlePreview30oz.classList.remove('active');
    bottlePreview32oz.classList.remove('active');
    bottlePreview.classList.remove('active');
    bottlePreview16oz.classList.add('active');
    bottleSwiper16oz.slideToLoop(bottleSwiper16oz.realIndex, 0);
  }
  else if(bottleSizeOption == '30oz'){
    bottlePreview32oz.classList.remove('active');
    bottlePreview16oz.classList.remove('active');
    bottlePreview.classList.remove('active');
    bottlePreview30oz.classList.add('active');
    bottleSwiper30oz.slideToLoop(bottleSwiper30oz.realIndex, 0);
  }
  
}
function changeSize(bottleSize){
  // if(bottleSize.dataset.name == '25oz'){
  //   sizeChanging = false;
  // }else{
  //   sizeChanging = true
  // }
  previewMainImage.forEach(p => {
    // p.style.opacity = 0;
  })
  loopImage.style.opacity = 0;
  loopImage.style.transition = '0';
  capImage.style.opacity = 0;
  capImage.style.transition = '0';
  capPreview.style.zIndex = '30';
  capPreview32oz.style.zIndex = '30';
  capPreview16oz.style.zIndex = '30';
  robocapPreview.style.zIndex = '30';
  robocapPreview32oz.style.zIndex = '30';
  robocapPreview16oz.style.zIndex = '30';
  loopPreview.style.zIndex = '35';
  loopPreview32oz.style.zIndex = '35';
  loopPreview16oz.style.zIndex = '35';
  bootPreview.style.zIndex = '20';
  bootPreview32oz.style.zIndex = '20';

  document.querySelector('.preview-main').classList.add('animation')
  customizationMain.dataset.size = bottleSize.dataset.name;
  setTimeout(function(){
    document.querySelector('.preview-main').classList.remove('animation');
    previewMainImage.forEach(p => {
      p.style.opacity = '';
    })

    capPreview.style.zIndex = '';
    capPreview32oz.style.zIndex = '';
    capPreview16oz.style.zIndex = '';
    robocapPreview.style.zIndex = '';
    robocapPreview32oz.style.zIndex = '';
    robocapPreview16oz.style.zIndex = '';
    loopPreview.style.zIndex = '';
    loopPreview32oz.style.zIndex = '';
    loopPreview16oz.style.zIndex = '';
    bootPreview.style.zIndex = '';
    bootPreview32oz.style.zIndex = '';
  }, 0);

  document.querySelectorAll('#bottle-size-text').forEach(e => { e.innerText = bottleSizeOption; })
  const capType = customizationMain.dataset.capType;
  if(bottleSizeOption == '25oz'){
    capType == 'robo' ? updateroboCapSummary(robocapMain25oz) : capType == 'bubble' ? updateBubblecapSummary(bubblecapMain25oz) : updateCapSummary(capMain25oz);
    capType == 'robo' ? updateConnectorSummary(connectorMain25oz) : capType == 'bubble' ? updateBandSummary(bandMain25oz) : updateLoopSummary(loopMain25oz);
  }
  else if(bottleSizeOption == '32oz'){
    capType == 'robo' ? updateroboCapSummary(robocapMain32oz) : capType == 'bubble' ? updateBubblecapSummary(bubblecapMain32oz) : updateCapSummary(capMain32oz);
    capType == 'robo' ? updateConnectorSummary(connectorMain32oz) : capType == 'bubble' ? updateBandSummary(bandMain32oz) : updateLoopSummary(loopMain32oz);
  }
  else if(bottleSizeOption == '16oz'){
    capType == 'robo' ? updateroboCapSummary(robocapMain16oz) : capType == 'bubble' ? updateBubblecapSummary(bubblecapMain16oz) : updateCapSummary(capMain16oz);
    capType == 'robo' ? updateConnectorSummary(connectorMain16oz) : capType == 'bubble' ? updateBandSummary(bandMain16oz) : updateLoopSummary(loopMain16oz);
  }
  else if(bottleSizeOption == '30oz'){
    capType == 'robo' ? updateroboCapSummary(robocapMain30oz) : capType == 'bubble' ? updateBubblecapSummary(bubblecapMain30oz) : updateCapSummary(capMain30oz);
    capType == 'robo' ? updateConnectorSummary(connectorMain30oz) : capType == 'bubble' ? updateBandSummary(bandMain30oz) : updateLoopSummary(loopMain30oz);
  }

  
  bootPreview.classList.remove('active'), bootPreview32oz.classList.remove('active');
  if (withBoot) {
    if (bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz') {
      updateBootSummary(bootMain25oz ? bootMain25oz : document.querySelector('.boot_component_radio[data-value="25oz"]:checked') );
      checkBootAvailability(bootMain25oz ? bootMain25oz : document.querySelector('.boot_component_radio[data-value="25oz"]:checked') );
      setTimeout(scrollSummarySectionDown, 1000);
    } else {
      updateBootSummary(bootMain32oz ? bootMain32oz : document.querySelector('.boot_component_radio[data-value="32oz"]:checked') ? document.querySelector('.boot_component_radio[data-value="32oz"]:checked') : document.querySelector('.boot_component_radio[data-value="32oz"]') );
      checkBootAvailability(bootMain32oz ? bootMain32oz : document.querySelector('.boot_component_radio[data-value="32oz"]:checked') ? document.querySelector('.boot_component_radio[data-value="32oz"]:checked') : document.querySelector('.boot_component_radio[data-value="32oz"]') ); 
      setTimeout(scrollSummarySectionDown, 1000);
    }
  }


  previewMainImage.forEach(function (pmi) {
    pmi.classList.remove('active')
  })

  previewSections.forEach(function (ps) {
    ps.classList.remove('active');
  })
  // updateBoot();
  if (bottleSizeOption === '25oz') {
    let backupBottleMain25oz = bottleMain25oz ? bottleMain25oz : bottleSwiper.slides[bottleSwiper.activeIndex];
    if(backupBottleMain25oz.classList.contains('disabled')){
      checkBottle(firstAvailableBottle25oz.dataset.name);
      backupBottleMain25oz = firstAvailableBottle25oz;
    }
    updateBottleSummary(backupBottleMain25oz);
    checkBottleAvailability(backupBottleMain25oz);  
  } else if (bottleSizeOption === '32oz') {
    let backupBottleMain32oz = bottleMain32oz ? bottleMain32oz : bottleSwiper32oz.slides[bottleSwiper32oz.activeIndex];
    if(backupBottleMain32oz.classList.contains('disabled')){
      checkBottle(firstAvailableBottle32oz.dataset.name);
      backupBottleMain32oz = firstAvailableBottle32oz;
    }
    updateBottleSummary(backupBottleMain32oz);
    checkBottleAvailability(backupBottleMain32oz);
  } else if (bottleSizeOption === '16oz') {
    
    let backupBottleMain16oz = bottleMain16oz ? bottleMain16oz : bottleSwiper16oz.slides[bottleSwiper16oz.activeIndex];
    if(backupBottleMain16oz.classList.contains('disabled')){
      checkBottle(firstAvailableBottle16oz.dataset.name);
      backupBottleMain16oz = firstAvailableBottle16oz;  
    }
    updateBottleSummary(backupBottleMain16oz);
    checkBottleAvailability(backupBottleMain16oz);
  } else if (bottleSizeOption === '30oz') {

    let backupBottleMain30ozz = bottleMain30oz ? bottleMain30oz : bottleSwiper30oz.slides[bottleSwiper30oz.activeIndex];
    if(backupBottleMain30ozz.classList.contains('disabled')){
      checkBottle(firstAvailableBottle30oz.dataset.name);
      backupBottleMain30ozz = firstAvailableBottle30oz;
    }
    updateBottleSummary(backupBottleMain30ozz);
    checkBottleAvailability(backupBottleMain30ozz);
  }
  
    bottleShowPreview()

    // updateBoot();
    if(bootSection.classList.contains('active') || document.querySelector('#boot-tab').checked){
      bootShowPreview();
    }
    else{

      bottleShowPreview()
    }

  setTimeout(() => {
    loopImage.style.transition = 'opacity 0.1s linear';
    loopImage.style.opacity = 1;
    capImage.style.transition = 'opacity 0.1s linear';
    capImage.style.opacity = 1;
  }, 0);
    // bootSection.classList.contains('active') || document.querySelector('#boot-tab').checked ? bootShowPreview() : (bottleShowPreview(), bottleSizeOption == '25oz' ? updateBottleSummary(bottleMain25oz) : updateBottleSummary(bottleMain32oz));
  updatePricing();
}



// event listener for bottle section radios
bottleRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
      bottleRadioUpdate(element);
      updatePricing();
  });
});

bottleRadiosMobile.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bottleRadioUpdate(element);
    updatePricing();
    element.classList.contains('disabled') ? scrollDownIfOOS(true) :  scrollDownIfOOS(false);
  });
});

bottleRadios32oz.forEach(function (element) {
  element.addEventListener('change', function (e) {

    bottleRadioUpdate(element);
    updatePricing();
  });
});

bottleRadiosMobile32oz.forEach(function (element) {
  element.addEventListener('change', function (e) {

    bottleRadioUpdate(element);
    updatePricing();
    element.classList.contains('disabled') ?  scrollDownIfOOS(true) :  scrollDownIfOOS(false);
  });
});

bottleRadios16oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bottleRadioUpdate(element);
    updatePricing();
  });
});

bottleRadiosMobile16oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bottleRadioUpdate(element);
    updatePricing();
    element.classList.contains('disabled') ?  scrollDownIfOOS(true) :  scrollDownIfOOS(false);
  });
});

bottleRadios30oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bottleRadioUpdate(element);
    updatePricing();
  });
});

bottleRadiosMobile30oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bottleRadioUpdate(element);
    updatePricing();
    element.classList.contains('disabled') ?  scrollDownIfOOS(true) : scrollDownIfOOS(false);
  });
});

let bottleIndex = 0;
function bottleRadioUpdate(element) {
  const currentIndex = parseInt(element.dataset.slider_index);
  if(currentIndex > bottleIndex + 5 || currentIndex < bottleIndex - 5){
    animationSpeed = 1000;
  }
  bottleIndex = parseInt(element.dataset.slider_index);
  customizationMain.classList.contains('show') ? (bottleSlideToPreview('data-name', element.dataset.name)) : (bottleSlideToPreview('data-name', element.dataset.name));
  animationSpeed = 300;
  updateBottleSummary(element);
  checkColor(element.dataset.variant_color);
  checkBottleAvailability(element);

}

function updateBottleSummary(value) {
  var bottle;
  bottleSizeOption == '25oz' ? bottle = bottleRadios[0] : bottleSizeOption == '32oz' ? bottle = bottleRadios32oz[0] : bottleSizeOption == '30oz' ? bottle = bottleRadios30oz[0] : bottle = bottleRadios16oz[0];
  const element = value ? value : bottle;
    checkAnimalObservatoryColor(bottleSizeOption == '16oz' ? bottleMain16oz ? bottleMain16oz : element : element);
  const name = element.dataset.name;
  const background = element.dataset.background;
  const mode = element.getAttribute('dark-text-mode');
  const image = element.dataset.image;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  let textColor;
  let backgroundColor;
  if(element.classList.contains('no_engraving')){
    customizationMain.classList.add('no_engraving');
  }
  else{
    customizationMain.classList.remove('no_engraving');
  }
  element.dataset.colorType == "limited" 
    ? (
    bottleColorTextLimited.innerText = name, 
    bottleColorTextClassic.innerText = "", 
    bottleColorTextLimitedMobile.innerText = name, 
    bottleColorTextClassicMobile.innerText = "",
    bottleColorTextLimited32oz.innerText = name, 
    bottleColorTextClassic32oz.innerText = "", 
    bottleColorTextLimitedMobile32oz.innerText = name, 
    bottleColorTextClassicMobile32oz.innerText = "",
    bottleColorTextLimited30oz.innerText = name, 
    bottleColorTextClassic30oz.innerText = "", 
    bottleColorTextLimitedMobile30oz.innerText = name, 
    bottleColorTextClassicMobile30oz.innerText = "",
    bottleColorTextLimited16oz.innerText = name, 
    bottleColorTextClassic16oz.innerText = "", 
    bottleColorTextLimitedMobile16oz.innerText = name, 
    bottleColorTextClassicMobile16oz.innerText = "",
    summaryBottleSection.setAttribute('color_type', 'limited'))
    : element.dataset.colorType == "animal"
    ? (
    bottleColorTextLimited.innerText = "", 
    bottleColorTextClassic.innerText = "", 
    bottleColorTextLimitedMobile.innerText = "", 
    bottleColorTextClassicMobile.innerText = "",
    bottleColorTextLimited32oz.innerText = "", 
    bottleColorTextClassic32oz.innerText = "", 
    bottleColorTextLimitedMobile32oz.innerText = "", 
    bottleColorTextClassicMobile32oz.innerText = "",
    bottleColorTextLimited16oz.innerText = "", 
    bottleColorTextClassic16oz.innerText = "", 
    bottleColorTextAnimal16oz.innerText = name,
    bottleColorTextLimitedMobile16oz.innerText = "", 
    bottleColorTextClassicMobile16oz.innerText = "",
    bottleColorTextAnimalMobile16oz.innerText = name,
    summaryBottleSection.setAttribute('color_type', 'animal'))
    : (
    bottleColorTextLimited.innerText = '', 
    bottleColorTextClassic.innerText = name, 
    bottleColorTextLimitedMobile.innerText = '', 
    bottleColorTextClassicMobile.innerText = name, 
    bottleColorTextLimited32oz.innerText = '', 
    bottleColorTextClassic32oz.innerText = name, 
    bottleColorTextLimitedMobile32oz.innerText = '', 
    bottleColorTextClassicMobile32oz.innerText = name, 
    bottleColorTextLimited30oz.innerText = '', 
    bottleColorTextClassic30oz.innerText = name, 
    bottleColorTextLimitedMobile30oz.innerText = '', 
    bottleColorTextClassicMobile30oz.innerText = name, 
    bottleColorTextLimited16oz.innerText = '', 
    bottleColorTextClassic16oz.innerText = name, 
    bottleColorTextAnimal16oz.innerText = "",
    bottleColorTextLimitedMobile16oz.innerText = '', 
    bottleColorTextClassicMobile16oz.innerText = name, 
    bottleColorTextAnimalMobile16oz.innerText = "",
    summaryBottleSection.setAttribute('color_type', 'classic'));
  chosenBottle = name;
  if (mode == 'true') {
    engravingColor = 'dark';

  } else {
    engravingColor = 'light';
  }
  previewEngraving.setAttribute('data-text_color', engravingColor);
  popupEngraving.setAttribute('data-text_color', engravingColor);

  if (background != '') {
    backgroundColor = background;
  }
  else if (background == '') {
    backgroundColor = '#ffffff';
    textColor = '#352b27'
  }
  changeBackground(backgroundColor, textColor);
  bottlePreview.setAttribute('data-filled', 'filled');
  bottlePreview32oz.setAttribute('data-filled', 'filled');
  bottlePreview30oz.setAttribute('data-filled', 'filled');
  bottlePreview16oz.setAttribute('data-filled', 'filled');
  bottleImage.src = element.dataset.image;
  popupBottleImage.src = element.dataset.image;
  bottleBundleVariantID = bundleVariantID;
  bottleIndividualVariantID = singleVariantID;
  bottleBundleVariantID32oz = bundleVariantID;
  bottleIndividualVariantID32oz = singleVariantID;
  bottleBundleVariantID30oz = bundleVariantID;
  bottleIndividualVariantID30oz = singleVariantID;
  bottleInventory = {
    variantID: bundleVariantID,
    variantQuantity: element.dataset.item_count
  }
}

// change background and text on bottle change
function changeBackground(backgroundColor, textColor) {
  customizationMain.style.setProperty('--background-color', backgroundColor);
}

  let capIndex = 0;
// event listener for cap section radios
capRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if(currentIndex > capIndex + 5 || currentIndex < capIndex - 5){
      animationSpeed = 1000;
    }
    capIndex = currentIndex;
    capSlideToPreview(element.dataset.slider_index);
    const image = bottleSizeOption == '25oz' ? element.dataset.image : element.dataset.image_32oz ? element.dataset.image_32oz : '';
    updateCapSummary(element);
    const capType = document.querySelector('.flask-customization-main').dataset.capType;
    capType == 'robo' ? '' : checkCapAvailability(element);
    updatePricing();
    animationSpeed = 300;
  })
});

capRadiosMobile.forEach(function (element) {
  element.addEventListener('change', function (e) {
    capSlideToPreview(element.dataset.slider_index);
    const image = bottleSizeOption == '25oz' ? element.dataset.image : element.dataset.image_32oz ? element.dataset.image_32oz : '';
    updateCapSummary(element);
    element.classList.contains('disabled') ?  scrollDownIfOOS(true) :  scrollDownIfOOS(false);
    const capType = document.querySelector('.flask-customization-main').dataset.capType;
    capType == 'robo' ? '' : checkCapAvailability(element);
    updatePricing();
  })
});

function updateCapSummary(value) {
  const element = value ? value : capRadios[0];
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  element.dataset.colorType == "limited" ? (capColorTextLimited.innerText = name, capColorTextClassic.innerText = "", summaryCapSection.setAttribute('color_type', 'limited')) : (capColorTextLimited.innerText = '', capColorTextClassic.innerText = name, summaryCapSection.setAttribute('color_type', 'classic'))
  element.dataset.colorType == "limited" ? (capColorTextLimitedMobile.innerText = name, capColorTextClassicMobile.innerText = "", summaryCapSection.setAttribute('color_type', 'limited')) : (capColorTextLimitedMobile.innerText = '', capColorTextClassicMobile.innerText = name, summaryCapSection.setAttribute('color_type', 'classic'));
  chosenCap = name;
  if(bottleSizeOption == '25oz'){
    capPreview.setAttribute('data-filled', 'filled');
    capPreview32oz.setAttribute('data-filled', '');
    capPreview16oz.setAttribute('data-filled', '');
    capType == 'robo' ? '' : capImage.src = image;
    popupCapImage.src = image;
  }
  else if(bottleSizeOption == '32oz'){
    capPreview32oz.setAttribute('data-filled', 'filled');
    capPreview.setAttribute('data-filled', '');
    capPreview16oz.setAttribute('data-filled', '');
    capType == 'robo' ? '' : capImage.src = image_32oz;
    popupCapImage.src = image_32oz;
  }
  else if(bottleSizeOption == '16oz'){
    capPreview16oz.setAttribute('data-filled', 'filled');
    capPreview.setAttribute('data-filled', '');
    capPreview32oz.setAttribute('data-filled', '');
    capType == 'robo' ? '' : capImage.src = image_16oz;
    popupCapImage.src = image_16oz;
  }
  else if(bottleSizeOption == '30oz'){
    capPreview30oz.setAttribute('data-filled', 'filled');
    capPreview.setAttribute('data-filled', '');
    capPreview32oz.setAttribute('data-filled', '');
    capPreview16oz.setAttribute('data-filled', '');
    capType == 'robo' ? '' : capImage.src = image_30oz;
    popupCapImage.src = image_30oz;
  }
  // capImage.src = bottleSizeOption == '25oz' ? image : image_32oz;
  // popupCapImage.src = bottleSizeOption == '25oz' ? image : image_32oz;
  capType == 'robo' ? capBundleVariantID = '' : capBundleVariantID = bundleVariantID;
  capType == 'robo' ? capIndividualVariantID = '' : capIndividualVariantID = singleVariantID;
  capType == 'robo' ? capInventory = '' : capInventory = {
    variantID: bundleVariantID,
    variantQuantity: element.dataset.item_count
  }
  updatePricing();
}


let robocapIndex = 0;
// event listener for robocap section radios
robocapRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if(currentIndex > robocapIndex + 5 || currentIndex < robocapIndex - 5){
      animationSpeed = 1000;
    }
    robocapIndex = currentIndex;
    robocapSlideToPreview(element.dataset.slider_index);
    const image = bottleSizeOption == '25oz' ? element.dataset.image : element.dataset.image_32oz ? element.dataset.image_32oz : '';
    updateroboCapSummary(element);
    const capType = document.querySelector('.flask-customization-main').dataset.capType;
    capType == 'robo' ? checkroboCapAvailability(element) : '';
    updatePricing();
    animationSpeed = 300;
  })
});

robocapRadiosMobile.forEach(function (element) {
  element.addEventListener('change', function (e) {
    robocapSlideToPreview(element.dataset.slider_index);
    const image = bottleSizeOption == '25oz' ? element.dataset.image : element.dataset.image_32oz ? element.dataset.image_32oz : '';
    updateroboCapSummary(element);
    element.classList.contains('disabled') ?  scrollDownIfOOS(true) :  scrollDownIfOOS(false);
    const capType = document.querySelector('.flask-customization-main').dataset.capType;
    capType == 'robo' ? checkroboCapAvailability(element) : '';
    updatePricing();
  })
});

// event listener for bubblecap section radios
let bubblecapIndex = 0;
bubblecapRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if(currentIndex > bubblecapIndex + 5 || currentIndex < bubblecapIndex - 5){
      animationSpeed = 1000;
    }
    bubblecapIndex = currentIndex;
    bubblecapSlideToPreview(element.dataset.slider_index);
    const image = bottleSizeOption == '25oz' ? element.dataset.image : element.dataset.image_32oz ? element.dataset.image_32oz : '';
    updateBubblecapSummary(element);
    const capType = document.querySelector('.flask-customization-main').dataset.capType;
    capType == 'bubble' ? checkBubbleAvailability(element) : '';
    updatePricing();
    animationSpeed = 300;
  })
});

bubblecapRadiosMobile.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bubblecapSlideToPreview(element.dataset.slider_index);
    const image = bottleSizeOption == '25oz' ? element.dataset.image : element.dataset.image_32oz ? element.dataset.image_32oz : '';
    updateBubblecapSummary(element);
    element.classList.contains('disabled') ?  scrollDownIfOOS(true) :  scrollDownIfOOS(false);
    const capType = document.querySelector('.flask-customization-main').dataset.capType;
    capType == 'bubble' ? checkBubbleAvailability(element) : '';
    updatePricing();
  })
});

function updateroboCapSummary(value) {
  const element = value ? value : robocapRadios[0];
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  element.dataset.colorType == "limited" ? (robocapColorTextLimited.innerText = name, robocapColorTextClassic.innerText = "", robocapColorTextAnimal.innerText = "", summaryCapSection.setAttribute('color_type', 'limited')) : element.dataset.colorType == "animal" ? (robocapColorTextLimited.innerText = "", robocapColorTextClassic.innerText = "", robocapColorTextAnimal.innerText = name, summaryCapSection.setAttribute('color_type', 'animal')) : (robocapColorTextLimited.innerText = '', robocapColorTextClassic.innerText = name, robocapColorTextAnimal.innerText = "", summaryCapSection.setAttribute('color_type', 'classic'))
  element.dataset.colorType == "limited" ? (robocapColorTextLimitedMobile.innerText = name, robocapColorTextClassicMobile.innerText = "", robocapColorTextAnimalMobile.innerText = "", summaryCapSection.setAttribute('color_type', 'limited')) : element.dataset.colorType == "animal" ? (robocapColorTextLimitedMobile.innerText = "", robocapColorTextClassicMobile.innerText = "", robocapColorTextAnimalMobile.innerText = name, summaryCapSection.setAttribute('color_type', 'animal')) : (robocapColorTextLimitedMobile.innerText = '', robocapColorTextClassicMobile.innerText = name, robocapColorTextAnimalMobile.innerText = "", summaryCapSection.setAttribute('color_type', 'classic'));


  if(bottleSizeOption == '16oz'){
    checkAnimalObservatoryColor(robocapMain16oz ? robocapMain16oz : element);
  }else if(bottleSizeOption == '25oz'){
    checkAnimalObservatoryColor(robocapMain25oz ? robocapMain25oz : element);
  }else if(bottleSizeOption == '32oz'){
    checkAnimalObservatoryColor(robocapMain32oz ? robocapMain32oz : element);
  }else if(bottleSizeOption == '30oz'){
    checkAnimalObservatoryColor(robocapMain30oz ? robocapMain30oz : element);
  }

  chosenCap = name;
  if(bottleSizeOption == '25oz'){
    robocapPreview.setAttribute('data-filled', 'filled');
    robocapPreview32oz.setAttribute('data-filled', '');
    robocapPreview16oz.setAttribute('data-filled', '');
    capType == 'robo' ? capImage.src = image : '';
    popupCapImage.src = image;
  }
  else if(bottleSizeOption == '32oz'){
    robocapPreview32oz.setAttribute('data-filled', 'filled');
    robocapPreview.setAttribute('data-filled', '');
    robocapPreview16oz.setAttribute('data-filled', '');
    capType == 'robo' ? capImage.src = image_32oz : '';
    popupCapImage.src = image_32oz;
  }
  else if(bottleSizeOption == '16oz'){
    robocapPreview16oz.setAttribute('data-filled', 'filled');
    robocapPreview.setAttribute('data-filled', '');
    robocapPreview32oz.setAttribute('data-filled', '');
    capType == 'robo' ? capImage.src = image_16oz : '';
    popupCapImage.src = image_16oz;
  }
  else if(bottleSizeOption == '30oz'){
    robocapPreview30oz.setAttribute('data-filled', 'filled');
    robocapPreview.setAttribute('data-filled', '');
    robocapPreview32oz.setAttribute('data-filled', '');
    robocapPreview16oz.setAttribute('data-filled', '');
    capType == 'robo' ? capImage.src = image_30oz : '';
    popupCapImage.src = image_30oz;
  }
  // capImage.src = bottleSizeOption == '25oz' ? image : image_32oz;
  // popupCapImage.src = bottleSizeOption == '25oz' ? image : image_32oz;
  capType == 'robo' ? capBundleVariantID = bundleVariantID : '';
  capType == 'robo' ? capIndividualVariantID = singleVariantID : '';
  capType == 'robo' ? capInventory = {
    variantID: bundleVariantID,
    variantQuantity: element.dataset.item_count
  } : '';
  updatePricing();
}

function updateBubblecapSummary(value) {
  const element = value ? value : bubblecapRadios[0];
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  element.dataset.colorType == "limited" ? (bubblecapColorTextLimited.innerText = name, bubblecapColorTextClassic.innerText = "", bubblecapColorTextAnimal.innerText = "", summaryCapSection.setAttribute('color_type', 'limited')) : element.dataset.colorType == "animal" ? (bubblecapColorTextLimited.innerText = "", bubblecapColorTextClassic.innerText = "", bubblecapColorTextAnimal.innerText = name, summaryCapSection.setAttribute('color_type', 'animal')) : (bubblecapColorTextLimited.innerText = '', bubblecapColorTextClassic.innerText = name, bubblecapColorTextAnimal.innerText = "", summaryCapSection.setAttribute('color_type', 'classic'))
  element.dataset.colorType == "limited" ? (bubblecapColorTextLimitedMobile.innerText = name, bubblecapColorTextClassicMobile.innerText = "", bubblecapColorTextAnimalMobile.innerText = "", summaryCapSection.setAttribute('color_type', 'limited')) : element.dataset.colorType == "animal" ? (bubblecapColorTextLimitedMobile.innerText = "", bubblecapColorTextClassicMobile.innerText = "", bubblecapColorTextAnimalMobile.innerText = name, summaryCapSection.setAttribute('color_type', 'animal')) : (bubblecapColorTextLimitedMobile.innerText = '', bubblecapColorTextClassicMobile.innerText = name, bubblecapColorTextAnimalMobile.innerText = "", summaryCapSection.setAttribute('color_type', 'classic'));

  if(document.querySelector('.bubblecap-preview.active'))
  if(bottleSizeOption == '16oz'){
    checkAnimalObservatoryColor(bubblecapMain16oz ? bubblecapMain16oz : element);
  }else if(bottleSizeOption == '25oz'){
    checkAnimalObservatoryColor(bubblecapMain25oz ? bubblecapMain25oz : element);
  }else if(bottleSizeOption == '32oz'){
    checkAnimalObservatoryColor(bubblecapMain32oz ? bubblecapMain32oz : element);
  }else if(bottleSizeOption == '30oz'){
    checkAnimalObservatoryColor(bubblecapMain30oz ? bubblecapMain30oz : element);
  }

  chosenCap = name;
  if(bottleSizeOption == '25oz'){
    bubblecapPreview.setAttribute('data-filled', 'filled');
    bubblecapPreview32oz.setAttribute('data-filled', '');
    bubblecapPreview16oz.setAttribute('data-filled', '');
    bubblecapPreview30oz.setAttribute('data-filled', '');
    capType == 'bubble' ? capImage.src = image : '';
    popupCapImage.src = image;
  }
  else if(bottleSizeOption == '32oz'){
    bubblecapPreview32oz.setAttribute('data-filled', 'filled');
    bubblecapPreview.setAttribute('data-filled', '');
    bubblecapPreview16oz.setAttribute('data-filled', '');
    bubblecapPreview30oz.setAttribute('data-filled', '');
    capType == 'bubble' ? capImage.src = image_32oz : '';
    popupCapImage.src = image_32oz;
  }
  else if(bottleSizeOption == '16oz'){
    bubblecapPreview16oz.setAttribute('data-filled', 'filled');
    bubblecapPreview.setAttribute('data-filled', '');
    bubblecapPreview32oz.setAttribute('data-filled', '');
    bubblecapPreview30oz.setAttribute('data-filled', '');
    capType == 'bubble' ? capImage.src = image_16oz : '';
    popupCapImage.src = image_16oz;
  }
  else if(bottleSizeOption == '30oz'){
    bubblecapPreview30oz.setAttribute('data-filled', 'filled');
    bubblecapPreview.setAttribute('data-filled', '');
    bubblecapPreview32oz.setAttribute('data-filled', '');
    bubblecapPreview16oz.setAttribute('data-filled', '');
    capType == 'bubble' ? capImage.src = image_30oz : '';
    popupCapImage.src = image_30oz;
  }

  capType == 'bubble' ? capBundleVariantID = bundleVariantID : '';
  capType == 'bubble' ? capIndividualVariantID = singleVariantID : '';
  capType == 'bubble' ? capInventory = {
    variantID: bundleVariantID,
    variantQuantity: element.dataset.item_count
  } : '';
  updatePricing();
}


// event listener for loop section radios
let loopIndex = 0;
loopRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if(currentIndex > loopIndex + 5 || currentIndex < loopIndex - 5){
      animationSpeed = 1000;
    }
    loopIndex = currentIndex;
    loopSlideToPreview(element.dataset.slider_index);
    updateLoopSummary(element);
    checkLoopAvailability(element);
    updatePricing();
    animationSpeed = 300;
  })
});

loopRadiosMobile.forEach(function (element) {
  element.addEventListener('change', function (e) {
    loopSlideToPreview(element.dataset.slider_index);
    updateLoopSummary(element);
    element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false);
    checkLoopAvailability(element);
    updatePricing();
  })
});

let loopColorType = null;
function updateLoopSummary(value) {
  const element = value ? value : loopRadios[0];
  loopColorType = element.dataset.colorType;
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const bundleVariantID = element.classList.contains('disabled') ? '' : element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = customizationMain.dataset.capType;

  if (element.dataset.colorType == "limited") {
      loopColorTextLimited.innerText = name;
      loopColorTextClassic.innerText = "";
      loopColorTextCharm.innerText = "";
      summaryLoopSection.setAttribute('color_type', 'limited');
      loopColorTextLimitedMobile.innerText = name;
      loopColorTextClassicMobile.innerText = "";
      loopColorTextCharmMobile.innerText = "";
  } 
  else if (element.dataset.colorType == 'charm') {
    loopColorTextLimited.innerText = "";
    loopColorTextClassic.innerText = "";
    loopColorTextCharm.innerText = name.replace('charm loop ','');
    summaryLoopSection.setAttribute('color_type', 'charm');
    loopColorTextLimitedMobile.innerText = "";
    loopColorTextCharmMobile.innerText = name.replace('charm loop ','');
    loopColorTextClassicMobile.innerText = "";
  }
  else {
      loopColorTextLimited.innerText = "";
      loopColorTextCharm.innerText = "";
      loopColorTextClassic.innerText = name;
      summaryLoopSection.setAttribute('color_type', 'classic');
      loopColorTextLimitedMobile.innerText = "";
      loopColorTextCharmMobile.innerText = "";
      loopColorTextClassicMobile.innerText = name;
  }

  chosenLoop = name;
  if(bottleSizeOption == '25oz'){
    loopPreview.setAttribute('data-filled', 'filled');
    loopPreview32oz.setAttribute('data-filled', '');
    loopPreview16oz.setAttribute('data-filled', '');
    capType == 'robo' ? '' : loopImage.src = image;
    popupLoopImage.src = image;
  }
  else if(bottleSizeOption == '32oz'){
    loopPreview32oz.setAttribute('data-filled', 'filled');
    loopPreview16oz.setAttribute('data-filled', '');
    loopPreview.setAttribute('data-filled', '');
    capType == 'robo' ? '' : loopImage.src = image_32oz;
    popupLoopImage.src = image_32oz;
  }
  else if(bottleSizeOption == '16oz'){
    loopPreview16oz.setAttribute('data-filled', 'filled');
    loopPreview32oz.setAttribute('data-filled', '');
    loopPreview.setAttribute('data-filled', '');
    capType == 'robo' ? '' : loopImage.src = image_16oz;
    popupLoopImage.src = image_16oz;
  }
  else if(bottleSizeOption == '30oz'){
    loopPreview30oz.setAttribute('data-filled', 'filled');
    loopPreview32oz.setAttribute('data-filled', '');
    loopPreview16oz.setAttribute('data-filled', '');
    loopPreview.setAttribute('data-filled', '');
    capType == 'robo' ? '' : loopImage.src = image_30oz;
    popupLoopImage.src = image_30oz;
  }
  // loopImage.src = bottleSizeOption == '25oz' ? image : image_32oz;
  // popupLoopImage.src = bottleSizeOption == '25oz' ? image : image_32oz;
    if(capType == 'pebble'){
      if (withLoop) {
        loopBundleVariantID = bundleVariantID;
        loopIndividualVariantID = singleVariantID;
        loopInventory = {
          variantID: bundleVariantID,
          variantQuantity: element.dataset.item_count
        }
      }
  }
  updatePricing();

}


// event listener for connector section radios

let connectorIndex = 0;
connectorRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if(currentIndex > connectorIndex + 5 || currentIndex < connectorIndex - 5){
      animationSpeed = 1000;
    }
    connectorIndex = currentIndex;
    connectorSlideToPreview(element.dataset.slider_index);
    updateConnectorSummary(element);
    checkConnectorAvailability(element);
    updatePricing();
    animationSpeed = 300;
  })
});

connectorRadiosMobile.forEach(function (element) {
  element.addEventListener('change', function (e) {
    connectorSlideToPreview(element.dataset.slider_index);
    updateConnectorSummary(element);
    element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false);
    checkConnectorAvailability(element);
    updatePricing();
  })
});
let connectorColorType = null;
let bandColorType = null;
function updateConnectorSummary(value) {
  const element = value ? value : connectorRadios[0];
  connectorColorType = element.dataset.colorType;
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  if(bottleSizeOption == '25oz'){
    checkAnimalObservatoryColor(connectorMain25oz ? connectorMain25oz : element);
  }else if(bottleSizeOption == '32oz'){
    checkAnimalObservatoryColor(connectorMain32oz ? connectorMain32oz : element);
  }else if(bottleSizeOption == '16oz'){
    checkAnimalObservatoryColor(connectorMain16oz ? connectorMain16oz : element);
  }

  if (element.dataset.colorType == "limited") {
      connectorColorTextLimited.innerText = name;
      connectorColorTextClassic.innerText = "";
      connectorColorTextAnimal.innerText = "";
      summaryLoopSection.setAttribute('color_type', 'limited');
      connectorColorTextLimitedMobile.innerText = name;
      connectorColorTextClassicMobile.innerText = "";
      connectorColorTextAnimalMobile.innerText = "";
  } 
  else if (element.dataset.colorType == 'charm') {
    connectorColorTextLimited.innerText = "";
    connectorColorTextClassic.innerText = "";
    connectorColorTextAnimal.innerText = "";
    summaryLoopSection.setAttribute('color_type', 'charm');
    connectorColorTextLimitedMobile.innerText = "";
    connectorColorTextClassicMobile.innerText = "";
    connectorColorTextAnimalMobile.innerText = "";
  }
  else if (element.dataset.colorType == 'animal') {
    connectorColorTextLimited.innerText = "";
    connectorColorTextClassic.innerText = "";
    connectorColorTextAnimal.innerText = name;
    summaryLoopSection.setAttribute('color_type', 'animal');
    connectorColorTextLimitedMobile.innerText = "";
    connectorColorTextClassicMobile.innerText = "";
    connectorColorTextAnimalMobile.innerText = name;
  }
  else {
      connectorColorTextLimited.innerText = "";
      connectorColorTextClassic.innerText = name;
      connectorColorTextAnimal.innerText = "";
      summaryLoopSection.setAttribute('color_type', 'classic');
      connectorColorTextLimitedMobile.innerText = "";
      connectorColorTextClassicMobile.innerText = name;
      connectorColorTextAnimalMobile.innerText = "";
  }

  chosenLoop = name;
  if(bottleSizeOption == '25oz'){
    connectorPreview.setAttribute('data-filled', 'filled');
    connectorPreview32oz.setAttribute('data-filled', '');
    connectorPreview16oz.setAttribute('data-filled', '');
    capType == 'robo' ? loopImage.src = image : '';
    popupLoopImage.src = image;
  }
  else if(bottleSizeOption == '32oz'){
    connectorPreview32oz.setAttribute('data-filled', 'filled');
    connectorPreview16oz.setAttribute('data-filled', '');
    connectorPreview.setAttribute('data-filled', '');
    capType == 'robo' ? loopImage.src = image_32oz : '';
    popupLoopImage.src = image_32oz;
  }
  else if(bottleSizeOption == '16oz'){
    connectorPreview16oz.setAttribute('data-filled', 'filled');
    connectorPreview32oz.setAttribute('data-filled', '');
    connectorPreview.setAttribute('data-filled', '');
    capType == 'robo' ? loopImage.src = image_16oz : '';
    popupLoopImage.src = image_16oz;
  }
  else if(bottleSizeOption == '30oz'){
    bandPreview30oz.setAttribute('data-filled', 'filled');
    bandPreview32oz.setAttribute('data-filled', '');
    bandPreview16oz.setAttribute('data-filled', '');
    bandPreview.setAttribute('data-filled', '');
    capType == 'robo' ? loopImage.src = image_30oz : '';
    popupLoopImage.src = image_30oz;
  }
  // loopImage.src = bottleSizeOption == '25oz' ? image : image_32oz;
  // popupLoopImage.src = bottleSizeOption == '25oz' ? image : image_32oz;

  if(capType == 'robo'){
    if (withLoop) {
      loopBundleVariantID = bundleVariantID;
      loopIndividualVariantID = singleVariantID;
      loopInventory = {
        variantID: bundleVariantID,
        variantQuantity: element.dataset.item_count
      }
    }
  }
  updatePricing();

}
let bandIndex = 0;
bandRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    const currentIndex = parseInt(element.dataset.slider_index);
    if(currentIndex > bandIndex + 5 || currentIndex < bandIndex - 5){
      animationSpeed = 1000;
    }
    bandIndex = currentIndex;
    bandSlideToPreview(element.dataset.slider_index);
    updateBandSummary(element);
    checkBandAvailability(element);
    updatePricing();
    animationSpeed = 300;
  })
});

bandRadiosMobile.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bandSlideToPreview(element.dataset.slider_index);
    updateBandSummary(element);
    element.classList.contains('disabled') ? scrollDownIfOOS(true) : '';
    checkBandAvailability(element);
    updatePricing();
  })
});

function updateBandSummary(value) {
  const element = value ? value : bandRadios[0];
  bandColorType = element.dataset.colorType;
  const name = element.dataset.name;
  const image = element.dataset.image;
  const image_32oz = element.dataset.image_32oz;
  const image_16oz = element.dataset.image_16oz;
  const image_30oz = element.dataset.image_30oz || element.dataset.image;
  const bundleVariantID = element.dataset.variant_id;
  const singleVariantID = element.dataset.main_variant;
  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  if(bottleSizeOption == '25oz'){
    checkAnimalObservatoryColor(bandMain25oz ? bandMain25oz : element);
  }else if(bottleSizeOption == '32oz'){
    checkAnimalObservatoryColor(bandMain32oz ? bandMain32oz : element);
  }else if(bottleSizeOption == '16oz'){
    checkAnimalObservatoryColor(bandMain16oz ? bandMain16oz : element);
  }else if(bottleSizeOption == '30oz'){
    checkAnimalObservatoryColor(bandMain30oz ? bandMain30oz : element);
  }

  if (element.dataset.colorType == "limited") {
      bandColorTextLimited.innerText = name;
      bandColorTextClassic.innerText = "";
      bandColorTextAnimal.innerText = "";
      summaryLoopSection.setAttribute('color_type', 'limited');
      bandColorTextLimitedMobile.innerText = name;
      bandColorTextClassicMobile.innerText = "";
      bandColorTextAnimalMobile.innerText = "";
  } 
  else if (element.dataset.colorType == 'charm') {
    bandColorTextLimited.innerText = "";
    bandColorTextClassic.innerText = "";
    bandColorTextAnimal.innerText = "";
    summaryLoopSection.setAttribute('color_type', 'charm');
    bandColorTextLimitedMobile.innerText = "";
    bandColorTextClassicMobile.innerText = "";
    bandColorTextAnimalMobile.innerText = "";
  }
  else if (element.dataset.colorType == 'animal') {
    bandColorTextLimited.innerText = "";
    bandColorTextClassic.innerText = "";
    bandColorTextAnimal.innerText = name;
    summaryLoopSection.setAttribute('color_type', 'animal');
    bandColorTextLimitedMobile.innerText = "";
    bandColorTextClassicMobile.innerText = "";
    bandColorTextAnimalMobile.innerText = name;
  }
  else {
      bandColorTextLimited.innerText = "";
      bandColorTextClassic.innerText = name;
      bandColorTextAnimal.innerText = "";
      summaryLoopSection.setAttribute('color_type', 'classic');
      bandColorTextLimitedMobile.innerText = "";
      bandColorTextClassicMobile.innerText = name;
      bandColorTextAnimalMobile.innerText = "";
  }

  chosenLoop = name;
  if(bottleSizeOption == '25oz'){
    bandPreview.setAttribute('data-filled', 'filled');
    bandPreview32oz.setAttribute('data-filled', '');
    bandPreview16oz.setAttribute('data-filled', '');
    bandPreview30oz.setAttribute('data-filled', '');
    capType == 'bubble' ? loopImage.src = image : '';
    popupLoopImage.src = image;
  }
  else if(bottleSizeOption == '32oz'){
    bandPreview32oz.setAttribute('data-filled', 'filled');
    bandPreview16oz.setAttribute('data-filled', '');
    bandPreview.setAttribute('data-filled', '');
    bandPreview30oz.setAttribute('data-filled', '');
    capType == 'bubble' ? loopImage.src = image_32oz : '';
    popupLoopImage.src = image_32oz;
  }
  else if(bottleSizeOption == '16oz'){
    bandPreview16oz.setAttribute('data-filled', 'filled');
    bandPreview32oz.setAttribute('data-filled', '');
    bandPreview.setAttribute('data-filled', '');
    bandPreview30oz.setAttribute('data-filled', '');
    capType == 'bubble' ? loopImage.src = image_16oz : '';
    popupLoopImage.src = image_16oz;
  }
  else if(bottleSizeOption == '30oz'){
    bandPreview30oz.setAttribute('data-filled', 'filled');
    bandPreview32oz.setAttribute('data-filled', '');
    bandPreview.setAttribute('data-filled', '');
    bandPreview16oz.setAttribute('data-filled', '');
    capType == 'bubble' ? loopImage.src = image_30oz : '';
    popupLoopImage.src = image_30oz;
  }

  if(capType == 'bubble'){
    if (withLoop) {
      loopBundleVariantID = bundleVariantID;
      loopIndividualVariantID = singleVariantID;
      loopInventory = {
        variantID: bundleVariantID,
        variantQuantity: element.dataset.item_count
      }
    }
  }
  updatePricing();

}

// event listener for boot section radios
bootRadios.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bootRadioUpdate(element);
  })
});
bootRadios32oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bootRadioUpdate(element);
  })
});
bootRadiosMobile.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bootRadioUpdate(element);
    element.classList.contains('disabled') ? scrollDownIfOOS(true) : '';
  })
});
bootRadiosMobile32oz.forEach(function (element) {
  element.addEventListener('change', function (e) {
    bootRadioUpdate(element);
    element.classList.contains('disabled') ? scrollDownIfOOS(true) : '';
  })
});


let bootIndex = 0
function bootRadioUpdate(element){
  const currentIndex = parseInt(element.dataset.slider_index);
  if(currentIndex > bootIndex + 5 || currentIndex < bootIndex - 5){
    animationSpeed = 1000;
  }
  bootIndex = currentIndex;
  bootSlideToPreview('data-name', element.dataset.name);
  updateBootSummary(element);
  checkBootAvailability(element);
  animationSpeed = 300;
  updatePricing();

}

function updateBootSummary(value) {
  var element;
  if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
   element = value ? value : bootRadios[0];
  }else{
   element = value ? value : bootRadios32oz[0];
  }
  const name = element.dataset.name;
  const image = element.dataset.image;
  const variantID = element.dataset.variant_id;
  checkAnimalObservatoryColor(bottleSizeOption == '16oz' || bottleSizeOption == '25oz' || bottleSizeOption == '30oz' ? bootMain16oz ? bootMain16oz : element : element);

  if (element.dataset.colorType == "limited") {
    bootColorTextLimited.innerText = name;
    bootColorTextLimited32oz.innerText = name;
    bootColorTextClassic.innerText = "";
    bootColorTextClassic32oz.innerText = "";
    bootColorTextAnimal.innerText = "";
    bootColorTextCandy.innerText = "";
    bootColorTextCandy32oz.innerText = "";
    summaryBootSection.setAttribute('color_type', 'limited');
    bootColorTextLimitedMobile.innerText = name;
    bootColorTextLimitedMobile32oz.innerText = name;
    bootColorTextClassicMobile.innerText = "";
    bootColorTextClassicMobile32oz.innerText = '';
    bootColorTextAnimalMobile.innerText = "";
    bootColorTextCandyMobile.innerText = "";
    bootColorTextCandyMobile32oz.innerText = "";
  } else if(element.dataset.colorType == 'animal') {
    bootColorTextLimited.innerText = "";
    bootColorTextLimited32oz.innerText = "";
    bootColorTextClassic.innerText = "";
    bootColorTextClassic32oz.innerText = "";
    bootColorTextAnimal.innerText = name;
    bootColorTextCandy.innerText = "";
    bootColorTextCandy32oz.innerText = "";
    summaryBootSection.setAttribute('color_type', 'animal');
    bootColorTextLimitedMobile.innerText = "";
    bootColorTextLimitedMobile32oz.innerText = "";
    bootColorTextClassicMobile.innerText = "";
    bootColorTextClassicMobile32oz.innerText = "";
    bootColorTextAnimalMobile.innerText = name;
    bootColorTextCandyMobile.innerText = "";
    bootColorTextCandyMobile32oz.innerText = "";
  } else if(element.dataset.colorType == 'candy') {
    bootColorTextLimited.innerText = "";
    bootColorTextLimited32oz.innerText = "";
    bootColorTextClassic.innerText = "";
    bootColorTextClassic32oz.innerText = "";
    bootColorTextAnimal.innerText = "";
    bootColorTextCandy.innerText = name;
    bootColorTextCandy32oz.innerText = name;
    summaryBootSection.setAttribute('color_type', 'candy');
    bootColorTextLimitedMobile.innerText = "";
    bootColorTextLimitedMobile32oz.innerText = "";
    bootColorTextClassicMobile.innerText = "";
    bootColorTextClassicMobile32oz.innerText = "";
    bootColorTextAnimalMobile.innerText = "";
    bootColorTextCandyMobile.innerText = name;
    bootColorTextCandyMobile32oz.innerText = name;
  } else {
    bootColorTextLimited.innerText = '';
    bootColorTextLimited32oz.innerText = '';
    bootColorTextClassic.innerText = name;
    bootColorTextClassic32oz.innerText = name;
    bootColorTextAnimal.innerText = "";
    bootColorTextCandy.innerText = "";
    bootColorTextCandy32oz.innerText = "";
    summaryBootSection.setAttribute('color_type', 'classic');
    bootColorTextLimitedMobile.innerText = '';
    bootColorTextLimitedMobile32oz.innerText = '';
    bootColorTextClassicMobile.innerText = name;
    bootColorTextClassicMobile32oz.innerText = name;
    bootColorTextAnimalMobile.innerText = "";
    bootColorTextCandyMobile.innerText = "";
    bootColorTextCandyMobile32oz.innerText = "";
  }

  chosenBoot = name;
  bootPreview.setAttribute('data-filled', 'filled');
  bootPreview32oz.setAttribute('data-filled', 'filled');
  bootImage.src = image;
  popupBootImage.src = image;
  bootVariantID = variantID;

  bootInventory = {
    variantID: variantID,
    variantQuantity: element.dataset.item_count
  }
  updatePricing();
}

const loopMainImage = document.querySelector('.main-image-loop');
let temporaryLoopBundleVID = '';
let temporaryLoopIndividualVID = '';


// event listener for boot add-on
bootChoices.addEventListener('click', function (e) {
  [...bootChoices.children].forEach(function (element) {
    element.classList.remove('active');
  });
  if (e.target.closest('#add_boot')) {
    e.target.closest('#add_boot').classList.add('active');
    withBoot = true;
  }
  else {
    e.target.closest('#no_boot').classList.add('active')
    withBoot = false;
  }
  updateBoot();
});

bootChoicesMobile.addEventListener('click', function (e) {
  [...bootChoicesMobile.children].forEach(function (element) {
    element.classList.remove('active');
  });
  if (e.target.closest('#add_boot')) {
    e.target.closest('#add_boot').classList.add('active')
    withBoot = true;
  }
  else {
    e.target.closest('#no_boot').classList.add('active')
    withBoot = false;
  }
  updateBoot();
});

const bootMainImage = document.querySelector('.main-image-boot');
let temporaryBootVID = '';

function updateBoot() {
  if (withBoot) {
    bootColorSection.classList.remove('hidden');
    bootColorSectionMobile.classList.remove('hidden');
    bootColorSection32oz.classList.remove('hidden');
    bootColorSectionMobile32oz.classList.remove('hidden');
    bootSection.querySelector('.boot-section_header h3').innerText = "Boot";
    bootSection.dataset.boot = 'with';
    bootPreview.dataset.boot = 'with';
    bootPreview32oz.dataset.boot = 'with';
    previewSections.forEach(function (ps) {
      ps.classList.remove('active');
    })
    if (bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz') {
      bootPreview.classList.add('active');
      bootPreview32oz.classList.remove('active');
    }
    else {
      bootPreview32oz.classList.add('active');
      bootPreview.classList.remove('active');
    };
    bootMainImage.classList.remove('hidden');
    bootMainImage.classList.add('active');
    popupBootImage.classList.remove('hidden');

    bootNext.classList.add('active');
    bootPrevious.classList.add('active');


    if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
      bootNext.classList.add('active');
      bootPrevious.classList.add('active');
      bootNext.classList.remove('hidden');
      bootPrevious.classList.remove('hidden');
  
      bootNext32oz.classList.remove('active');
      bootPrevious32oz.classList.remove('active');
    }
    else{
      bootNext.classList.remove('active');
      bootPrevious.classList.remove('active');
  
      bootNext32oz.classList.add('active');
      bootPrevious32oz.classList.add('active');
      bootNext32oz.classList.remove('hidden');
      bootPrevious32oz.classList.remove('hidden');
    }

    bootSection.setAttribute('data-filled', 'filled');
    if (bootSection.getAttribute('data-filled') === 'empty') {
      if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
        bootSection.querySelector('.color-section#boot-25oz').querySelectorAll('input[type="radio"]')[0].checked = true;
        bootSection.querySelector('.color-section#boot-25oz').querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
      else{
        bootSection.querySelector('.color-section#boot-32oz').querySelectorAll('input[type="radio"]')[0].checked = true;
        bootSection.querySelector('.color-section#boot-32oz').querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
    }
    if (bootVariantID.length < 1 && temporaryBootVID.length < 1 && bootIsAvailable) {
      if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
        bootSection.querySelector('.color-section#boot-25oz').querySelectorAll('input[type="radio"]')[0].checked = true;
        bootSection.querySelector('.color-section#boot-25oz').querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
      else{
        bootSection.querySelector('.color-section#boot-32oz').querySelectorAll('input[type="radio"]')[0].checked = true;
        bootSection.querySelector('.color-section#boot-32oz').querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
    }
    if (bootVariantID.length < 1 && temporaryBootVID.length > 1) {

      bootVariantID = temporaryBootVID;
    }
    bootNext.classList.remove('hidden');
    bootPrevious.classList.remove('hidden');

    if (!bootIsAvailable) {
      summaryBootSection.classList.add('unavailable');
      summaryBootSection.classList.add('unavailable');
      summaryBootSectionMobile.classList.add('unavailable');
      if(window.innerWidth > 899)
      // addToBag.setAttribute('disabled', '');
      document.querySelector('[for="boot-tab"').classList.add('unavailable');
    } else {
      summaryBootSection.classList.remove('unavailable');
      summaryBootSectionMobile.classList.remove('unavailable');
      if(window.innerWidth > 899)
      addToBag.removeAttribute('disabled');
      document.querySelector('[for="boot-tab"').classList.remove('unavailable');
    }
  }
  else {
    bootColorSection.classList.add('hidden');
    bootColorSection32oz.classList.add('hidden');
    bootColorSectionMobile.classList.add('hidden');
    bootSection.querySelector('.boot-section_header h3').innerText = " No Boot";
    bootSection.dataset.boot = 'without';
    bootPreview.dataset.boot = 'without';
    bootPreview32oz.dataset.boot = 'without';
    bootMainImage.classList.add('hidden');
    popupBootImage.classList.add('hidden');
    bootSection.setAttribute('data-filled', 'filled');
    temporaryBootVID = bootVariantID;
    bootVariantID = '';
    bootNext.classList.add('hidden');
    bootPrevious.classList.add('hidden');
    bootChoices.querySelector('#add_boot').classList.remove('active');
    bootChoicesMobile.querySelector('#add_boot').classList.remove('active');
    bootChoices.querySelector('#no_boot').classList.add('active');
    bootChoicesMobile.querySelector('#no_boot').classList.add('active');
    summaryBootSection.classList.remove('unavailable');
    summaryBootSection.classList.remove('unavailable');
    summaryBootSectionMobile.classList.remove('unavailable');
    document.querySelector('[for="boot-tab"').classList.remove('unavailable');
    if (bottleIsAvailable && loopIsAvailable && capIsAvailable) {
      bootIsAvailable = true;
      if(window.innerWidth > 899)
      addToBag.removeAttribute('disabled');
      addToBag.classList.remove('disabled');
    }
  }
  updatePricing();

}

// declare swipers
let bottleSwiper;
let bottleSwiper32oz;
let bottleSwiper30oz;
let bottleSwiper16oz;
let capSwiper;
let capSwiper32oz;
let capSwiper30oz;
let capSwiper16oz;
let robocapSwiper;
let robocapSwiper32oz;
let robocapSwiper30oz;
let robocapSwiper16oz;
let bubblecapSwiper;
let bubblecapSwiper32oz;
let bubblecapSwiper30oz;
let bubblecapSwiper16oz;
let loopSwiper;
let loopSwiper32oz;
let loopSwiper30oz;
let loopSwiper16oz;
let connectorSwiper;
let connectorSwiper32oz;
let connectorSwiper30oz;
let connectorSwiper16oz;
let bandSwiper;
let bandSwiper32oz;
let bandSwiper30oz;
let bandSwiper16oz;
let bootSwiper;
let bootSwiper32oz;

/*
*
** BOTTLE SWIPER **
* initialize bottle swipers first
*
*/

document.addEventListener('DOMContentLoaded', function () {


  bottleSwiper32oz = new Swiper("#bottle-preview-32oz.bottle-preview", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    loopAdditionalSlides: 2,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    loopPreventsSliding: false,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 0,

    navigation: {
      nextEl: '.bottle-next-32oz',
      prevEl: '.bottle-previous-32oz',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let bottle32ozSInitialized = false;

  bottleSwiper32oz.on('init', function () {
    bottleSInitialized = true;
  });
  
  bottleSwiper32oz.on('click', function (e) {
    bottleMain32oz = bottleSwiper32oz.clickedSlide;
    bottlePreviewChanges(bottleSwiper32oz.clickedSlide)
  });
    
  bottleSwiper32oz.on('snapIndexChange', function (e) {
    bottleMain32oz = bottleSwiper32oz.slides[bottleSwiper32oz.activeIndex];
    if(bottleSizeOption == '32oz'){
      if (bottle32ozSInitialized) {
      try {
        bottleSlideToPreview('data-name', bottleMain32oz.dataset.name);
        bottlePreviewChanges(bottleSwiper32oz.slides[bottleSwiper32oz.activeIndex]);
      } catch (error) {
        console.log(error)
      }
      }
    }
    bottle32ozSInitialized = true;
  });

  bottleSwiper = new Swiper("#bottle-preview-25oz.bottle-preview", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    loopAdditionalSlides: 2,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    loopPreventsSliding: false,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.bottle-next',
      prevEl: '.bottle-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  bottleSwiper16oz = new Swiper("#bottle-preview-16oz.bottle-preview", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    loopAdditionalSlides: 2,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    loopPreventsSliding: false,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 0,

    navigation: {
      nextEl: '.bottle-next',
      prevEl: '.bottle-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let bottleSInitialized = false;
  let bottle16ozSInitialized = false;
  
  bottleSwiper.on('init', function () {
    bottleSInitialized = true;
  });
  
  bottleSwiper16oz.on('init', function () {
    bottleSInitialized = true;
  });

  bottleSwiper.on('click', function (e) {
    bottleMain25oz = bottleSwiper.clickedSlide;
    bottlePreviewChanges(bottleSwiper.clickedSlide)
  });
  
  bottleSwiper16oz.on('click', function (e) {
    bottleMain16oz = bottleSwiper16oz.clickedSlide;
    bottlePreviewChanges(bottleSwiper16oz.clickedSlide)
  });

  bottleSwiper.on('snapIndexChange', function (e) {
    bottleMain25oz = bottleSwiper.slides[bottleSwiper.activeIndex];
    if(bottleSizeOption == '25oz'){
      if (bottleSInitialized) {
        try {
          bottleSlideToPreview('data-name', bottleMain25oz.dataset.name);
          bottlePreviewChanges(bottleSwiper.slides[bottleSwiper.activeIndex]);
        } catch (error) {
          console.log(error);
        }
      }
    }
    bottleSInitialized = true;
  });
  
  bottleSwiper16oz.on('snapIndexChange', function (e) {
    bottleMain16oz = bottleSwiper16oz.slides[bottleSwiper16oz.activeIndex];
    if(bottleSizeOption == '16oz'){
      if (bottle16ozSInitialized) {
        try {
          bottleSlideToPreview('data-name', bottleMain16oz.dataset.name);
          bottlePreviewChanges(bottleSwiper16oz.slides[bottleSwiper16oz.activeIndex]);
        } catch (error) {
          console.log(error)
        }
      }
    }
    bottle16ozSInitialized = true;
  });

  bottleSwiper30oz = new Swiper("#bottle-preview-30oz.bottle-preview", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    loopAdditionalSlides: 2,
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    loopPreventsSliding: false,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 0,
    // Virtual slides for better performance with many slides

    navigation: {
      nextEl: '.bottle-next',
      prevEl: '.bottle-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 3
      }
    }
  });

  let bottle30ozSInitialized = false;

  bottleSwiper30oz.on('init', function () {
    bottle30ozSInitialized = true;
  });
  
  bottleSwiper30oz.on('click', function (e) {
    bottleMain30oz = bottleSwiper30oz.clickedSlide;
    bottlePreviewChanges(bottleSwiper30oz.clickedSlide)
  });
  
  bottleSwiper30oz.on('snapIndexChange', function (e) {

    bottleMain30oz = bottleSwiper30oz.slides[bottleSwiper30oz.activeIndex];
    if(bottleSizeOption == '30oz'){
      if (bottle30ozSInitialized) {
      try {
        bottleSlideToPreview('data-name', bottleMain30oz.dataset.name);
        bottlePreviewChanges(bottleSwiper30oz.slides[bottleSwiper30oz.activeIndex]);
      } catch (error) {
        console.log(error)
      }
      }
    }
    bottle30ozSInitialized = true;
  });
  
  if(!sourceExists || localStorage.getItem('flaskOnboarding') != 'hide'){
    initSwipers();
  }
  else if(!sourceExists && localStorage.getItem('flaskOnboarding') == 'hide'){
    initSwipers();
  }
  else if(sourceExists && localStorage.getItem('flaskOnboarding') == 'hide'){
    initSwipers();
  }

  if (!capExists || !loopExists || !bottleExists) {
    if(defaultSize == '32oz'){
    bottleRadios32oz[0].dispatchEvent(changeEvent);
    }
    else if(defaultSize == '16oz'){
      bottleRadios16oz[0].dispatchEvent(changeEvent);
    }
    else if(defaultSize == '30oz'){
      bottleRadios30oz[0].dispatchEvent(changeEvent);
    }
    else{
      bottleRadios[0].dispatchEvent(changeEvent);
    }
    // bottleRadiosMobile[0].dispatchEvent(changeEvent);
    // bottleRadiosMobile32oz[0].dispatchEvent(changeEvent);

  } 

});

function closeOnboarding(){
  if(!swiperInitialized){
    initSwipers();
  }
        if (document.querySelector('.onboarding-section').classList.contains('closed')) {
          setTimeout(() => {
            document.querySelector('.onboarding-section').classList.add('fade-out');
            setTimeout(() => {
              document.querySelector('.onboarding-section').classList.add('hidden');
            }, 300);
          }, 5000); // Match the transition duration
        }
}

// Performance optimization: Debounce function to reduce excessive calls
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Performance optimization: Throttle function for scroll/resize events
function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

// add function to initialize component swipers
function initSwipers() {

  /*
  *
  ** CAP SWIPER **
  *
  */
  let capSInitialized = false;
  capSwiper = new Swiper('.cap-preview[data-size-category="25oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let cap32ozSInitialized = false;
  capSwiper32oz = new Swiper('.cap-preview[data-size-category="32oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let cap16ozSInitialized = false;
  capSwiper16oz = new Swiper('.cap-preview[data-size-category="16oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let cap30ozSInitialized = false;
  capSwiper30oz = new Swiper('.cap-preview[data-size-category="30oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  capSwiper.on('click', function (e) {
    const activeSlide = capSwiper.clickedSlide;
    capMain25oz = capSwiper.clickedSlide;
    capPreviewChanges(capSwiper.clickedSlide);
    bottleSizeOption == '25oz' ? capSwiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });
  
  capSwiper32oz.on('click', function (e) {
    const activeSlide = capSwiper32oz.clickedSlide;
    capMain32oz = capSwiper32oz.clickedSlide;
    capPreviewChanges(capSwiper32oz.clickedSlide);
    bottleSizeOption == '32oz' ? capSwiper32oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  capSwiper16oz.on('click', function (e) {
    const activeSlide = capSwiper16oz.clickedSlide;
    capMain16oz = capSwiper16oz.clickedSlide;
    capPreviewChanges(capSwiper16oz.clickedSlide);
    bottleSizeOption == '16oz' ? capSwiper16oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  capSwiper30oz.on('click', function (e) {
    const activeSlide = capSwiper30oz.clickedSlide;
    capMain30oz = capSwiper30oz.clickedSlide;
    capPreviewChanges(capSwiper30oz.clickedSlide);
    bottleSizeOption == '30oz' ? capSwiper30oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  capSwiper32oz.on('snapIndexChange', function (e) {
    capMain32oz = capSwiper32oz.slides[capSwiper32oz.activeIndex];
    if(bottleSizeOption == '32oz'){
      if (cap32ozSInitialized) {
        capPreviewChanges(capSwiper32oz.slides[capSwiper32oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (capPreviewChanges(capSwiper32oz.slides[capSwiper32oz.activeIndex]));
          if(bottleSizeOption == '32oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '32oz' ? capSwiper32oz.slides[capSwiper32oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    cap32ozSInitialized = true;
  });

  capSwiper16oz.on('snapIndexChange', function (e) {
    capMain16oz = capSwiper16oz.slides[capSwiper16oz.activeIndex];
    if(bottleSizeOption == '16oz'){
      if (cap16ozSInitialized) {
        capPreviewChanges(capSwiper16oz.slides[capSwiper16oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (capPreviewChanges(capSwiper16oz.slides[capSwiper16oz.activeIndex]));
          if(bottleSizeOption == '16oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '16oz' ? capSwiper16oz.slides[capSwiper16oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    cap16ozSInitialized = true;
  });

  capSwiper30oz.on('snapIndexChange', function (e) {
    capMain30oz = capSwiper30oz.slides[capSwiper30oz.activeIndex];
    if(bottleSizeOption == '30oz'){
      if (cap30ozSInitialized) {
        capPreviewChanges(capSwiper30oz.slides[capSwiper30oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (capPreviewChanges(capSwiper30oz.slides[capSwiper30oz.activeIndex]));
          if(bottleSizeOption == '30oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '30oz' ? capSwiper30oz.slides[capSwiper30oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    cap30ozSInitialized = true;
  });
  
  capSwiper.on('snapIndexChange', function (e) {
    capMain25oz = capSwiper.slides[capSwiper.activeIndex];
    if(bottleSizeOption == '25oz'){
      if (capSInitialized) {
        capPreviewChanges(capSwiper.slides[capSwiper.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (capPreviewChanges(capSwiper.slides[capSwiper.activeIndex]));
          if(bottleSizeOption == '25oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '25oz' ? capSwiper.slides[capSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    capSInitialized = true;
  });

  /*
  *
  ** ROBO CAP SWIPER **
  *
  */
  let robocapSInitialized = false;
  robocapSwiper = new Swiper('.robocap-preview[data-size-category="25oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let robocap32ozSInitialized = false;
  robocapSwiper32oz = new Swiper('.robocap-preview[data-size-category="32oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let robocap16ozSInitialized = false;
  robocapSwiper16oz = new Swiper('.robocap-preview[data-size-category="16oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let robocap30ozSInitialized = false;
  robocapSwiper30oz = new Swiper('.robocap-preview[data-size-category="30oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  /*
  *
  ** BUBBLECAP SWIPER **
  *
  */
  let bubblecapSInitialized = false;
  bubblecapSwiper = new Swiper('.bubblecap-preview[data-size-category="25oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let bubblecap32ozSInitialized = false;
  bubblecapSwiper32oz = new Swiper('.bubblecap-preview[data-size-category="32oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let bubblecap16ozSInitialized = false;
  bubblecapSwiper16oz = new Swiper('.bubblecap-preview[data-size-category="16oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let bubblecap30ozSInitialized = false;
  bubblecapSwiper30oz = new Swiper('.bubblecap-preview[data-size-category="30oz"]', {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.cap-next',
      prevEl: '.cap-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  bubblecapSwiper.on('click', function (e) {
    const activeSlide = bubblecapSwiper.clickedSlide;
    bubblecapMain25oz = bubblecapSwiper.clickedSlide;
    bubblecapPreviewChanges(bubblecapSwiper.clickedSlide);
    bottleSizeOption == '25oz' ? bubblecapSwiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  bubblecapSwiper32oz.on('click', function (e) {
    const activeSlide = bubblecapSwiper32oz.clickedSlide;
    bubblecapMain32oz = bubblecapSwiper32oz.clickedSlide;
    bubblecapPreviewChanges(bubblecapSwiper32oz.clickedSlide);
    bottleSizeOption == '32oz' ? bubblecapSwiper32oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  bubblecapSwiper16oz.on('click', function (e) {
    const activeSlide = bubblecapSwiper16oz.clickedSlide;
    bubblecapMain16oz = bubblecapSwiper16oz.clickedSlide;
    bubblecapPreviewChanges(bubblecapSwiper16oz.clickedSlide);
    bottleSizeOption == '16oz' ? bubblecapSwiper16oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  bubblecapSwiper30oz.on('click', function (e) {
    const activeSlide = bubblecapSwiper30oz.clickedSlide;
    bubblecapMain30oz = bubblecapSwiper30oz.clickedSlide;
    bubblecapPreviewChanges(bubblecapSwiper30oz.clickedSlide);
    bottleSizeOption == '30oz' ? bubblecapSwiper30oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  bubblecapSwiper.on('snapIndexChange', function (e) {
    bubblecapMain25oz = bubblecapSwiper.slides[bubblecapSwiper.activeIndex];
    if(bottleSizeOption == '25oz'){
      if (bubblecapSInitialized) {
        bubblecapPreviewChanges(bubblecapSwiper.slides[bubblecapSwiper.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (bubblecapPreviewChanges(bubblecapSwiper.slides[bubblecapSwiper.activeIndex]));
          if(bottleSizeOption == '25oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '25oz' ? bubblecapSwiper.slides[bubblecapSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    bubblecapSInitialized = true;
  });

  bubblecapSwiper32oz.on('snapIndexChange', function (e) {
    bubblecapMain32oz = bubblecapSwiper32oz.slides[bubblecapSwiper32oz.activeIndex];
    if(bottleSizeOption == '32oz'){
      if (bubblecap32ozSInitialized) {
        bubblecapPreviewChanges(bubblecapSwiper32oz.slides[bubblecapSwiper32oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (bubblecapPreviewChanges(bubblecapSwiper32oz.slides[bubblecapSwiper32oz.activeIndex]));
          if(bottleSizeOption == '32oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '32oz' ? bubblecapSwiper32oz.slides[bubblecapSwiper32oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    bubblecap32ozSInitialized = true;
  });

  bubblecapSwiper16oz.on('snapIndexChange', function (e) {
    bubblecapMain16oz = bubblecapSwiper16oz.slides[bubblecapSwiper16oz.activeIndex];
    if(bottleSizeOption == '16oz'){
      if (bubblecap16ozSInitialized) {
        bubblecapPreviewChanges(bubblecapSwiper16oz.slides[bubblecapSwiper16oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (bubblecapPreviewChanges(bubblecapSwiper16oz.slides[bubblecapSwiper16oz.activeIndex]));
          if(bottleSizeOption == '16oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '16oz' ? bubblecapSwiper16oz.slides[bubblecapSwiper16oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    bubblecap16ozSInitialized = true;
  });

  bubblecapSwiper30oz.on('snapIndexChange', function (e) {
    bubblecapMain30oz = bubblecapSwiper30oz.slides[bubblecapSwiper30oz.activeIndex];
    if(bottleSizeOption == '30oz'){
      if (bubblecap30ozSInitialized) {
        bubblecapPreviewChanges(bubblecapSwiper30oz.slides[bubblecapSwiper30oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (bubblecapPreviewChanges(bubblecapSwiper30oz.slides[bubblecapSwiper30oz.activeIndex]));
          if(bottleSizeOption == '30oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '30oz' ? bubblecapSwiper30oz.slides[bubblecapSwiper30oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    bubblecap30ozSInitialized = true;
  });
  
  robocapSwiper32oz.on('click', function (e) {
    const activeSlide = robocapSwiper32oz.clickedSlide;
    robocapMain32oz = robocapSwiper32oz.clickedSlide;
    robocapPreviewChanges(robocapSwiper32oz.clickedSlide);
    bottleSizeOption == '32oz' ? robocapSwiper32oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });
  
  robocapSwiper16oz.on('click', function (e) {
    const activeSlide = robocapSwiper16oz.clickedSlide;
    robocapMain16oz = robocapSwiper16oz.clickedSlide;
    robocapPreviewChanges(robocapSwiper16oz.clickedSlide);
    bottleSizeOption == '16oz' ? robocapSwiper16oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  robocapSwiper30oz.on('click', function (e) {
    const activeSlide = robocapSwiper30oz.clickedSlide;
    robocapMain30oz = robocapSwiper30oz.clickedSlide;
    robocapPreviewChanges(robocapSwiper30oz.clickedSlide);
    bottleSizeOption == '30oz' ? robocapSwiper30oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });
  
  robocapSwiper32oz.on('snapIndexChange', function (e) {
    robocapMain32oz = robocapSwiper32oz.slides[robocapSwiper32oz.activeIndex];
    if(bottleSizeOption == '32oz'){
      if (robocap32ozSInitialized) {
        robocapPreviewChanges(robocapSwiper32oz.slides[robocapSwiper32oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (robocapPreviewChanges(robocapSwiper32oz.slides[robocapSwiper32oz.activeIndex]));
          if(bottleSizeOption == '32oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '32oz' ? robocapSwiper32oz.slides[robocapSwiper32oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    robocap32ozSInitialized = true;
  });
  
  robocapSwiper16oz.on('snapIndexChange', function (e) {
    robocapMain16oz = robocapSwiper16oz.slides[robocapSwiper16oz.activeIndex];
    if(bottleSizeOption == '16oz'){
      if (robocap16ozSInitialized) {
        robocapPreviewChanges(robocapSwiper16oz.slides[robocapSwiper16oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (robocapPreviewChanges(robocapSwiper16oz.slides[robocapSwiper16oz.activeIndex]));
          if(bottleSizeOption == '16oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '16oz' ? robocapSwiper16oz.slides[robocapSwiper16oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    robocap16ozSInitialized = true;
  });

  robocapSwiper30oz.on('snapIndexChange', function (e) {
    robocapMain30oz = robocapSwiper30oz.slides[robocapSwiper30oz.activeIndex];
    if(bottleSizeOption == '30oz'){
      if (robocap30ozSInitialized) {
        robocapPreviewChanges(robocapSwiper30oz.slides[robocapSwiper30oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (robocapPreviewChanges(robocapSwiper30oz.slides[robocapSwiper30oz.activeIndex]));
          if(bottleSizeOption == '30oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '30oz' ? robocapSwiper30oz.slides[robocapSwiper30oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    robocap30ozSInitialized = true;
  });
  
  robocapSwiper.on('snapIndexChange', function (e) {
    robocapMain25oz = robocapSwiper.slides[robocapSwiper.activeIndex];
    if(bottleSizeOption == '25oz'){
      if (robocapSInitialized) {
        robocapPreviewChanges(robocapSwiper.slides[robocapSwiper.activeIndex]);
      } else {
        try {
          sourceExists ? '' : (robocapPreviewChanges(robocapSwiper.slides[robocapSwiper.activeIndex]));
          if(bottleSizeOption == '25oz'){
            capBundleVariantID = '';
            capIndividualVariantID = '';
          }
          popupCapImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '25oz' ? robocapSwiper.slides[robocapSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    robocapSInitialized = true;
  });

  /*
  *
  ** LOOP SWIPER **
  *
  */
  let loopSInitialized = false;
  loopSwiper = new Swiper(".loop-preview[data-size-category='25oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let loop32ozSInitialized = false;
  loopSwiper32oz = new Swiper(".loop-preview[data-size-category='32oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let loop16ozSInitialized = false;
  loopSwiper16oz = new Swiper(".loop-preview[data-size-category='16oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let loop30ozSInitialized = false;
  loopSwiper30oz = new Swiper(".loop-preview[data-size-category='30oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  loopSwiper.on('click', function (e) {
    const activeSlide = loopSwiper.clickedSlide;
    loopMain25oz = loopSwiper.clickedSlide;
    loopPreviewChanges(loopSwiper.slides[loopSwiper.activeIndex]);
    bottleSizeOption == '25oz' ? loopSwiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });
  
  loopSwiper32oz.on('click', function (e) {
    const activeSlide = loopSwiper32oz.clickedSlide;
    loopMain32oz = loopSwiper32oz.clickedSlide;
    loopPreviewChanges(loopSwiper32oz.slides[loopSwiper32oz.activeIndex]);
    bottleSizeOption == '25oz' ? loopSwiper32oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  loopSwiper16oz.on('click', function (e) {
    const activeSlide = loopSwiper16oz.clickedSlide;
    loopMain16oz = loopSwiper16oz.clickedSlide;
    loopPreviewChanges(loopSwiper16oz.slides[loopSwiper16oz.activeIndex]);
    bottleSizeOption == '25oz' ? loopSwiper16oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  loopSwiper30oz.on('click', function (e) {
    const activeSlide = loopSwiper30oz.clickedSlide;
    loopMain30oz = loopSwiper30oz.clickedSlide;
    loopPreviewChanges(loopSwiper30oz.slides[loopSwiper30oz.activeIndex]);
    bottleSizeOption == '30oz' ? loopSwiper30oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  loopSwiper32oz.on('snapIndexChange', function (e) {
    loopMain32oz = loopSwiper32oz.slides[loopSwiper32oz.activeIndex];
    if(bottleSizeOption == '32oz'){
      if (loop32ozSInitialized) {
        loopPreviewChanges(loopSwiper32oz.slides[loopSwiper32oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : loopPreviewChanges(loopSwiper32oz.slides[loopSwiper32oz.activeIndex]);
          loopBundleVariantID = '';
          loopIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '32oz' ? loopSwiper32oz.slides[loopSwiper32oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    loop32ozSInitialized = true;
    loopozSInitialized = true;
    updatePricing();
  });

  loopSwiper16oz.on('snapIndexChange', function (e) {
    loopMain16oz = loopSwiper16oz.slides[loopSwiper16oz.activeIndex];
    if(bottleSizeOption == '16oz'){
      if (loop16ozSInitialized) {
        loopPreviewChanges(loopSwiper16oz.slides[loopSwiper16oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : loopPreviewChanges(loopSwiper16oz.slides[loopSwiper16oz.activeIndex]);
          loopBundleVariantID = '';
          loopIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '16oz' ? loopSwiper16oz.slides[loopSwiper16oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    loop16ozSInitialized = true;
    loopozSInitialized = true;
    updatePricing();
  });

  loopSwiper30oz.on('snapIndexChange', function (e) {
    loopMain30oz = loopSwiper30oz.slides[loopSwiper30oz.activeIndex];
    if(bottleSizeOption == '30oz'){
      if (loop30ozSInitialized) {
        loopPreviewChanges(loopSwiper30oz.slides[loopSwiper30oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : loopPreviewChanges(loopSwiper30oz.slides[loopSwiper30oz.activeIndex]);
          loopBundleVariantID = '';
          loopIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '30oz' ? loopSwiper30oz.slides[loopSwiper30oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    loop30ozSInitialized = true;
    loopozSInitialized = true;
    updatePricing();
  });

  loopSwiper.on('snapIndexChange', function (e) {
    loopMain25oz = loopSwiper.slides[loopSwiper.activeIndex];
    if(bottleSizeOption == '25oz'){
      if (loopSInitialized) {
        loopPreviewChanges(loopSwiper.slides[loopSwiper.activeIndex]);
      } else {
        try {
          sourceExists ? '' : loopPreviewChanges(loopSwiper.slides[loopSwiper.activeIndex]);
          loopBundleVariantID = '';
          loopIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
    }
    loopSInitialized = true;
    bottleSizeOption == '25oz' ? loopSwiper.slides[loopSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    updatePricing();
  });

  /*
  *
  ** CONNECTOR SWIPER **
  *
  */
  let connectorSInitialized = false;
  connectorSwiper = new Swiper(".connector-preview[data-size-category='25oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.connector-next',
      prevEl: '.connector-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let connector32ozSInitialized = false;
  connectorSwiper32oz = new Swiper(".connector-preview[data-size-category='32oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.connector-next',
      prevEl: '.connector-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let connector16ozSInitialized = false;
  connectorSwiper16oz = new Swiper(".connector-preview[data-size-category='16oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let connector30ozSInitialized = false;
  connectorSwiper30oz = new Swiper(".connector-preview[data-size-category='30oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  connectorSwiper.on('click', function (e) {
    const activeSlide = connectorSwiper.clickedSlide;
    connectorMain25oz = connectorSwiper.clickedSlide;
    connectorPreviewChanges(connectorSwiper.slides[connectorSwiper.activeIndex]);
    bottleSizeOption == '25oz' ? connectorSwiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });
  
  connectorSwiper32oz.on('click', function (e) {
    const activeSlide = connectorSwiper32oz.clickedSlide;
    connectorMain32oz = connectorSwiper32oz.clickedSlide;
    connectorPreviewChanges(connectorSwiper32oz.slides[connectorSwiper32oz.activeIndex]);
    bottleSizeOption == '25oz' ? connectorSwiper32oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  connectorSwiper16oz.on('click', function (e) {
    const activeSlide = connectorSwiper16oz.clickedSlide;
    connectorMain16oz = connectorSwiper16oz.clickedSlide;
    connectorPreviewChanges(connectorSwiper16oz.slides[connectorSwiper16oz.activeIndex]);
    bottleSizeOption == '25oz' ? connectorSwiper16oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  connectorSwiper30oz.on('click', function (e) {
    const activeSlide = connectorSwiper30oz.clickedSlide;
    connectorMain30oz = connectorSwiper30oz.clickedSlide;
    connectorPreviewChanges(connectorSwiper30oz.slides[connectorSwiper30oz.activeIndex]);
    bottleSizeOption == '30oz' ? connectorSwiper30oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  connectorSwiper32oz.on('snapIndexChange', function (e) {
    connectorMain32oz = connectorSwiper32oz.slides[connectorSwiper32oz.activeIndex];
    if(bottleSizeOption == '32oz'){
      if (connector32ozSInitialized) {
        connectorPreviewChanges(connectorSwiper32oz.slides[connectorSwiper32oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : connectorPreviewChanges(connectorSwiper32oz.slides[connectorSwiper32oz.activeIndex]);
          connectorBundleVariantID = '';
          connectorIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '32oz' ? connectorSwiper32oz.slides[connectorSwiper32oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    connector32ozSInitialized = true;
    connectorozSInitialized = true;
    updatePricing();
  });

  connectorSwiper16oz.on('snapIndexChange', function (e) {
    connectorMain16oz = connectorSwiper16oz.slides[connectorSwiper16oz.activeIndex];
    if(bottleSizeOption == '16oz'){
      if (connector16ozSInitialized) {
        connectorPreviewChanges(connectorSwiper16oz.slides[connectorSwiper16oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : connectorPreviewChanges(connectorSwiper16oz.slides[connectorSwiper16oz.activeIndex]);
          connectorBundleVariantID = '';
          connectorIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '16oz' ? connectorSwiper16oz.slides[connectorSwiper16oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    connector16ozSInitialized = true;
    connectorozSInitialized = true;
    updatePricing();
  });

  connectorSwiper30oz.on('snapIndexChange', function (e) {
    connectorMain30oz = connectorSwiper30oz.slides[connectorSwiper30oz.activeIndex];
    if(bottleSizeOption == '30oz'){
      if (connector30ozSInitialized) {
        connectorPreviewChanges(connectorSwiper30oz.slides[connectorSwiper30oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : connectorPreviewChanges(connectorSwiper30oz.slides[connectorSwiper30oz.activeIndex]);
          connectorBundleVariantID = '';
          connectorIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '30oz' ? connectorSwiper30oz.slides[connectorSwiper30oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    connector30ozSInitialized = true;
    connectorozSInitialized = true;
    updatePricing();
  });

  connectorSwiper.on('snapIndexChange', function (e) {
    connectorMain25oz = connectorSwiper.slides[connectorSwiper.activeIndex];
    if(bottleSizeOption == '25oz'){
      if (connectorSInitialized) {
        connectorPreviewChanges(connectorSwiper.slides[connectorSwiper.activeIndex]);
      } else {
        try {
          sourceExists ? '' : connectorPreviewChanges(connectorSwiper.slides[connectorSwiper.activeIndex]);
          connectorBundleVariantID = '';
          connectorIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
    }
    connectorSInitialized = true;
    bottleSizeOption == '25oz' ? connectorSwiper.slides[connectorSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    updatePricing();
  });

  /*
  *
  ** BAND SWIPER **
  *
  */
  let bandSInitialized = false;
  bandSwiper = new Swiper(".band-preview[data-size-category='25oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let band32ozSInitialized = false;
  bandSwiper32oz = new Swiper(".band-preview[data-size-category='32oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let band16ozSInitialized = false;
  bandSwiper16oz = new Swiper(".band-preview[data-size-category='16oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  let band30ozSInitialized = false;
  bandSwiper30oz = new Swiper(".band-preview[data-size-category='30oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,

    navigation: {
      nextEl: '.loop-next',
      prevEl: '.loop-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  bandSwiper.on('click', function (e) {
    const activeSlide = bandSwiper.clickedSlide;
    bandMain25oz = bandSwiper.clickedSlide;
    bandPreviewChanges(bandSwiper.slides[bandSwiper.activeIndex]);
    bottleSizeOption == '25oz' ? bandSwiper.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });
  
  bandSwiper32oz.on('click', function (e) {
    const activeSlide = bandSwiper32oz.clickedSlide;
    bandMain32oz = bandSwiper32oz.clickedSlide;
    bandPreviewChanges(bandSwiper32oz.slides[bandSwiper32oz.activeIndex]);
    bottleSizeOption == '25oz' ? bandSwiper32oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  bandSwiper16oz.on('click', function (e) {
    const activeSlide = bandSwiper16oz.clickedSlide;
    bandMain16oz = bandSwiper16oz.clickedSlide;
    bandPreviewChanges(bandSwiper16oz.slides[bandSwiper16oz.activeIndex]);
    bottleSizeOption == '25oz' ? bandSwiper16oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  bandSwiper30oz.on('click', function (e) {
    const activeSlide = bandSwiper30oz.clickedSlide;
    bandMain30oz = bandSwiper30oz.clickedSlide;
    bandPreviewChanges(bandSwiper30oz.slides[bandSwiper30oz.activeIndex]);
    bottleSizeOption == '30oz' ? bandSwiper30oz.clickedSlide.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  bandSwiper32oz.on('snapIndexChange', function (e) {
    bandMain32oz = bandSwiper32oz.slides[bandSwiper32oz.activeIndex];
    if(bottleSizeOption == '32oz'){
      if (band32ozSInitialized) {
        bandPreviewChanges(bandSwiper32oz.slides[bandSwiper32oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : bandPreviewChanges(bandSwiper32oz.slides[bandSwiper32oz.activeIndex]);
          bandBundleVariantID = '';
          bandIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '32oz' ? bandSwiper32oz.slides[bandSwiper32oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    band32ozSInitialized = true;
    updatePricing();
  });

  bandSwiper16oz.on('snapIndexChange', function (e) {
    bandMain16oz = bandSwiper16oz.slides[bandSwiper16oz.activeIndex];
    if(bottleSizeOption == '16oz'){
      if (band16ozSInitialized) {
        bandPreviewChanges(bandSwiper16oz.slides[bandSwiper16oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : bandPreviewChanges(bandSwiper16oz.slides[bandSwiper16oz.activeIndex]);
          bandBundleVariantID = '';
          bandIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '16oz' ? bandSwiper16oz.slides[bandSwiper16oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    band16ozSInitialized = true;
    updatePricing();
  });

  bandSwiper30oz.on('snapIndexChange', function (e) {
    bandMain30oz = bandSwiper30oz.slides[bandSwiper30oz.activeIndex];
    if(bottleSizeOption == '30oz'){
      if (band30ozSInitialized) {
        bandPreviewChanges(bandSwiper30oz.slides[bandSwiper30oz.activeIndex]);
      } else {
        try {
          sourceExists ? '' : bandPreviewChanges(bandSwiper30oz.slides[bandSwiper30oz.activeIndex]);
          bandBundleVariantID = '';
          bandIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
      bottleSizeOption == '30oz' ? bandSwiper30oz.slides[bandSwiper30oz.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
    band30ozSInitialized = true;
    updatePricing();
  });

  bandSwiper.on('snapIndexChange', function (e) {
    bandMain25oz = bandSwiper.slides[bandSwiper.activeIndex];
    if(bottleSizeOption == '25oz'){
      if (bandSInitialized) {
        bandPreviewChanges(bandSwiper.slides[bandSwiper.activeIndex]);
      } else {
        try {
          sourceExists ? '' : bandPreviewChanges(bandSwiper.slides[bandSwiper.activeIndex]);
          bandBundleVariantID = '';
          bandIndividualVariantID = '';
          popupLoopImage.src = '';
        } catch (error) {
          console.log(error);
        }
      }
    }
    bandSInitialized = true;
    bottleSizeOption == '25oz' ? bandSwiper.slides[bandSwiper.activeIndex].classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    updatePricing();
  });

  /*
  *
  ** BOOT SWIPER **
  *
  */
  let bootSInitialized = false;
  bootSwiper = new Swiper(".boot-preview[data-size-category='25oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    loopAdditionalSlides: 3,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 0,
    navigation: {
      nextEl: '.boot-next',
      prevEl: '.boot-previous',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    }
  });

  bootSwiper32oz = new Swiper(".boot-preview[data-size-category='32oz']", {
    loop: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
      enabled: true
    },
    observer: false,
    observeParents: false,
    loopAdditionalSlides: 3,
    allowTouchMove: false,
    allowSlideClick: true,
    spaceBetween: 0,
    speed: animationSpeed ? animationSpeed : 300,
    slidesPerView: 2,
    centeredSlides: true,
    watchSlidesVisibility: false,
    slideVisibleClass: 'swiper-slide-visible',
    watchSlidesProgress: false,
    slideToClickedSlide: true,
    initialSlide: 0,
    navigation: {
      nextEl: '.boot-next-32oz',
      prevEl: '.boot-previous-32oz',
    },
    breakpoints: {
      900: {
        allowTouchMove: false,
        allowSlideClick: true,
        slidesPerView: 3
      },
      1300: {
        slidesPerView: 5,
      }
    },
    on: {
      init: function () {
        // closeOnboarding();
      swiperInitialized = true;
      }
    }
  });

  bootSwiper.on('click', function (e) {
    bootMain25oz = bootSwiper.clickedSlide;
    bootPreviewChanges(bootSwiper.clickedSlide);
    bottleSizeOption == '25oz' ? bootMain25oz.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });
  
  bootSwiper32oz.on('click', function (e) {
    bootMain32oz = bootSwiper32oz.clickedSlide;
    bootPreviewChanges(bootSwiper32oz.clickedSlide);
    bottleSizeOption == '32oz' ? bootMain32oz.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
  });

  bootSwiper.on('snapIndexChange', function (e) {
    bootMain25oz = bootSwiper.slides[bootSwiper.activeIndex];
    if (bootPreview.dataset.filled != '' || bootPreview.dataset.filled != 'empty') {
      if (bootSInitialized) {
        withBoot ? (bootSlideToPreview('data-name', bootMain25oz.dataset.name, '25oz'), bootPreviewChanges(bootSwiper.slides[bootSwiper.activeIndex])) : '';
      } else {
        try {
          sourceExists ? '' : (withBoot ? bootPreviewChanges(bootSwiper.slides[bootSwiper.activeIndex]) : '');
        } catch (error) { }
      }
    }
    bootSInitialized = true;
    bottleSizeOption == '25oz' ? bootMain25oz.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    updatePricing();
  });

  bootSwiper32oz.on('snapIndexChange', function (e) {
    bootMain32oz = bootSwiper32oz.slides[bootSwiper32oz.activeIndex];
    if (bootPreview32oz.dataset.filled != '' || bootPreview32oz.dataset.filled != 'empty') {
      if (bootSInitialized) {
        withBoot ? (bootSlideToPreview('data-name', bootMain32oz, '32oz'), bootPreviewChanges(bootSwiper32oz.slides[bootSwiper32oz.activeIndex])) : '';
      } else {
        try {
          sourceExists ? '' : (withBoot ? bootPreviewChanges(bootSwiper32oz.slides[bootSwiper32oz.activeIndex]) : '');
        } catch (error) { }
      }
    }
    bootSInitialized = true;
    bottleSizeOption == '32oz' ? (bootMain32oz && bootMain32oz.classList.contains('disabled')) ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    updatePricing();
  });
  bootSwiper32oz.on('init', function (e) {
    swiperInitialized = true;
  });
}



// Debounced version of bottlePreviewChanges for better performance
const debouncedBottlePreviewChanges = debounce(function(activeSlide) {
  bottleRadioCheck(activeSlide.dataset.name)
  updateBottleSummary(activeSlide);
  checkColor(activeSlide.dataset.variant_color);
}, 50);

function bottlePreviewChanges(activeSlide) {
  bottleRadioCheck(activeSlide.dataset.name)
  updateBottleSummary(activeSlide);
  checkColor(activeSlide.dataset.variant_color);
  checkBottleAvailability(activeSlide);
  updatePricing();
}

function bottleRadioCheck(param) {

  bottleRadios.forEach(element => {
    if (element.dataset.name === param) {
      element.checked = true;
    }
  });
  bottleRadiosMobile.forEach(element => {
    if (element.dataset.name === param) {
      element.checked = true;
      bottleSizeOption == '25oz' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
  });
  bottleRadios32oz.forEach(element => {
    if (element.dataset.name === param) {
      element.checked = true;
    }
  });
  bottleRadiosMobile32oz.forEach(element => {
    if (element.dataset.name === param) {
      element.checked = true;
      bottleSizeOption == '32oz' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
  });

  bottleRadios16oz.forEach(element => {
    if (element.dataset.name === param) {
      element.checked = true;
    }
  });
  bottleRadiosMobile16oz.forEach(element => {
    if (element.dataset.name === param) {
      element.checked = true;
      bottleSizeOption == '16oz' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
  });
  bottleRadios30oz.forEach(element => {
    if (element.dataset.name === param) {
      element.checked = true;
    }
  });
  bottleRadiosMobile30oz.forEach(element => {
    if (element.dataset.name === param) {
      element.checked = true;
      bottleSizeOption == '30oz' ? element.classList.contains('disabled') ? scrollDownIfOOS(true) : scrollDownIfOOS(false) : '';
    }
  });
}


function bottleSlideToPreview(attributeName = 'data-name', attributeValue, source = '') {
  let closestSlideIndex = -1;
  let minDistance = Infinity;
  // Find the closest slide for bottleSwiper
  if(source == '' || source == '32oz'){
    bottleSwiper.slides.forEach((slide, index) => {
      if (slide.getAttribute(attributeName) === attributeValue) {
        const distance = Math.abs(bottleSwiper.activeIndex - index);
        if (distance < minDistance) {
          closestSlideIndex = index;
          minDistance = distance;
        }
      }
    });

    // If a match is found, slide to the closest slide
    if (closestSlideIndex !== -1) {
      bottleSwiper.slideTo(closestSlideIndex, randomizeCondition || sizeChanging ? 0 : animationSpeed, false);
    }
  }

  if(source == '' || source == '25oz'){
  // Same logic for bottleSwiper32oz
    let closestSlideIndex32oz = -1;
    let minDistance32oz = Infinity;

    bottleSwiper32oz.slides.forEach((slide, index) => {
      if (slide.getAttribute(attributeName) === attributeValue) {
        const distance = Math.abs(bottleSwiper32oz.activeIndex - index);
        if (distance < minDistance32oz) {
          closestSlideIndex32oz = index;
          minDistance32oz = distance;
        }
      }
    });

    if (closestSlideIndex32oz !== -1) {
      bottleSwiper32oz.slideTo(closestSlideIndex32oz, randomizeCondition || sizeChanging ? 0 : animationSpeed, false);
    }
  }

  if(source == '' || source == '16oz'){
    // Same logic for bottleSwiper16oz
    let closestSlideIndex16oz = -1;
    let minDistance16oz = Infinity;

    bottleSwiper16oz.slides.forEach((slide, index) => {
      if (slide.getAttribute(attributeName) === attributeValue) {
        const distance = Math.abs(bottleSwiper16oz.activeIndex - index);
        if (distance < minDistance16oz) {
          closestSlideIndex16oz = index;
          minDistance16oz = distance;
        }
      }
    });

    if (closestSlideIndex16oz !== -1) {
      bottleSwiper16oz.slideTo(closestSlideIndex16oz, randomizeCondition || sizeChanging ? 0 : animationSpeed, false);
    }
  }
  if(source == '' || source == '30oz'){
    // Same logic for bottleSwiper30oz
    let closestSlideIndex30oz = -1;
    let minDistance30oz = Infinity;

    bottleSwiper30oz.slides.forEach((slide, index) => {
      if (slide.getAttribute(attributeName) === attributeValue) {
        const distance = Math.abs(bottleSwiper30oz.activeIndex - index);
        if (distance < minDistance30oz) {
          closestSlideIndex30oz = index;
          minDistance30oz = distance;
        }
      }
    });

    if (closestSlideIndex30oz !== -1) {
      bottleSwiper30oz.slideTo(closestSlideIndex30oz, randomizeCondition || sizeChanging ? 0 : animationSpeed, false);
    }
  }
  sizeChanging = false;
}

// functionality for slide to preview if customizer is not open
function bottleSlideToPreviewMain(params){
  
  bottleSizeOption == '25oz' ? bottleSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
  bottleSizeOption == '32oz' ? bottleSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
  bottleSizeOption == '16oz' ? bottleSwiper16oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
  bottleSizeOption == '30oz' ? bottleSwiper30oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false) : '';
}



// robocap swiper



function capPreviewChanges(activeSlide) {
  capRadioCheck(activeSlide.dataset.name);
  updateCapSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  capType == 'robo' ? '' : checkCapAvailability(activeSlide);
  summaryCapSection.dataset.filled != 'filled' ? capBundleVariantID = '' : '';
  updatePricing();
}

function capRadioCheck(param) {
  capRadios.forEach(element => {

    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
  capRadiosMobile.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}

function robocapPreviewChanges(activeSlide) {
  robocapRadioCheck(activeSlide.dataset.name);
  updateroboCapSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  capType == 'robo' ? checkroboCapAvailability(activeSlide) : '';
  summaryCapSection.dataset.filled != 'filled' ? capBundleVariantID = '' : '';
  updatePricing();
}

function bubblecapPreviewChanges(activeSlide) {
  bubblecapRadioCheck(activeSlide.dataset.name);
  updateBubblecapSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  capType == 'bubble' ? checkBubbleAvailability(activeSlide) : '';
  summaryCapSection.dataset.filled != 'filled' ? capBundleVariantID = '' : '';
  updatePricing();
}

function robocapRadioCheck(param) {
  robocapRadios.forEach(element => {

    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
  robocapRadiosMobile.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}

function bubblecapRadioCheck(param) {
  bubblecapRadios.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
  bubblecapRadiosMobile.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}

function bandPreviewChanges(activeSlide) {
  bandRadioCheck(activeSlide.dataset.name);
  updateBandSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  capType == 'bubble' ? checkBandAvailability(activeSlide) : '';
  loopSection.dataset.filled != 'filled' ? loopBundleVariantID = '' : '';
  updatePricing();
}

function bandRadioCheck(param) {
  bandRadios.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
  bandRadiosMobile.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}



function capSlideToPreview(params) {
  // if(bottleSizeOption == '25oz'){
  //   capSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
  //   capSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
  // }
  // else{
    capSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
    capSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
    capSwiper16oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
    capSwiper30oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
  // }
}


function robocapSlideToPreview(params) {
  // if(bottleSizeOption == '25oz'){
  //   capSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
  //   capSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
  // }
  // else{
    robocapSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
    robocapSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
    robocapSwiper16oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
    robocapSwiper30oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
  // }
}

function bubblecapSlideToPreview(params) {
  bubblecapSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
  bubblecapSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
  bubblecapSwiper16oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
  bubblecapSwiper30oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false)
}


function loopPreviewChanges(activeSlide) {
  loopRadioCheck(activeSlide.dataset.name);
  updateLoopSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  capType == 'robo' ? '' : checkLoopAvailability(activeSlide);
  loopSection.dataset.filled != 'filled' ? loopBundleVariantID = '' : '';
  updatePricing();
}

function loopRadioCheck(param) {
  loopRadios.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
  loopRadiosMobile.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}


function loopSlideToPreview(params) {
  // if(bottleSizeOption == '25oz'){
  //   loopSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
  //   loopSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
  // }
  // else{
    loopSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
    loopSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
    loopSwiper16oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
    loopSwiper30oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
  // }
}

function connectorPreviewChanges(activeSlide) {
  connectorRadioCheck(activeSlide.dataset.name);
  updateConnectorSummary(activeSlide);
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  capType == 'robo' ? checkConnectorAvailability(activeSlide) : '';
  loopSection.dataset.filled != 'filled' ? connectorBundleVariantID = '' : '';
  updatePricing();
}

function connectorRadioCheck(param) {
  connectorRadios.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
  connectorRadiosMobile.forEach(element => {
    if (element.dataset.name == param) {
      element.checked = true;
    }
  });
}


function connectorSlideToPreview(params) {
  // if(bottleSizeOption == '25oz'){
  //   connectorSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
  //   connectorSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
  // }
  // else{
    connectorSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
    connectorSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
    connectorSwiper16oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
    connectorSwiper30oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
  // }
}

function bandSlideToPreview(params) {
  bandSwiper.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
  bandSwiper32oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
  bandSwiper16oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
  bandSwiper30oz.slideToLoop(params, randomizeCondition ? 0 : animationSpeed, false);
}



function bootPreviewChanges(activeSlide) {
  bootRadioCheck(activeSlide.dataset.name)
  updateBootSummary(activeSlide);
  checkBootAvailability(activeSlide);
  updatePricing();
}

function bootRadioCheck(param) {
  if(bottleSizeOption == '25oz' || bottleSizeOption == '16oz' || bottleSizeOption == '30oz'){
    bootRadios.forEach(element => {
      if (element.dataset.name == param) {
        element.checked = true;
      }
    });
    bootRadiosMobile.forEach(element => {
      if (element.dataset.name == param) {
        element.checked = true;
      }
    });
  }
  else{ 
    bootRadios32oz.forEach(element => {
      if (element.dataset.name == param) {
        element.checked = true;
      }
    });
    bootRadiosMobile32oz.forEach(element => {
      if (element.dataset.name == param) {
        element.checked = true;
      }
    });
  }
}


function bootSlideToPreview(attributeName = 'data-name', attributeValue, source = '') {
  let closestSlideIndex = -1;
  let minDistance = Infinity;

  // Find the closest slide for bootSwiper
  if(source == '25oz' || source == ''){
    bootSwiper.slides.forEach((slide, index) => {
      if (slide.getAttribute(attributeName) === attributeValue) {
        const distance = Math.abs(bootSwiper.activeIndex - index);
        if (distance < minDistance) {
          closestSlideIndex = index;
          minDistance = distance;
        }
      }
    });

    // If a match is found, slide to the closest slide
    if (closestSlideIndex !== -1) {
        bootSwiper.slideTo(closestSlideIndex, randomizeCondition || sizeChanging ? 0 : animationSpeed, false);
    }
  }
  // Same logic for bootSwiper32oz
  if(source == '' || source == '25oz'){
    let closestSlideIndex32oz = -1;
    let minDistance32oz = Infinity;

    bootSwiper32oz.slides.forEach((slide, index) => {
      if (slide.getAttribute(attributeName) === attributeValue) {
        const distance = Math.abs(bootSwiper32oz.activeIndex - index);
        if (distance < minDistance32oz) {
          closestSlideIndex32oz = index;
          minDistance32oz = distance;
        }
      }
    });

    if (closestSlideIndex32oz !== -1) {
      bootSwiper32oz.slideTo(closestSlideIndex32oz, randomizeCondition || sizeChanging ? 0 : animationSpeed, false);
    }
  }
  sizeChanging = false;
}

function checkSizeRadioButtonWithValue(value){
  summaryBottleSection.setAttribute('data-filled', 'filled');
  summaryCapSection.setAttribute('data-filled', 'filled');
  summaryLoopSection.setAttribute('data-filled', 'filled');

  bottleSizeRadios.forEach(function(bottle){
    if (bottle.dataset.name == value) {
      bottle.checked = true;
      bottle.dispatchEvent(changeEvent);
    }
  })

  bottleSizeRadiosMobile.forEach(function(bottle){
    if (bottle.dataset.name == value) {
      bottle.checked = true;
      bottle.dispatchEvent(changeEvent);
    }
  })
}

function checkRadioButtonWithValue(value) {
  console.log('checkRadioButtonWithValue', value);

  if(summaryCapSection.getAttribute('data-filled') != 'filled'){
    const capSection = document.querySelector('.summary-content.cap-section');
    capSection.querySelectorAll('.cap-type-options').forEach(section => {
      if (defaultCapType == 'robo') {
        section.querySelectorAll('input[type="radio"]')[1].checked = true;
        section.querySelectorAll('input[type="radio"]')[1].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'pebble'){
        section.querySelectorAll('input[type="radio"]')[0].checked = true;
        section.querySelectorAll('input[type="radio"]')[0].dispatchEvent(changeEvent);
      }
      else if (defaultCapType == 'bubble'){
        section.querySelectorAll('input[type="radio"]')[2].checked = true;
        section.querySelectorAll('input[type="radio"]')[2].dispatchEvent(changeEvent);
      }
    });
  }

  summaryBottleSection.setAttribute('data-filled', 'filled');
  summaryCapSection.setAttribute('data-filled', 'filled');
  summaryLoopSection.setAttribute('data-filled', 'filled');

  // Get all the names of available components
  const bottleRadioNames = Array.from(bottleRadios).map(bottle => bottle.dataset.name);
  const bottleRadioNames32oz = Array.from(bottleRadios32oz).map(bottle => bottle.dataset.name);
  const bottleRadioNames16oz = Array.from(bottleRadios16oz).map(bottle => bottle.dataset.name);
  const bottleRadioNames30oz = Array.from(bottleRadios30oz || []).map(bottle => bottle.dataset.name);
  const capRadioNames = Array.from(capRadios).map(cap => cap.dataset.name);
  const loopRadioNames = Array.from(loopRadios).map(loop => loop.dataset.name);
  const robocapRadioNames = Array.from(robocapRadios).map(robocap => robocap.dataset.name);
  const bubblecapRadioNames = Array.from(bubblecapRadios).map(bubblecap => bubblecap.dataset.name);
  const bandRadioNames = Array.from(bandRadios).map(band => band.dataset.name);
  const connectorRadioNames = Array.from(connectorRadios).map(connector => connector.dataset.name);

  if (bottleRadioNames.includes(value)) {
    bottleRadios.forEach(function (bottle) {
      if (bottle.dataset.name == value) {
        bottle.checked = true;

        if(bottleSizeOption == '25oz')
        bottle.dispatchEvent(changeEvent);
      }
    });
  }
  else {
    if(bottleSizeOption == '25oz'){
      for (const [index, e] of bottleRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          bottleRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }

  if (bottleRadioNames32oz.includes(value)) {
    bottleRadios32oz.forEach(function (bottle) {
      if (bottle.dataset.name == value) {
        bottle.checked = true;
        if(bottleSizeOption == '32oz')
        bottle.dispatchEvent(changeEvent);
      }
    });
  }
  else {
    if(bottleSizeOption == '32oz'){
      for (const [index, e] of bottleRadios32oz.entries()) {
        if (!e.classList.contains('disabled')) {
          bottleRadios32oz[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }

  if (bottleRadioNames16oz.includes(value)) {
    bottleRadios16oz.forEach(function (bottle) {
      if (bottle.dataset.name == value) {
        bottle.checked = true;

        if(bottleSizeOption == '16oz')
        bottle.dispatchEvent(changeEvent);
      }
    });
  }
  else {
    if(bottleSizeOption == '16oz'){
      for (const [index, e] of bottleRadios16oz.entries()) {
        if (!e.classList.contains('disabled')) {
          bottleRadios16oz[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }

  if (bottleRadioNames30oz.includes(value)) {
    bottleRadios30oz.forEach(function (bottle) {
      if (bottle.dataset.name == value) {
        bottle.checked = true;
        if(bottleSizeOption == '30oz')
        bottle.dispatchEvent(changeEvent);
      }
    });
  }
  else {
    if(bottleSizeOption == '30oz' && bottleRadios30oz.length){
      for (const [index, e] of bottleRadios30oz.entries()) {
        if (!e.classList.contains('disabled')) {
          bottleRadios30oz[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }

  if(defaultCapType == 'pebble'){ 
    if (capRadioNames.includes(value)) {
      capRadios.forEach(function (cap) {
        if(value == 'chrome'){
          if (cap.dataset.name == 'chia') {
            cap.checked = true;
            cap.dispatchEvent(changeEvent);
          }
        }
        else{
          if (cap.dataset.name == value) {
            cap.checked = true;
            cap.dispatchEvent(changeEvent);
          }
        }
      });
    }
    else {
      for (const [index, e] of capRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          capRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }

    if (loopRadioNames.includes(value)) {
      loopRadios.forEach(function (loop) {
        if(value == 'chrome'){
          if (loop.dataset.name == 'chia') {
            loop.checked = true;
            loop.dispatchEvent(changeEvent);
          }
        }
        else{
          if (loop.dataset.name == value) {
            loop.checked = true;
            loop.dispatchEvent(changeEvent);
          }
        }
      });
    }
    else {
      for (const [index, e] of loopRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          loopRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }
  else if(defaultCapType == 'bubble'){
    if(bubblecapRadioNames.includes(value)){
      bubblecapRadios.forEach(function (bubblecap) {
        if(bubblecap.dataset.name == value){
          bubblecap.checked = true;
          bubblecap.dispatchEvent(changeEvent);
        }
      });
    }
    if(bandRadioNames.includes(value)){
      bandRadios.forEach(function (band) {
        if(band.dataset.name == value){
          band.checked = true;
          band.dispatchEvent(changeEvent);
        }
      });
    }
    else{
      for (const [index, e] of bubblecapRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          bubblecapRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }
  else{
    if (robocapRadioNames.includes(value)) {
      robocapRadios.forEach(function (cap) {
        if(value == 'chrome'){
          if (cap.dataset.name == 'chia') {
            cap.checked = true;
            cap.dispatchEvent(changeEvent);
          }
        }
        else{
          if (cap.dataset.name == value) {
            cap.checked = true;
            cap.dispatchEvent(changeEvent);
          }
        }
      });
    }
    else {
      for (const [index, e] of robocapRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          robocapRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
    
    if (connectorRadioNames.includes(value)) {
      connectorRadios.forEach(function (connector) {
        if(value == 'chrome'){
          if (connector.dataset.name == 'chia') {
            connector.checked = true;
            connector.dispatchEvent(changeEvent);
          }
        }
        else{
          if (connector.dataset.name == value) {
            connector.checked = true;
            connector.dispatchEvent(changeEvent);
          }
        }
      });
    }
    else {
      for (const [index, e] of connectorRadios.entries()) {
        if (!e.classList.contains('disabled')) {
          connectorRadios[index].dispatchEvent(changeEvent)
          break;
        }
      }
    }
  }
}

let temporaryRandomNumber = 0;
randomize.addEventListener('click', function () {
  randomizeCondition = true;
  const colorMax = randomColors.length;
  const colorMax32oz = bottleRadios32oz.length;
  const colorMax16oz = bottleRadios16oz.length;
  const colorMax30oz = bottleRadios30oz ? bottleRadios30oz.length : 0;

  let randomColorIndex;
  let randomColorIndex32oz;
  let randomColorIndex16oz;
  let randomColorIndex30oz;

  do {
    randomColorIndex = Math.floor(Math.random() * colorMax);
  } while (temporaryRandomNumber === randomColorIndex);

  // Update temporaryRandomNumber with the newly generated randomColorIndex
  temporaryRandomNumber = randomColorIndex;

  animationSpeed = 0;
  const capColor = randomColors[randomColorIndex].cap;
  const loopColor = randomColors[randomColorIndex].loop;
  const bottleColor = randomColors[randomColorIndex].bottle;
  const bootColor = randomColors[randomColorIndex].boot;
  if(bottleSizeOption == '25oz'){

    checkLoop(loopColor);
    checkCap(capColor);
    bootColor ? checkBoot(bootColor) : (withBoot = false, updateBoot(), bootImage.src = '', popupLoopImage.src = '');
    checkBottle(bottleColor);

  } else if(bottleSizeOption == '32oz'){
      checkLoop(loopColor);
      checkCap(capColor);
      bootColor ? checkBoot(bootColor) : (withBoot = false, updateBoot(), bootImage.src = '', popupLoopImage.src = '');
      checkBottle(bottleColor);
  } else if(bottleSizeOption == '16oz'){
      checkLoop(loopColor);
      checkCap(capColor);
      bootColor ? checkBoot(bootColor) : (withBoot = false, updateBoot(), bootImage.src = '', popupLoopImage.src = '');
      checkBottle(bottleColor);
  } else if(bottleSizeOption == '30oz'){
      checkLoop(loopColor);
      checkCap(capColor);
      bootColor ? checkBoot(bootColor) : (withBoot = false, updateBoot(), bootImage.src = '', popupLoopImage.src = '');
      checkBottle(bottleColor);
  }
  
  previewMainImage.forEach(function (element) {
    if (element.classList.contains('active')) {
      element.classList.add('active');
      // setTimeout(function () {
      //   element.classList.remove('active');
      // }, animationSpeed);
    }
  });

  animationSpeed = 300;
  randomizeCondition = false;
});

const priceContainer = document.querySelector('.price-container');
function updatePricing() {

  const capType = document.querySelector('.flask-customization-main').dataset.capType;

  // Individual component prices
  let bottlePrice = 25; // 16oz/25oz
  if (bottleSizeOption == '30oz') {
    bottlePrice = 20; // Lite bottle
  } else if (bottleSizeOption == '32oz') {
    bottlePrice = 30;
  }
  
  let bootPrice = 10; // Default for 16oz/25oz/30oz
  if (bottleSizeOption == '32oz') {
    bootPrice = 12;
  }
  
  let capPrice = 15; // Pebble cap base
  if (capType == 'robo') {
    capPrice = 20; // Includes connector + straw
  }
  
  loopPrice = loopColorType == 'charm' ? 12 : 10;
  
  totalPrice = 0;
  summaryCapSection.dataset.filled != 'filled' ? capBundleVariantID = '' : '';
  loopSection.dataset.filled != 'filled' ? loopBundleVariantID = '' : '';

  // Calculate bundle prices based on spreadsheet
  let bundlePrice = 0;
  let combinedPrice = 0;
  
  // Check if we have a bundle (bottle + cap + loop/accessories)
  if (bottleBundleVariantID.length > 1 && capBundleVariantID.length > 1 && loopBundleVariantID.length > 1) {
    
    // Set base combined prices (original prices before bundle discount)
    if (bottleSizeOption == '16oz') {
      if (capType == 'pebble') {
        bundlePrice = 35; // Bottle + Pebble + Loop
        combinedPrice = loopColorType == 'charm' ? 52 : 50; // Bottle(25) + Cap(15) + Loop(10/12)
      } else if (capType == 'robo') {
        bundlePrice = 45; // Bottle + Robo Bundle
        combinedPrice = 55; // Bottle(25) + Robo(20) + Connector(10) + Straw
      } else if (capType == 'bubble') {
        bundlePrice = 40; // Bottle + Bubble Bundle
        combinedPrice = 50; // Bottle(25) + Bubble(15) + Band(10)
      }
    } else if (bottleSizeOption == '25oz') {
      if (capType == 'pebble') {
        bundlePrice = 35; // Bottle + Pebble + Loop
        combinedPrice = loopColorType == 'charm' ? 52 : 50; // Bottle(25) + Cap(15) + Loop(10/12)
      } else if (capType == 'robo') {
        bundlePrice = 45; // Bottle + Robo Bundle
        combinedPrice = 55; // Bottle(25) + Robo(20) + Connector(10) + Straw
      } else if (capType == 'bubble') {
        bundlePrice = 40; // Bottle + Bubble Bundle
        combinedPrice = 50; // Bottle(25) + Bubble(15) + Band(10)
      }
    } else if (bottleSizeOption == '30oz') {
      if (capType == 'pebble') {
        bundlePrice = 30; // Lite Bottle + Pebble + Loop
        combinedPrice = loopColorType == 'charm' ? 47 : 45; // Bottle(20) + Cap(15) + Loop(10/12)
      } else if (capType == 'robo') {
        bundlePrice = 40; // Lite Bottle + Robo Bundle
        combinedPrice = 50; // Bottle(20) + Robo(20) + Connector(10) + Straw
      } else if (capType == 'bubble') {
        bundlePrice = 35; // Lite Bottle + Bubble Bundle
        combinedPrice = 45; // Bottle(20) + Bubble(15) + Band(10)
      }
    } else if (bottleSizeOption == '32oz') {
      if (capType == 'pebble') {
        bundlePrice = 40; // Bottle + Pebble + Loop
        combinedPrice = loopColorType == 'charm' ? 57 : 55; // Bottle(30) + Cap(15) + Loop(10/12)
      } else if (capType == 'robo') {
        bundlePrice = 50; // Bottle + Robo Bundle
        combinedPrice = 60; // Bottle(30) + Robo(20) + Connector(10) + Straw
      } else if (capType == 'bubble') {
        bundlePrice = 45; // Bottle + Bubble Bundle
        combinedPrice = 55; // Bottle(30) + Bubble(15) + Band(10)
      }
    }
    
    // Add glider upgrade if active (adds $5 to combined price, not $8)
    if (gliderActive && capType == 'robo') {
      combinedPrice += 5; // Glider upgrade adds $5 to combined price
      bundlePrice += gliderPrice; // Add actual glider price to bundle
    }
    
    // Add boot to pricing
    if (bootVariantID.length > 1) {
      combinedPrice += bootPrice; // Add boot to combined price
      
      // Bundle prices with boot from spreadsheet
      if (bottleSizeOption == '16oz' || bottleSizeOption == '25oz') {
        if (capType == 'pebble') {
          bundlePrice = 45;
        } else if (capType == 'robo') {
          bundlePrice = gliderActive ? 60 : 55; // With glider: 60, without: 55
        } else if (capType == 'bubble') {
          bundlePrice = 50; // Bottle + Bubble + Boot
        }
      } else if (bottleSizeOption == '30oz') {
        if (capType == 'pebble') {
          bundlePrice = 40;
        } else if (capType == 'robo') {
          bundlePrice = gliderActive ? 55 : 50; // With glider: 55, without: 50
        } else if (capType == 'bubble') {
          bundlePrice = 45; // Bottle + Bubble + Boot
        }
      } else if (bottleSizeOption == '32oz') {
        if (capType == 'pebble') {
          bundlePrice = 52;
        } else if (capType == 'robo') {
          bundlePrice = gliderActive ? 67 : 62; // With glider: 67, without: 62
        } else if (capType == 'bubble') {
          bundlePrice = 57; // Bottle + Bubble + Boot
        }
      }
    }
    
    // Only show bundle pricing if we have a loop (for pebble) or if robo/bubble
    if (loopBundleVariantID.length > 1 || capType == 'robo' || capType == 'bubble') {
      totalPriceText.innerText = '$' + bundlePrice.toLocaleString();
      originalPriceText.innerText = '$' + combinedPrice.toLocaleString();
      priceContainer.classList.add('bundle');
    } else {
      // No bundle, calculate individual prices
      totalPrice = bottlePrice + capPrice;
      if (bootVariantID.length > 1) totalPrice += bootPrice;
      if (gliderActive && capType == 'robo') totalPrice += gliderPrice;
      totalPriceText.innerText = '$' + totalPrice.toLocaleString();
      originalPriceText.innerText = '';
      priceContainer.classList.remove('bundle');
    }
  }
  else {
    // No bundle - add individual component prices
    if (bottleBundleVariantID.length > 1) totalPrice += bottlePrice;
    if (capBundleVariantID.length > 1) totalPrice += capPrice;
    if (loopBundleVariantID.length > 1) totalPrice += loopPrice;
    if (bootVariantID.length > 1) totalPrice += bootPrice;
    if (gliderActive && capType == 'robo' && capBundleVariantID.length > 1) {
      totalPrice += gliderPrice;
    }
    totalPriceText.innerText = '$' + totalPrice.toLocaleString();
    originalPriceText.innerText = '';
    priceContainer.classList.remove('bundle');
  }
  if(bottleBundleVariantID.length > 1){
    if(loopBundleVariantID.length > 1 || capBundleVariantID.length > 1 || bootVariantID.length > 1){
      priceContainer.classList.add('bottle-plus');
      priceContainer.classList.remove('bottle');
}
    else{
      priceContainer.classList.remove('bottle-plus');
      priceContainer.classList.add('bottle');
    }
  }
  else{
    priceContainer.classList.remove('bottle','bottle-plus');
  }


  if(capBundleVariantID.length > 1) {
    if(capType == 'robo') {
      priceContainer.classList.add('cap-plus');
      priceContainer.classList.remove('cap');
      
      if(gliderActive) {
        priceContainer.classList.remove('straw', 'straw-plus');
        
        if(loopBundleVariantID.length > 1 || bootVariantID.length > 1) {
          priceContainer.classList.add('glider-plus');
          priceContainer.classList.remove('glider');
        } else {
          priceContainer.classList.remove('glider-plus');
          priceContainer.classList.add('glider');
        }
      } else {
        priceContainer.classList.remove('glider', 'glider-plus');
        
        if(loopBundleVariantID.length > 1 || bootVariantID.length > 1) {
          priceContainer.classList.add('straw-plus');
          priceContainer.classList.remove('straw');
        } else {
          priceContainer.classList.remove('straw-plus');
          priceContainer.classList.add('straw');
        }
      }
    } else {
      if(loopBundleVariantID.length > 1 || bootVariantID.length > 1) {
        priceContainer.classList.add('cap-plus');
        priceContainer.classList.remove('cap');
      } else {
        priceContainer.classList.remove('cap-plus');
        priceContainer.classList.add('cap');
      }
      
      priceContainer.classList.remove('straw', 'straw-plus', 'glider', 'glider-plus');
    }
  } else {
    priceContainer.classList.remove('cap', 'cap-plus', 'straw', 'straw-plus', 'glider', 'glider-plus');
  }

  if(loopBundleVariantID.length > 1){
    const looptext = document.querySelector('.price-text.price-text--loop');
    loopColorType == 'charm' ? looptext.innerText = 'Charm Loop' : looptext.innerText = 'Loop'
    if(bootVariantID.length > 1){
      priceContainer.classList.add('loop-plus');
      priceContainer.classList.remove('loop');
    }
    else{
      priceContainer.classList.remove('loop-plus');
      priceContainer.classList.add('loop');
    }
  }
  else{
    priceContainer.classList.remove('loop','loop-plus');
  }

  if(bootVariantID.length > 1){
    priceContainer.classList.add('boot');
  }
  else{
    priceContainer.classList.remove('boot');
  }
}

if (capTypeValue.length > 0 && sizeExists || capExists || loopExists || bottleExists || bootExists) {
    showCustomizer(true);
    animationSpeed = 0;

    document.addEventListener('DOMContentLoaded', function () {
      initSwipers();
      setTimeout(function () {
        randomizeCondition = true;
        bottleSizeOption = sizeValue;
        document.querySelectorAll('cap-type-options').forEach(function(option){
          
          const radioInput = option.querySelector(`input[type="radio"][data-name="${capTypeValue}"]`);
          
          if (radioInput) {
            const customChangeEvent = new Event('change', {
              bubbles: true,
              cancelable: true
            });
            
            radioInput.checked = true;
            const dispatched = radioInput.dispatchEvent(customChangeEvent);
          }
        });
  
        capValue.length > 1 ? checkCap(capValue) : '';
        loopValue.length > 1 ? checkLoop(loopValue) : '';
        if (bottleValue.length > 1 || (sizeExists && bottleValue.length < 1)) {
          setTimeout(function(){
              checkBottle(bottleValue);
          }, 500);
          
        }
        if(bootValue.length > 1){
          setTimeout(function(){
            checkBoot(bootValue);
          }, 500);
        }
        
        if(sizeValue == '25oz') {
          document.querySelector('#product-price').innerText = '$35';
          bottlePreview.classList.add('active');
          bottlePreview.dataset.filled = 'filled';
  
          if(withBoot ){
            // bootRadios[0].dispatchEvent(changeEvent);
          }
          updatePricing();
          checkSizeRadioButtonWithValue('25oz');
          document.querySelector('.preview-main').classList.remove('animation');
          changeSize(bottleSizeHolder);
          oosModal.classList.remove('show');
        }
        else if(sizeValue == '16oz'){
  
          document.querySelector('#product-price').innerText = '#35';
          bottlePreview.classList.remove('active');
          bottlePreview16oz.classList.add('active');
          bottlePreview16oz.dataset.filled = 'filled';
  
          if(withBoot ){
            // bootRadios[0].dispatchEvent(changeEvent);
          }
          updatePricing();
          checkSizeRadioButtonWithValue('16oz');
          document.querySelector('.preview-main').classList.remove('animation');
          changeSize(bottleSizeHolder);
          oosModal.classList.remove('show');
        }
        else if(sizeValue == '30oz'){
          document.querySelector('#product-price').innerText = '$25';
          bottlePreview30oz.classList.add('active');
          bottlePreview30oz.dataset.filled = 'filled';

          updatePricing();
          checkSizeRadioButtonWithValue('30oz');
          document.querySelector('.preview-main').classList.remove('animation');
          changeSize(bottleSizeHolder);
          oosModal.classList.remove('show');
        }
        else if(sizeValue == '32oz'){
          document.querySelector('#product-price').innerText = '$40';
          bottlePreview.classList.remove('active');
          bottlePreview32oz.classList.add('active');
          bottlePreview32oz.dataset.filled = 'filled';
  
          updatePricing();
          checkSizeRadioButtonWithValue('32oz');
          document.querySelector('.preview-main').classList.remove('animation');
          changeSize(bottleSizeHolder);
          oosModal.classList.remove('show');
        }
        randomizeCondition = false;
        animationSpeed = 300;
      }, 0);
    }); 
}
if (sourceExists) {
  showCustomizer(true);;
  document.querySelector('body').classList.remove('hide');
}


function checkCap(value) {
  summaryCapSection.setAttribute('data-filled', 'filled');
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  if(capType == 'robo'){
    robocapRadios.forEach(function (connector) {
      if (connector.dataset.name == value) {
        connector.checked = true;
        connector.dispatchEvent(changeEvent);
      }
    });
    robocapRadiosMobile.forEach(function (connector) {
      if (connector.dataset.name == value) {
        connector.checked = true;
        connector.dispatchEvent(changeEvent);
      }
    });
  }
  else if(capType == 'bubble'){
    bubblecapRadios.forEach(function (bubblecap) {
      if (bubblecap.dataset.name == value) {
        bubblecap.checked = true;
        bubblecap.dispatchEvent(changeEvent);
      }
    });
    bubblecapRadiosMobile.forEach(function (bubblecap) {
      if (bubblecap.dataset.name == value) {
        bubblecap.checked = true;
        bubblecap.dispatchEvent(changeEvent);
      }
    });
  }
  else{
    capRadios.forEach(function (cap) {
      if (cap.dataset.name == value) {
        cap.checked = true;
        cap.dispatchEvent(changeEvent);
      }
    });
    capRadiosMobile.forEach(function (cap) {
      if (cap.dataset.name == value) {
        cap.checked = true;
      }
    });
  }
}

function checkLoop(value) {
  summaryLoopSection.setAttribute('data-filled', 'filled');
  // withLoop = true;
  summaryLoopSection.setAttribute('data-loop', 'with');
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  // updateLoop();
  if(capType == 'robo'){
    connectorRadios.forEach(function (connector) {
      if (connector.dataset.name == value) {
        connector.checked = true;
        connector.dispatchEvent(changeEvent);
      }
    });
    connectorRadiosMobile.forEach(function (connectorm) {
      if (connectorm.dataset.name == value) {
        connectorm.checked = true;
        connectorm.dispatchEvent(changeEvent);
      }
    });
  }
  else if(capType == 'bubble'){
    bandRadios.forEach(function (band) {
      if (band.dataset.name == value) {
        band.checked = true;
        band.dispatchEvent(changeEvent);
      }
    });
    bandRadiosMobile.forEach(function (band) {
      if (band.dataset.name == value) {
        band.checked = true;
        band.dispatchEvent(changeEvent);
      }
    });
  }
  else{
    loopRadios.forEach(function (loop) {
      if (loop.dataset.name == value) {
        loop.checked = true;
        loop.dispatchEvent(changeEvent);
      }
    });
    loopRadiosMobile.forEach(function (loopm) {
      if (loopm.dataset.name == value) {
        loopm.checked = true;
        loopm.dispatchEvent(changeEvent);
      }
    });
  }
  
}
function checkBottle(value) {
  // Prevent recursive calls
  if (isCheckingBottle) {
    // return;
  }
  
  isCheckingBottle = true;
  randomizeCondition = true;
  summaryBottleSection.setAttribute('data-filled', 'filled');

  let foundAvailable = false;
  let firstAvailable = null;
  let targetRadios = [];
  let targetMobileRadios = [];

  // Determine which radio sets to check based on bottle size
  if (bottleSizeOption == '25oz') {
    targetRadios = [bottleRadios, bottleRadios32oz, bottleRadios16oz];
    targetMobileRadios = [bottleRadiosMobile, bottleRadiosMobile32oz, bottleRadiosMobile16oz];
  } else if (bottleSizeOption == '32oz') {
    targetRadios = [bottleRadios32oz, bottleRadios, bottleRadios16oz];
    targetMobileRadios = [bottleRadiosMobile32oz, bottleRadiosMobile, bottleRadiosMobile16oz];
  } else if (bottleSizeOption == '16oz') {
    targetRadios = [bottleRadios16oz, bottleRadios, bottleRadios32oz];
    targetMobileRadios = [bottleRadiosMobile16oz, bottleRadiosMobile, bottleRadiosMobile32oz];
  } else if (bottleSizeOption == '30oz') {
    targetRadios = [bottleRadios30oz, bottleRadios, bottleRadios32oz];
    targetMobileRadios = [bottleRadiosMobile30oz, bottleRadiosMobile, bottleRadiosMobile32oz];
  }

  // First pass: find first available radio and check if selected one is available
  targetRadios[0].forEach(element => {
    if (!element.classList.contains('disabled') && !firstAvailable) {
      firstAvailable = element;
    }
    if (element.dataset.name === value) {
      if (element.classList.contains('disabled')) {
        foundAvailable = false;
      } else {
        foundAvailable = true;
      }
    }
  });

  // If selected bottle is disabled, use first available
  if (!foundAvailable && firstAvailable) {
    value = firstAvailable.dataset.name;
  }

  // Set the radio buttons
  targetRadios.forEach(radioSet => {
    radioSet.forEach(bottle => {
      if (bottle.dataset.name === value) {
        bottle.checked = true;
        if (radioSet === targetRadios[0] && !isDispatchingEvents) {
          isDispatchingEvents = true;
          try {
            bottle.dispatchEvent(changeEvent);
          } finally {
            isDispatchingEvents = false;
          }
        }
      }
    });
  });

  targetMobileRadios.forEach(radioSet => {
    radioSet.forEach(bottle => {
      if (bottle.dataset.name === value) {
        bottle.checked = true;
      }
    });
  });
  randomizeCondition = false;
  isCheckingBottle = false;
}
function checkBoot(value) {
  summaryBootSection.setAttribute('data-filled', 'filled');
  summaryBootSection.setAttribute('data-boot', 'with');
  withBoot = true;
  bootChoices.querySelector('#add_boot').classList.add('active');
  bootChoicesMobile.querySelector('#add_boot').classList.add('active');
  bootChoices.querySelector('#no_boot').classList.remove('active');
  bootChoicesMobile.querySelector('#no_boot').classList.remove('active');
  updateBoot();

  // Define radio sets for optimization based on bottle size
  let targetRadios = [];
  let targetMobileRadios = [];

  if (bottleSizeOption === '16oz' || bottleSizeOption === '25oz' || bottleSizeOption === '30oz') {
    targetRadios = [bootRadios];
    targetMobileRadios = [bootRadiosMobile];
  } else {
    targetRadios = [bootRadios32oz, bootRadios];
    targetMobileRadios = [bootRadiosMobile32oz, bootRadiosMobile];
  }

  // Set the radio buttons
  targetRadios.forEach(radioSet => {
    radioSet.forEach(bottle => {
      if (bottle.dataset.name === value) {
        bottle.checked = true;
        if (radioSet === targetRadios[0] && !isDispatchingEvents) {
          isDispatchingEvents = true;
          try {
            bottle.dispatchEvent(changeEvent);
          } finally {
            isDispatchingEvents = false;
          }
        }
      }
    });
  });

  targetMobileRadios.forEach(radioSet => {
    radioSet.forEach(bottle => {
      if (bottle.dataset.name === value) {
        bottle.checked = true;
      }
    });
  });
  
  summaryBottleSection.click();
}


function reset() {
  randomizeCondition = true;
  animationSpeed = 0;

  const bottleBool = bottleBundleVariantID.length > 1;
  const capBool = capBundleVariantID.length > 1;
  const loopBool = loopBundleVariantID.length > 1;
  const bootBool = bootVariantID.length > 1;

  popupCheckout.classList.remove('show');

  bottleRadios[0].checked = true
  bottleRadios[0].dispatchEvent(changeEvent);
  bottleRadios32oz[0].checked = true
  bottleRadios32oz[0].dispatchEvent(changeEvent);
  bottleRadios16oz[0].checked = true;
  bottleRadios16oz[0].dispatchEvent(changeEvent);
  if (bottleRadios30oz.length) {
    bottleRadios30oz[0].checked = true;
    bottleRadios30oz[0].dispatchEvent(changeEvent);
  }

  loopRadios[0].checked = true
  loopRadios[0].dispatchEvent(changeEvent);
  connectorRadios[0].checked = true;
  connectorRadios[0].dispatchEvent(changeEvent);
  bandRadios[0].checked = true;
  bandRadios[0].dispatchEvent(changeEvent);

  capRadios[0].checked = true
  capRadios[0].dispatchEvent(changeEvent);
  robocapRadios[0].checked = true
  robocapRadios[0].dispatchEvent(changeEvent);
  bubblecapRadios[0].checked = true
  bubblecapRadios[0].dispatchEvent(changeEvent);

  withBoot = false;
  bootVariantID = '';
  engravingInput.value = '';
  engravingInputMobile.value = '';
  popupEngravingText.innerText = '';
  engravingValue = '';
  document.querySelector('.bottle-hover span').innerText = '';

  bottleBool ? '' : (bottleBundleVariantID = '', popupBottleImage.src = '');
  capBool ? '' : (capBundleVariantID = '', popupCapImage.src = '');
  loopBool ? '' : (loopBundleVariantID = '', popupLoopImage.src = '', withLoop = true);
  bootBool ? '' : (bootVariantID = '', popupBootImage.src = '', withBoot = false);
  // if (!loopBool) {
  //   [...loopChoices.children].forEach(function (element) {
  //     element.classList.remove('active');
  //     element.id == 'no_loop' ? element.classList.add('active') : ''
  //   });
  // }
  // if (!loopBool) {
  //   [...loopChoicesMobile.children].forEach(function (element) {
  //     element.classList.remove('active');
  //     element.id == 'no_loop' ? element.classList.add('active') : ''
  //   });
  // }

  if (!bootBool) {
    [...bootChoices.children].forEach(function (element) {
      element.classList.remove('active');
      element.id == 'no_boot' ? element.classList.add('active') : ''
    });
  }
  if (!bootBool) {
    [...bootChoicesMobile.children].forEach(function (element) {
      element.classList.remove('active');
      element.id == 'no_boot' ? element.classList.add('active') : ''
    });
  }



  updateBoot();
  // updateLoop();

  // summaryBootSection.dataset.filled = "empty";
  // summaryLoopSection.dataset.filled = "empty";
  // summaryCapSection.dataset.filled = "empty";

  summaryBottleSection.click();
  document.querySelector('#bottle-tab').checked = true;
  document.querySelector('#bottle-tab').dispatchEvent(changeEvent);
  summaryEngravingSection.dataset.filled = 'empty';
  
  updateCTA();

  customizationMain.classList.remove('loading-icon');
  //   const css = document.querySelector('#flaskCustomizerCSS').innerHTML;
  //   document.querySelector('#flaskCustomizerCSS').remove();
  //   const cssel = document.createElement('style');
  //   cssel.id = 'flaskCustomizerCSS';
  //   cssel.innerHTML = css;
  // setTimeout(function(){
  //   document.head.append(cssel);}, 10)
  
  
  randomizeCondition = false;
  animationSpeed = 300;
}

const isWindowSizeGreaterThan899 = window.innerWidth > 899;
// component clicks
document.querySelector('.bottle-hover').addEventListener('click', function () {
  summaryBottleSection.click();
  summaryBottleSectionMobile.classList.add('active');
  document.querySelector('#bottle-tab').checked = true;
  document.querySelector('#bottle-tab').dispatchEvent(changeEvent);
})
document.querySelector('.cap-hover').addEventListener('click', function () {
  summaryCapSection.click();
  summaryCapSectionMobile.classList.add('active');
  document.querySelector('#cap-tab').checked = true;
  document.querySelector('#cap-tab').dispatchEvent(changeEvent);
})
document.querySelector('.loop-hover').addEventListener('click', function () {
  summaryLoopSection.click();
  summaryLoopSectionMobile.classList.add('active');
  document.querySelector('#loop-tab').checked = true;
  document.querySelector('#loop-tab').dispatchEvent(changeEvent);
})
document.querySelector('.boot-hover').addEventListener('click', function () {
  if(withBoot){
    summaryBootSection.click();
    summaryBootSectionMobile.classList.add('active');
    document.querySelector('#boot-tab').checked = true;
    document.querySelector('#boot-tab').dispatchEvent(changeEvent);
  }
})


// onboarding functions
const onboardingNext = document.querySelectorAll('.ocf--next');
const onboardingBack = document.querySelectorAll('.ocf--back');


// onboardingNext.forEach(function (obn) {
//   obn.addEventListener('click', function (e) {
//     onBoardingNextSlide(e.target.dataset.step);
//   });
// });
// onboardingBack.forEach(function (obn) {
//   obn.addEventListener('click', function (e) {
//   });
// });

function onBoardingNextSlide(param) {
  const step = parseInt(param) + 1;
  const slide = document.querySelector(`.onboarding_content.onboarding--step-${step}`);
  document.querySelectorAll('.onboarding_content').forEach(function (oc) { oc.classList.remove('active') })
  stopOnboardingVideo();

  param != '4' ? (slide.classList.add('active'), slide.querySelector('.ocm--video').play()) : ((document.querySelector('.onboarding-section').classList.add('closed')), setTimeout(function(){closeOnboarding()}, 100), localStorage.setItem('flaskOnboarding', 'hide'));
}

function onBoardingPreviousSlide(param) {
  const step = parseInt(param) - 1;
  const slide = document.querySelector(`.onboarding_content.onboarding--step-${step}`);
  document.querySelectorAll('.onboarding_content').forEach(function (oc) { oc.classList.remove('active') })
  stopOnboardingVideo();

  param != '1' ? (slide.classList.add('active'), slide.querySelector('.ocm--video').play()) : ((document.querySelector('.onboarding-section').classList.add('closed')), setTimeout(function(){closeOnboarding()}, 100), localStorage.setItem('flaskOnboarding', 'hide'));
}

function stopOnboardingVideo() {
  document.querySelectorAll('.ocm--video').forEach(function (vid) { vid.pause() })
}


function isLight(color) {
  // Convert the color to RGB
  let rgb = hexToRgb(color);

  // Calculate the perceived brightness using the formula
  let brightness = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;

  // Return true if the brightness is greater than 128 (considered light)
  return brightness > 128;
}

// Function to convert hex color to RGB
function hexToRgb(hex) {
  // Remove the hash if present
  hex = hex.replace(/^#/, '');

  // Parse the hex value into RGB
  let bigint = parseInt(hex, 16);
  let r = (bigint >> 16) & 255;
  let g = (bigint >> 8) & 255;
  let b = bigint & 255;

  // Return an object with RGB values
  return { r, g, b };
}

// Function to set text color based on background color
function checkColor(hex) {

  const eColor = isLight(hex) ? 'dark' : 'light';
  // Set the text color
  // previewEngraving.setAttribute('data-text_color', eColor);
  // popupEngraving.setAttribute('data-text_color', eColor);
  // engravingColor = eColor;
}


// custom swipe mobile functionality
let touchStartX = 0;
let touchMoveX = 0;
let touchStartY = 0;
let touchStartTime = 0;
const maxSwipeTime = 300; // 0.3 seconds in milliseconds

swipeElement.addEventListener('touchstart', handleTouchStart);
swipeElement.addEventListener('touchmove', handleTouchMove);

function handleTouchStart(event) {
  touchStartX = event.touches[0].clientX;
  touchStartY = event.touches[0].clientY;
  touchStartTime = new Date().getTime(); // record the start time of the touch
}

function handleTouchMove(event) {
  const currentTime = new Date().getTime();
  const elapsedTime = currentTime - touchStartTime;

  // If the swipe takes longer than 0.3s, stop handling it
  if (elapsedTime > maxSwipeTime) return;

  touchMoveX = event.touches[0].clientX;
  const touchMoveY = event.touches[0].clientY;
  let deltaX = touchMoveX - touchStartX;
  let deltaY = touchMoveY - touchStartY;

  // Only trigger swipe if horizontal movement is significant (more than 20px)
  // and horizontal movement is greater than vertical movement
  if (Math.abs(deltaX) > 20 && Math.abs(deltaX) > Math.abs(deltaY)) {
    if (deltaX > 0) {
      // Move to the right
      document.querySelector('#bottle-preview-25oz.bottle-preview.active') ? bottleSwiper.slidePrev() : '';
      document.querySelector('#bottle-preview-16oz.bottle-preview.active') ? bottleSwiper16oz.slidePrev() : '';
      document.querySelector('#bottle-preview-32oz.bottle-preview.active') ? bottleSwiper32oz.slidePrev() : '';
      document.querySelector('#bottle-preview-30oz.bottle-preview.active') ? bottleSwiper30oz.slidePrev() : '';
      document.querySelector('.cap-preview.active[data-size-category="25oz"]') ? capSwiper.slidePrev() : '';
      document.querySelector('.cap-preview.active[data-size-category="32oz"]') ? capSwiper32oz.slidePrev() : '';
      document.querySelector('.cap-preview.active[data-size-category="16oz"]') ? capSwiper16oz.slidePrev() : '';
      document.querySelector('.cap-preview.active[data-size-category="30oz"]') ? capSwiper30oz.slidePrev() : '';
      document.querySelector('.robocap-preview.active[data-size-category="25oz"]') ? robocapSwiper.slidePrev() : '';
      document.querySelector('.robocap-preview.active[data-size-category="32oz"]') ? robocapSwiper32oz.slidePrev() : '';
      document.querySelector('.robocap-preview.active[data-size-category="16oz"]') ? robocapSwiper16oz.slidePrev() : '';
      document.querySelector('.robocap-preview.active[data-size-category="30oz"]') ? robocapSwiper30oz.slidePrev() : '';
      document.querySelector('.bubblecap-preview.active[data-size-category="25oz"]') ? bubblecapSwiper.slidePrev() : '';
      document.querySelector('.bubblecap-preview.active[data-size-category="32oz"]') ? bubblecapSwiper32oz.slidePrev() : '';
      document.querySelector('.bubblecap-preview.active[data-size-category="16oz"]') ? bubblecapSwiper16oz.slidePrev() : '';
      document.querySelector('.bubblecap-preview.active[data-size-category="30oz"]') ? bubblecapSwiper30oz.slidePrev() : '';
      document.querySelector('.loop-preview.active[data-size-category="25oz"]') ? loopSwiper.slidePrev() : '';
      document.querySelector('.loop-preview.active[data-size-category="32oz"]') ? loopSwiper32oz.slidePrev() : '';
      document.querySelector('.loop-preview.active[data-size-category="16oz"]') ? loopSwiper16oz.slidePrev() : '';
      document.querySelector('.loop-preview.active[data-size-category="30oz"]') ? loopSwiper30oz.slidePrev() : '';
      document.querySelector('.band-preview.active[data-size-category="25oz"]') ? bandSwiper.slidePrev() : '';
      document.querySelector('.band-preview.active[data-size-category="32oz"]') ? bandSwiper32oz.slidePrev() : '';
      document.querySelector('.band-preview.active[data-size-category="16oz"]') ? bandSwiper16oz.slidePrev() : '';
      document.querySelector('.band-preview.active[data-size-category="30oz"]') ? bandSwiper30oz.slidePrev() : '';
      document.querySelector('.connector-preview.active[data-size-category="25oz"]') ? connectorSwiper.slidePrev() : '';
      document.querySelector('.connector-preview.active[data-size-category="32oz"]') ? connectorSwiper32oz.slidePrev() : '';
      document.querySelector('.connector-preview.active[data-size-category="16oz"]') ? connectorSwiper16oz.slidePrev() : '';
      document.querySelector('.connector-preview.active[data-size-category="30oz"]') ? connectorSwiper30oz.slidePrev() : '';
      document.querySelector('#boot-preview-25oz.boot-preview.active') ? bootSwiper.slidePrev() : '';
      document.querySelector('#boot-preview-32oz.boot-preview.active') ? bootSwiper32oz.slidePrev() : '';
    } else if (deltaX < 0) {
      // Move to the left
      document.querySelector('#bottle-preview-16oz.bottle-preview.active') ? bottleSwiper16oz.slideNext() : '';
      document.querySelector('#bottle-preview-25oz.bottle-preview.active') ? bottleSwiper.slideNext() : '';
      document.querySelector('#bottle-preview-32oz.bottle-preview.active') ? bottleSwiper32oz.slideNext() : '';
      document.querySelector('#bottle-preview-30oz.bottle-preview.active') ? bottleSwiper30oz.slideNext() : '';
      document.querySelector('.cap-preview.active[data-size-category="25oz"]') ? capSwiper.slideNext() : '';
      document.querySelector('.cap-preview.active[data-size-category="32oz"]') ? capSwiper32oz.slideNext() : '';
      document.querySelector('.cap-preview.active[data-size-category="16oz"]') ? capSwiper16oz.slideNext() : '';
      document.querySelector('.cap-preview.active[data-size-category="30oz"]') ? capSwiper30oz.slideNext() : '';
      document.querySelector('.robocap-preview.active[data-size-category="25oz"]') ? robocapSwiper.slideNext() : '';
      document.querySelector('.robocap-preview.active[data-size-category="32oz"]') ? robocapSwiper32oz.slideNext() : '';
      document.querySelector('.robocap-preview.active[data-size-category="16oz"]') ? robocapSwiper16oz.slideNext() : '';
      document.querySelector('.robocap-preview.active[data-size-category="30oz"]') ? robocapSwiper30oz.slideNext() : '';
      document.querySelector('.bubblecap-preview.active[data-size-category="25oz"]') ? bubblecapSwiper.slideNext() : '';
      document.querySelector('.bubblecap-preview.active[data-size-category="32oz"]') ? bubblecapSwiper32oz.slideNext() : '';
      document.querySelector('.bubblecap-preview.active[data-size-category="16oz"]') ? bubblecapSwiper16oz.slideNext() : '';
      document.querySelector('.bubblecap-preview.active[data-size-category="30oz"]') ? bubblecapSwiper30oz.slideNext() : '';
      document.querySelector('.loop-preview.active[data-size-category="25oz"]') ? loopSwiper.slideNext() : '';
      document.querySelector('.loop-preview.active[data-size-category="32oz"]') ? loopSwiper32oz.slideNext() : '';
      document.querySelector('.loop-preview.active[data-size-category="16oz"]') ? loopSwiper16oz.slideNext() : '';
      document.querySelector('.loop-preview.active[data-size-category="30oz"]') ? loopSwiper30oz.slideNext() : '';
      document.querySelector('.connector-preview.active[data-size-category="25oz"]') ? connectorSwiper.slideNext() : '';
      document.querySelector('.connector-preview.active[data-size-category="32oz"]') ? connectorSwiper32oz.slideNext() : '';
      document.querySelector('.connector-preview.active[data-size-category="16oz"]') ? connectorSwiper16oz.slideNext() : '';
      document.querySelector('.connector-preview.active[data-size-category="30oz"]') ? connectorSwiper30oz.slideNext() : '';
      document.querySelector('.band-preview.active[data-size-category="25oz"]') ? bandSwiper.slideNext() : '';
      document.querySelector('.band-preview.active[data-size-category="32oz"]') ? bandSwiper32oz.slideNext() : '';
      document.querySelector('.band-preview.active[data-size-category="16oz"]') ? bandSwiper16oz.slideNext() : '';
      document.querySelector('.band-preview.active[data-size-category="30oz"]') ? bandSwiper30oz.slideNext() : '';
      document.querySelector('#boot-preview-25oz.boot-preview.active') ? bootSwiper.slideNext() : '';
      document.querySelector('#boot-preview-32oz.boot-preview.active') ? bootSwiper32oz.slideNext() : '';
    }
  }

  touchStartX = touchMoveX;
  touchStartY = touchMoveY;
}


// functions to check if component is available
function checkBottleAvailability(params) {
  if (params.classList.contains('disabled')) {
    bottleBundleVariantID = '';
    bottleIndividualVariantID = '';
    bottleIsAvailable = false;
    summaryBottleSection.classList.add('unavailable');
    summaryBottleSectionMobile.classList.add('unavailable');
    document.querySelector('[for="bottle-tab"').classList.add('unavailable');
  } else {
    bottleIsAvailable = true;
    summaryBottleSection.classList.remove('unavailable');
    summaryBottleSectionMobile.classList.remove('unavailable');
    document.querySelector('[for="bottle-tab"').classList.remove('unavailable');
  }
  updateCTA();
}
function checkCapAvailability(params) {
  if (params.classList.contains('disabled')) {
    capBundleVariantID = '';
    capIndividualVariantID = '';
    capIsAvailable = false;
    summaryCapSection.classList.add('unavailable', 'unavailable--pebble');
    summaryCapSectionMobile.classList.add('unavailable', 'unavailable--pebble');
    document.querySelector('[for="cap-tab"').classList.add('unavailable', 'unavailable--pebble');
  } else {
    capIsAvailable = true;
    summaryCapSection.classList.remove('unavailable', 'unavailable--pebble', 'unavailable--robo');
    summaryCapSectionMobile.classList.remove('unavailable', 'unavailable--pebble', 'unavailable--robo');
    document.querySelector('[for="cap-tab"').classList.remove('unavailable', 'unavailable--pebble', 'unavailable--robo');
  }
  updateCTA();
}

function checkroboCapAvailability(params) {
  if (params.classList.contains('disabled')) {
    capBundleVariantID = '';
    capIndividualVariantID = '';
    capIsAvailable = false;
    summaryCapSection.classList.add('unavailable', 'unavailable--robo');
    summaryCapSectionMobile.classList.add('unavailable', 'unavailable--robo');
    document.querySelector('[for="cap-tab"').classList.add('unavailable', 'unavailable--robo');
  } else {
    capIsAvailable = true;
    summaryCapSection.classList.remove('unavailable', 'unavailable--robo', 'unavailable--pebble');
    summaryCapSectionMobile.classList.remove('unavailable', 'unavailable--robo', 'unavailable--pebble');
    document.querySelector('[for="cap-tab"').classList.remove('unavailable', 'unavailable--robo', 'unavailable--pebble');
  }
  updateCTA();
}

function checkBubbleAvailability(params) {
  if (params.classList.contains('disabled')) {
    capBundleVariantID = '';
    capIndividualVariantID = '';
    capIsAvailable = false;
    summaryCapSection.classList.add('unavailable', 'unavailable--bubble');
    summaryCapSectionMobile.classList.add('unavailable', 'unavailable--bubble');
    document.querySelector('[for="cap-tab"').classList.add('unavailable', 'unavailable--bubble');
  } else {
    capIsAvailable = true;
    summaryCapSection.classList.remove('unavailable', 'unavailable--bubble', 'unavailable--pebble');
    summaryCapSectionMobile.classList.remove('unavailable', 'unavailable--bubble', 'unavailable--pebble');
    document.querySelector('[for="cap-tab"').classList.remove('unavailable', 'unavailable--bubble', 'unavailable--pebble');
  }
  updateCTA();
}

function checkBandAvailability(params) {
  if (params.classList.contains('disabled')) {
    loopBundleVariantID = '';
    loopIndividualVariantID = '';
    loopIsAvailable = false;
    summaryLoopSection.classList.add('unavailable', 'unavailable--band');
    summaryLoopSectionMobile.classList.add('unavailable', 'unavailable--band');
    document.querySelector('[for="loop-tab"').classList.add('unavailable', 'unavailable--band');
  } else {
    loopIsAvailable = true;
    summaryLoopSection.classList.remove('unavailable', 'unavailable--band', 'unavailable--loop');
    summaryLoopSectionMobile.classList.remove('unavailable', 'unavailable--band', 'unavailable--loop');
    document.querySelector('[for="loop-tab"').classList.remove('unavailable', 'unavailable--band', 'unavailable--loop');
  }
  updateCTA();
}
function checkLoopAvailability(params) {
  if (params.classList.contains('disabled')) {
    loopBundleVariantID = '';
    loopIndividualVariantID = '';
    loopIsAvailable = false;
    summaryLoopSection.classList.add('unavailable');
    summaryLoopSectionMobile.classList.add('unavailable');
    document.querySelector('[for="loop-tab"').classList.add('unavailable');
  } else {
    loopIsAvailable = true;
    summaryLoopSection.classList.remove('unavailable');
    summaryLoopSectionMobile.classList.remove('unavailable');
    document.querySelector('[for="loop-tab"').classList.remove('unavailable');
  }
  updateCTA();
}

function checkConnectorAvailability(params) {
  if (params.classList.contains('disabled')) {
    loopBundleVariantID = '';
    loopIndividualVariantID = '';
    loopIsAvailable = false;
    summaryLoopSection.classList.add('unavailable');
    summaryLoopSectionMobile.classList.add('unavailable');
    document.querySelector('[for="loop-tab"').classList.add('unavailable');
  } else {
    loopIsAvailable = true;
    summaryLoopSection.classList.remove('unavailable');
    summaryLoopSectionMobile.classList.remove('unavailable');
    document.querySelector('[for="loop-tab"').classList.remove('unavailable');
  }
  updateCTA();
}
function checkBootAvailability(params) {
  if (params.classList.contains('disabled')) {
    bootVariantID = '';
    bootIsAvailable = false;
    summaryBootSection.classList.add('unavailable');
    summaryBootSectionMobile.classList.add('unavailable');
    document.querySelector('[for="boot-tab"').classList.add('unavailable');
  } else {
    bootIsAvailable = true;
    summaryBootSection.classList.remove('unavailable');
    summaryBootSectionMobile.classList.remove('unavailable');
    document.querySelector('[for="boot-tab"').classList.remove('unavailable');
  }
  updateCTA();
}

function updateCTA() {
  // if(window.innerWidth > 900){
  //   if (bottleIsAvailable && bootIsAvailable && loopIsAvailable && capIsAvailable && engravingIsValid) {
  //     addToBag.removeAttribute('disabled');
  //   }
  //   else {
  //     addToBag.setAttribute('disabled', '');
  //   }
  // }
  // else{
    if (bottleIsAvailable && bootIsAvailable && loopIsAvailable && capIsAvailable && engravingIsValid) {
      addToBag.classList.remove('disabled');
    }
    else {
      addToBag.classList.add('disabled');
    }
  // }
}


document.querySelector('.onboarding_modal--container').classList.add('active');
document.addEventListener('DOMContentLoaded', function () {
  pageLoaded = true;
  if (sourceExists || !document.querySelector('.onboarding-section').classList.contains('hidden')) {
    setTimeout(() => {
      document.querySelector('.onboarding--step-1.active .ocm--video').play();
      sourceExists = false;
    }, 1000);
  }
})

async function fetchFlaskDetails(url) {
  const fullUrl = url /*+ '&section_id=' + section*/;

  fetch(fullUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      return response.text(); // assuming the response is in text format
    })
    .then((data) => {
      // const sectionElement = document.querySelector(`#shopify-section-${section} form`);

      updateFlaskGallery(data);
      initializeVTOGallerySwiper();
    })
    .catch((error) => {
      console.error('Fetch error:', error);
    });
}

function updateFlaskGallery(data) {
  const productGallery = document.querySelectorAll('.product-gallery-swipper');
  const doc = parser.parseFromString(data, 'text/html');
  const newProductGallery = doc.querySelectorAll('.product-gallery-swipper');
  productGallery.forEach((element, index) => {
    element.replaceWith(newProductGallery[index]);
  })

  const productVTOContainer = document.querySelector('.desktop-product-vto-container');
  const newproductVTOContainer = doc.querySelector('.desktop-product-vto-container');
  productVTOContainer.replaceWith(newproductVTOContainer);

  document.querySelector('#product-gallery-container').setAttribute('data-product-sku', doc.querySelector('#product-gallery-container').getAttribute('data-product-sku'));
  try {
    loadGallerySwiper();
  } catch (error) {

  }

}


popupButtonEdit.forEach(function (button) {
  button.addEventListener('click', function (event) {
    popupCheckout.classList.remove('show');
  })
})


// disable emoji input in engraving

const allowedEmoji = ['♡','☻','✿','☆','⟡','☾','🐾','☯','🜲','𖤓','ᯓ','★','ꕤ','❆','•','ᴗ','♫','0','1','2','3','4','5','6','7','8','9'];
let emojies = '';

engravingInput.addEventListener('input', function(e){
  checkEmoji(engravingValue);
});

engravingInputMobile.addEventListener('input', function(e){
  checkEmoji(engravingValue);
});

function disableEmojiInput(event) {
  const isEmoji = isEmojiCharacter(event.key);

  if (isEmoji) {
      event.preventDefault();
  }
}
function checkEmoji(param){
  emojies = '';
  let invalidEmojiCounter = 0;
  const characters = Array.from(param);

  characters.forEach(character => {
      if(isEmojiCharacter(character)){
        invalidEmojiCounter++;
        emojies = emojies + character;
      }
  });
  updateEmoji(invalidEmojiCounter);
}

function updateEmoji(param){
  if(param > 0){
    document.querySelectorAll('.emoji-error').forEach(er => { er.style.display = 'flex' });
    document.querySelector('.summary-mobile #emoji-characters').innerText = emojies
    document.querySelector('.summary-desktop #emoji-characters').innerText = emojies 
    engravingIsValid = false;
  }
  else{
    document.querySelectorAll('.emoji-error').forEach(er => { er.style.display = 'none' });
    engravingIsValid = true;
  }
  updateCTA();
}

function isEmojiCharacter(char) {
  const emojiPattern = /^[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]+$/u;
  // emojiPattern.test(char) && !allowedEmoji.includes(char) ? emojies = emojies + char : '';
  return emojiPattern.test(char) && !allowedEmoji.includes(char);
}

let modifiedInput = '';
document.querySelectorAll('.button-emoji').forEach(emoji => {
    emoji.addEventListener('click', function (e) {

      if(engravingInput.value.length <= 14 || engravingInputMobile.value.length <= 14){
        // Updated by Ruent:  replace paw print emoji by actual svg to fix color issue
        const pawSVG = `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="white" stroke="white" style="width: 12px; height: 12px;"><path d="M18.137 21.824c-5.645 1.549-9.088 7.132-8.092 10.944c.998 3.813 4.766-.53 10.411-2.08c5.643-1.551 11.024.281 10.028-3.532c-.997-3.813-6.702-6.883-12.347-5.332" fill="white"></path><path d="M13.768 20.047c1.701-.632 1.918-4.417 1.012-6.969c-.906-2.55-3.02-4.103-4.721-3.469c-1.7.635-2.344 3.217-1.438 5.767c.906 2.551 3.445 5.306 5.147 4.671" fill="white"></path><path d="M20.708 18.078c1.803-.162 2.967-3.759 2.736-6.465c-.23-2.704-1.879-4.763-3.682-4.604c-1.803.163-3.079 2.486-2.848 5.19c.232 2.704 1.989 6.041 3.794 5.879" fill="white"></path><path d="M28.678 10.164c-1.809 0-3.275 2.2-3.275 4.914c0 2.716 1.467 6.195 3.275 6.195c1.81 0 3.276-3.479 3.276-6.195c.001-2.715-1.466-4.914-3.276-4.914" fill="white"></path><path d="M3.318 17.127c-1.568.926-1.766 3.584-.439 5.936c1.324 2.35 4.293 4.612 5.86 3.685c1.568-.927 1.141-4.693-.184-7.043c-1.325-2.352-3.671-3.505-5.237-2.578" fill="white"></path><path d="M45.865 44.529c-5.645-1.551-11.352 1.52-12.348 5.332c-.998 3.813 4.385 1.981 10.029 3.532c5.645 1.55 9.412 5.893 10.408 2.08c.998-3.812-2.446-9.394-8.089-10.944" fill="white"></path><path d="M50.234 42.755c1.699.632 4.24-2.123 5.146-4.674c.906-2.551.262-5.133-1.438-5.767c-1.701-.635-3.813.919-4.719 3.47s-.69 6.336 1.011 6.971" fill="white"></path><path d="M43.295 40.782c1.803.162 3.561-3.174 3.791-5.878s-1.043-5.028-2.846-5.19c-1.803-.16-3.451 1.9-3.684 4.605c-.23 2.705.936 6.301 2.739 6.463" fill="white"></path><path d="M35.322 43.978c1.811 0 3.277-3.479 3.277-6.195c0-2.714-1.467-4.914-3.277-4.914s-3.277 2.2-3.277 4.916c0 2.714 1.469 6.193 3.277 6.193" fill="white"></path><path d="M60.683 39.832c-1.568-.927-3.912.226-5.236 2.577c-1.323 2.351-1.751 6.117-.186 7.044c1.568.927 4.537-1.335 5.861-3.685c1.324-2.351 1.127-5.009-.439-5.936" fill="white"></path></svg>`;
        var newValue = engravingValue + emoji.value;
        
        // Update the input value
        engravingInput.value = engravingInput.value + emoji.value;
        engravingInputMobile.value = engravingInputMobile.value + emoji.value;
        engravingInput.dispatchEvent(new Event('input'));
        engravingInputMobile.dispatchEvent(new Event('input'));
        engravingValue = newValue;
        previewEngravingText.innerHTML = newValue.replace(/🐾/g, pawSVG);
        popupEngravingText.innerHTML = newValue.replace(/🐾/g, pawSVG);
      }else{
        e.preventDefault();
      }
    });
});

buttonFont.forEach(btn => {
  btn.addEventListener('click', function (e) {
    buttonFont.forEach(e => e.classList.remove('active'));
    btn.classList.add('active');
    engravingInput.style.fontFamily = btn.value;
    engravingInputMobile.style.fontFamily = btn.value;
    previewEngraving.style.fontFamily = btn.value;
    popupEngravingText.style.fontFamily = btn.value;
    engravingFont = btn.value;

      engravingInput.dispatchEvent(new Event('input'));
      engravingInputMobile.dispatchEvent(new Event('input'));

      if(btn.closest('.summary-mobile')){
        updateEngraving(engravingInputMobile.value, 'mobile', e);
      }
      if(btn.closest('.summary-desktop')){
        updateEngraving(engravingInput.value, 'desktop', e);
      }
    // update font size
    popupEngravingText.style.fontSize = btn.dataset.fontSize;
    previewEngravingText.style.fontSize = btn.dataset.fontSize;
  })
})

// scroll down on mobile swipe if component is out of stock
function scrollDownIfOOS(element){
  element == true ? setTimeout(() => {customizationMain.scrollTop = +999999;}, 200) : customizationMain.scrollTop = -999999;
        
}

// flask tooltip
document.querySelector('.flask-tooltip').addEventListener('click', function(e){
  document.querySelector('.flask-customization-main .price-container').classList.toggle('show-tooltip');
})

customizationMain.addEventListener('click', e => {
  if(!e.target.closest('.flask-tooltip')){
    document.querySelector('.flask-customization-main .price-container').classList.remove('show-tooltip');
  }
})
customizerLoaded = true;


function scrollSummarySectionDown(){
  const summary_section = document.querySelector('.summary-section');

  // Ensure the element exists
  if (summary_section) {
    // Scroll the element down by a specific amount (e.g., 100 pixels)
    summary_section.scrollBy({
      top: 100, // Amount to scroll down
      behavior: 'smooth', // Smooth scrolling effect
    });

    // Or scroll to the bottom of the element
    summary_section.scrollTo({
      top: summary_section.scrollHeight, // Scroll to the maximum height
      behavior: 'smooth', // Smooth scrolling effect
    });
  } else {
    console.error('Element not found!');
  }

}

class CapTypeOptions extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', function(e){
      customizationMain.dataset.capType = e.target.dataset.name;


      loopImage.style.opacity = 0;
      loopImage.style.transition = '0';
      if(e.target.dataset.name == 'robo'){
        document.querySelector(`.robocap-preview[data-size-category='${bottleSizeOption}']`).classList.add('active');
        document.querySelectorAll(`.cap-preview`).forEach(e => e.classList.remove('active'));
        document.querySelectorAll(`.bubblecap-preview`).forEach(e => e.classList.remove('active'));
        this.selectedCap = document.querySelector('.robocap_component_radio:checked');
        if (!this.selectedCap) {
          this.selectedCap = document.querySelector('.robocap_component_radio');
          if (this.selectedCap) {
            this.selectedCap.checked = true;
            this.selectedCap.dispatchEvent(new Event('change'));
          }
        }
        this.selectedCap.classList.contains('disabled') ? (summaryCapSection.classList.add('unavailable--robo'), summaryCapSectionMobile.classList.add('unavailable--robo')) : (summaryCapSection.classList.remove('unavailable--robo'), summaryCapSectionMobile.classList.remove('unavailable--robo'));
        
        this.selectedLoop = document.querySelector('.connector_component_radio:checked');
        if (!this.selectedLoop) {
          this.selectedLoop = document.querySelector('.connector_component_radio');
          if (this.selectedLoop) {
            this.selectedLoop.checked = true;
            this.selectedLoop.dispatchEvent(new Event('change'));
          }
        }
        this.capType = e.target.dataset.name;
        summaryCapSection.classList.remove('unavailable--pebble');
        summaryCapSectionMobile.classList.remove('unavailable--pebble');
        summaryCapSection.classList.remove('unavailable--bubble');
        summaryCapSectionMobile.classList.remove('unavailable--bubble');
      }
      else if(e.target.dataset.name == 'bubble'){
        document.querySelector(`.bubblecap-preview[data-size-category='${bottleSizeOption}']`).classList.add('active');
        document.querySelectorAll(`.cap-preview`).forEach(e => e.classList.remove('active'));
        document.querySelectorAll(`.robocap-preview`).forEach(e => e.classList.remove('active'));
        this.selectedCap = document.querySelector('.bubblecap_component_radio:checked');
        if (!this.selectedCap) {
          this.selectedCap = document.querySelector('.bubblecap_component_radio');
          if (this.selectedCap) {
            this.selectedCap.checked = true;
            this.selectedCap.dispatchEvent(new Event('change'));
          }
        }
        this.selectedCap.classList.contains('disabled') ? (summaryCapSection.classList.add('unavailable--bubble'), summaryCapSectionMobile.classList.add('unavailable--bubble')) : (summaryCapSection.classList.remove('unavailable--bubble'), summaryCapSectionMobile.classList.remove('unavailable--bubble'));
        
        this.selectedLoop = document.querySelector('.band_component_radio:checked');
        if (!this.selectedLoop) {
          this.selectedLoop = document.querySelector('.band_component_radio');
          if (this.selectedLoop) {
            this.selectedLoop.checked = true;
            this.selectedLoop.dispatchEvent(new Event('change'));
          }
        }
        this.capType = e.target.dataset.name;
        summaryCapSection.classList.remove('unavailable--pebble');
        summaryCapSectionMobile.classList.remove('unavailable--pebble');
        summaryCapSection.classList.remove('unavailable--robo');
        summaryCapSectionMobile.classList.remove('unavailable--robo');
      }
      else{
        document.querySelectorAll(`.robocap-preview`).forEach(e => e.classList.remove('active'));
        document.querySelectorAll(`.bubblecap-preview`).forEach(e => e.classList.remove('active'));
        document.querySelector(`.cap-preview[data-size-category='${bottleSizeOption}']`).classList.add('active');
        
        this.selectedCap = document.querySelector('.cap_component_radio:checked');
        if (!this.selectedCap) {
          this.selectedCap = document.querySelector('.cap_component_radio');
          if (this.selectedCap) {
            this.selectedCap.checked = true;
            this.selectedCap.dispatchEvent(new Event('change'));
          }
        }
        
        this.selectedLoop = document.querySelector('.loop_component_radio:checked');
        if (!this.selectedLoop) {
          this.selectedLoop = document.querySelector('.loop_component_radio');
          if (this.selectedLoop) {
            this.selectedLoop.checked = true;
            this.selectedLoop.dispatchEvent(new Event('change'));
          }
        }
        this.selectedCap.classList.contains('disabled') ? (summaryCapSection.classList.add('unavailable--pebble'), summaryCapSectionMobile.classList.add('unavailable--pebble')) : (summaryCapSection.classList.remove('unavailable--pebble'), summaryCapSectionMobile.classList.remove('unavailable--pebble'));
        this.capType = e.target.dataset.name;
        summaryCapSection.classList.remove('unavailable--robo');
        summaryCapSectionMobile.classList.remove('unavailable--robo');
        summaryCapSection.classList.remove('unavailable--bubble');
        summaryCapSectionMobile.classList.remove('unavailable--bubble');
      }

      this.capImage = bottleSizeOption == '25oz' ? this.selectedCap.dataset.image : this.selectedCap.dataset[`image_${bottleSizeOption}`];
      this.loopImage = bottleSizeOption == '25oz' ? this.selectedLoop.dataset.image : this.selectedLoop.dataset[`image_${bottleSizeOption}`];
      this.variantID = this.selectedCap.classList.contains('disabled') ? '' : this.selectedCap.dataset.variant_id;
      this.loopVariantID = this.selectedLoop.classList.contains('disabled') ? '' : this.selectedLoop.dataset.variant_id;
      this.updateCapType(this.capImage, this.variantID, this.capType, this.loopImage, this.loopVariantID);
      customizationMain.dataset.capType = e.target.dataset.name;
      this.checkCTA();
      updatePricing();
    });
  }

  checkCTA(){
    capIsAvailable = this.selectedCap.classList.contains('disabled') ? false : true;
    loopIsAvailable = this.selectedLoop.classList.contains('disabled') ? false : true;
    loopIsAvailable ? '' : loopBundleVariantID = '';
    updateCTA();
  }
  updateCapType(capimage, id, type, loopimage, loopid){
    popupCapImage.src = capimage;
    capImage.src = capimage;
    capBundleVariantID = id;
    popupLoopImage.src = loopimage;
    loopBundleVariantID = loopid;
    document.querySelector('#cap-type-text').innerText = type;
    setTimeout(() => {
      loopImage.src = loopimage;
      loopImage.style.transition = 'opacity 0.1s linear';
      loopImage.style.opacity = 1;
    }, 500);
  }
}

// Register the custom element
customElements.define("cap-type-options", CapTypeOptions);

function getCapType(){
  const capType = document.querySelector('.flask-customization-main').dataset.capType;
  return capType;
}

function showCustomizer(sourceExists){
  customizationMain.classList.add('show');

  if(!sourceExists){
    randomizeCondition = true
    bootShowPreview(clickFromMainRadios);
    capShowPreview(clickFromMainRadios);
    loopShowPreview(clickFromMainRadios);
    if(clickFromMainRadios == false){
      checkCap(mainRadios[0].dataset.color);
      checkLoop(mainRadios[0].dataset.color);
      checkBottle(mainRadios[0].dataset.color);
    }
      randomizeCondition = false;
      bottleShowPreview();
  }
  clickFromMainRadios = false;
}

// Glider Upgrade [Ron]
document.querySelectorAll('.robocap--upgrade-glider').forEach(function (glider) {
  const gliderAction = glider.querySelector('.upgrade-glider-action');
  const popupGliderMobile = document.querySelector('.popup-glider-wrapper-mobile');

  if (gliderAction) {
    gliderAction.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_398_3965)"><path d="M8.00431 5.0705V8.0045M8.00431 8.0045V10.9385M8.00431 8.0045H10.9383M8.00431 8.0045H5.07031" stroke="#352B27" stroke-linecap="round" /><path d="M8.00492 15.3382C12.0559 15.3382 15.3399 12.0542 15.3399 8.00315C15.3399 3.95214 12.0559 0.668152 8.00492 0.668152C3.95391 0.668152 0.669922 3.95214 0.669922 8.00315C0.669922 12.0542 3.95391 15.3382 8.00492 15.3382Z" stroke="#352B27" /></g><defs><clipPath id="clip0_398_3965"><rect width="16" height="16" fill="white" /></clipPath></defs></svg>';
  }
  
  glider.addEventListener('click', function (e) {
    if(glider.getAttribute('disabled') == 'true' || glider.getAttribute('data-stock-quantity') == 0){
      return;
    }
    e.preventDefault(); 
    glider.classList.toggle('active');
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.target.classList.contains('active')) {
          popupGliderMobile.style.display = 'none';
        } else {
          popupGliderMobile.style.display = 'block';
        }
      });
    });

    observer.observe(glider, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Set initial state
    popupGliderMobile.style.display = glider.classList.contains('active') ? 'none' : 'block';
    gliderActive = glider.classList.contains('active');
  
    if (gliderActive) {
      gliderAction.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99996 0.666687C3.94996 0.666687 0.666626 3.95002 0.666626 8.00002C0.666626 12.05 3.94996 15.3334 7.99996 15.3334C12.05 15.3334 15.3333 12.05 15.3333 8.00002C15.3333 3.95002 12.05 0.666687 7.99996 0.666687ZM11.1786 6.76002C11.2372 6.69312 11.2817 6.61518 11.3097 6.5308C11.3377 6.44642 11.3485 6.3573 11.3415 6.26868C11.3345 6.18006 11.3099 6.09373 11.269 6.01477C11.2282 5.93582 11.1719 5.86582 11.1037 5.80892C11.0354 5.75201 10.9564 5.70933 10.8714 5.6834C10.7863 5.65746 10.697 5.6488 10.6085 5.65791C10.5201 5.66702 10.4344 5.69372 10.3565 5.73644C10.2785 5.77917 10.2099 5.83705 10.1546 5.90669L7.28796 9.34602L5.80463 7.86202C5.67889 7.74058 5.51049 7.67339 5.33569 7.6749C5.16089 7.67642 4.99369 7.74654 4.87008 7.87014C4.74648 7.99375 4.67636 8.16096 4.67484 8.33575C4.67332 8.51055 4.74052 8.67895 4.86196 8.80469L6.86196 10.8047C6.92746 10.8702 7.00589 10.9213 7.09224 10.9547C7.17858 10.9882 7.27096 11.0033 7.36347 10.9991C7.45599 10.9949 7.54661 10.9715 7.62957 10.9303C7.71252 10.8892 7.78599 10.8312 7.84529 10.76L11.1786 6.76002Z" fill="white"/></svg>';
    } else {
      gliderVariantID = '';
      gliderAction.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_398_3965)"><path d="M8.00431 5.0705V8.0045M8.00431 8.0045V10.9385M8.00431 8.0045H10.9383M8.00431 8.0045H5.07031" stroke="#352B27" stroke-linecap="round" /><path d="M8.00492 15.3382C12.0559 15.3382 15.3399 12.0542 15.3399 8.00315C15.3399 3.95214 12.0559 0.668152 8.00492 0.668152C3.95391 0.668152 0.669922 3.95214 0.669922 8.00315C0.669922 12.0542 3.95391 15.3382 8.00492 15.3382Z" stroke="#352B27" /></g><defs><clipPath id="clip0_398_3965"><rect width="16" height="16" fill="white" /></clipPath></defs></svg>';
    }
    updatePricing();
  });
});

function checkAnimalObservatoryColor(element){
  if(element.dataset.colorType == 'animal' && element.dataset.animalObservatoryColor.length > 0){
    customizationMain.classList.add('animal-observatory-color');
    document.querySelectorAll('.flask-animal-border').forEach(e => e.style.background = element.dataset.animalObservatoryColor);
  }
  else{
    customizationMain.classList.remove('animal-observatory-color');
  }
}